/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-const */
/* eslint-disable no-duplicate-case */
// This is the main RdSAP component, it includes all the tabs.

import { Component, Inject, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild, inject, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CreateRdSAPSurveyModalComponent } from '../../modals/components/create-rdsap-survey/create-rdsap-survey.component';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ChangeDetectorRef, HostListener } from '@angular/core';
import { HeaderComponent } from '../../shared/components/header/header.component'; 
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { forEach, filter, isEqual, cloneDeep, orderBy } from 'lodash';
import { PcdbDataSelectorComponent } from '../pcdb-data-selector/pcdb-data-selector.component';
import { MeasurementWindowsModalComponent } from '../../modals/components/ee-openings-measurement-windows/ee-openings-measurement-windows.component';
import { EEBDMainBuildingRoofExtendedDataModalComponent } from '../../modals/components/eebd-main-building-roof-extended-data/eebd-main-building-roof-extended-data-modal.component';
import { EerrSolarWaterHeatingDetailsModalComponent } from '../../modals/components/eerr-solar-water-heating-details/eerr-solar-water-heating-details-modal.component';
import { RdSAPDimensionDetailsModalComponent } from '../../modals/components/rdsap-dimension-details/rdsap-dimension-details-modal.component';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { environment } from './../../../environments/environment';
import { Observable, of } from 'rxjs';
import { AvailableInputTypeV0 } from '../../models/rdsap/availableInputTypeV0';
import { AGGREGATED_DATA_SERVICE_TOKEN, IAggregatedDataService } from '../../models/data/aggregated-data.interface';
import { RdSAPLookupCodeDtoV0 } from '../../models/rdsap/rdSAPLookupCodeDtoV0';
import { RatingColorClasses, RatingColorService, RatingDetails } from '../../services/rating/rating.service';
import { RdSAPDataSetDtoV0 } from '../../models/rdsap/rdSAPDataSetDtoV0';
import { PVConfigurationV0, RdSAPAssessmentReportMimeTypes, RdSAPBuildingPartUIDTOV0, RdSAPGeneralDetailUIDTOV0, RdSAPHeatingUIDTOV0, RdSAPOpeningDetailUIDTOV0, RdSAPRenewablesRecoveryUIDTOV0, ReportStatus} from 'src/rdsap-api';
import { RdSAPAssessmentReportUIDTOV0 } from '../../../rdsap-api/model/rdSAPAssessmentReportUIDTOV0';
import { RdSAPResultsDetailUIDTOV0 } from '../../../rdsap-api/model/rdSAPResultsDetailUIDTOV0';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShowerProfileDetailsComponent } from '../../modals/components/shower-profile-details/shower-profile-details.component';
import { UtilsService } from '../../services/utils/utils.service';
import { HealthCheckService } from '../../services/health/health-check.service';
import { AssessmentReportsService } from '../../../rdsap-api';
import { ToastService } from '../../services/toast/toast.service';
import { CustomCookieService } from '../../services/configuration/cookies.service';
import { Location } from '@angular/common';
import { rdsapPCDBData } from '../../config/rdsap-pcdb-data.config';
import { PcdfSearchManualService } from 'src/rdsap/services/pcdf/pcdf-search-manual.service';
import { HighlightRequiredDirective } from '../../directives/highlight-required.directive';

const MAIN_SYSTEM_AND_DHW_ONLY = '1 Main system + 1 DHW only';

@Component({
  selector: 'app-rdsap',
  templateUrl: './rdsap.component.html',
  styleUrls: ['./rdsap.component.scss'],
  providers: [RatingColorService],
})

export class RdsapComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  // Mobile navigation
  isSidebarOpen: boolean = false;
  @ViewChild('standardTpl', { static: true }) standardTpl!: TemplateRef<any>;
  @ViewChild('successTpl', { static: true }) successTpl!: TemplateRef<any>;
  @ViewChild('dangerTpl', { static: true }) dangerTpl!: TemplateRef<any>;
  @ViewChildren(HighlightRequiredDirective)


  highlightDirectives: QueryList<HighlightRequiredDirective>;
  private modalService = inject(NgbModal);
  isEdit = true;
  hasAccess = true;
  isEditVisible = true;
  form: FormGroup;
  constructionAgeList: any[] = [];
  eeRRLookupCodes: any;
  keyedLookUpCodes: any;
  swhConfigurations: any;
  keyedSWHConfigurations: any;
  pvConfigurationsOptions: any;
  keyedPVConfigurationsOptions: any;
  wallsInsulationTypes: any;
  roofInsulationTypes: any;
  roofInsulationThicknesses: any;
  wallsInsulationTypesNoCavity: any;
  roofRoomsInsulationThicknesses: any;
  roofRoomsInsulationThicknessesWithoutNotApplicable: any;
  communityHeatingFuelCodes: any;
  mainSystem1CommunityHeating: boolean;
  pcdbSelectorHeatingTypes: any;
  loading = false;
  cylinderDetailsDeclaredHeatLossSelected = false;
  previousEPCCheckDisabled: string;
  forInformationOnly: any;
  isDisabled = false;
  assetEE: any = {};
  eeStatusDetails: any = {};
  eeGeneralDetails: RdSAPGeneralDetailUIDTOV0 = {address: null};
  pvBatteryCapacity = 0;
  eeGenericDetails: any = {};
  windTurbinesDetailsKnown: boolean;
  eeRRPropertyTypes: any[] = [];
  glazingTypes: any[] = [];
  selectedDataSet: any = {};
  showAdditionalWall: any = {};
  showAdditionalWall2: any = {};
  showRoofRoom: any = {};
  isSaved = false;
  successMessage = '';
  standardMessage = '';
  errorMessage = '';
  roofInsulationTypesByBuildingPart: any;
  roofInsulationThicknessesByBuildingPart: any;
  roofRoomsInsulationThicknessesByBuildingPart: any;
  heatingMainSystemCategoriesBySystem: any;
  heatingMainSystemCategoriesByFuel: any;
  heatingFuelsBySystem: any;
  heatingSystemTypesBySystem: any;
  heatingFlueTypesBySystem: any;
  heatingControlsBySystem: any;
  renewablesOrientationsByArray: any;
  secondaryHeating = false;
  secondaryHeatingFuels: any[] = [];
  secoundaryHeatingSystems: any[] = [];
  waterHeatingTypes: any[] = [];
  waterHeatingFuels: any[] = [];
  immersionTypes: any[] = [];
  primarySystemTypes: any[] = [];
  renewablesSwhOrientations: any[] = [];
  modifiedBackgroundClass = 'green-200-bg';
  selectedRdSapRatingInfo = [
    {
      description: 'EE Current',
      color: 'bg-grey',
      icon: 'assessment',
      rating: '0',
    },
    {
      description: 'EE Potential',
      color: 'bg-grey',
      icon: 'assessment',
      rating: '0',
    },
    {
      description: 'EI Current',
      color: 'bg-grey',
      icon: 'assessment',
      rating: '0',
    },
    {
      description: 'EI Potential',
      color: 'bg-grey',
      icon: 'assessment',
      rating: '0',
    },
  ];
  activeRdSapRatingInfo: any[] = [...this.selectedRdSapRatingInfo];
  showBuildingExtensions = {
    extension1: false,
    extension2: false,
    extension3: false,
    extension4: false,
  };
  private readonly MAIN_SYSTEM_AND_DHW_ONLY = '1 Main system + 1 DHW only';
  heatingMainSystems = [
    '1 Main system',
    '2 Main systems',
    this.MAIN_SYSTEM_AND_DHW_ONLY,
    'None installed',
  ];
  flueGasHeatRecoveryOptions = [
    'None',
    'Main system 1 only',
    'Main system 2 only',
    'Main systems 1 and 2',
  ];
  wasteWaterHeatRecoveryOptions = [
    'None',
    'Instantaneous (1 system)',
    'Instantaneous (2 systems)',
    'Storage',
  ];
  displayedColumns: string[] = [
    'date',
    'type',
    'eeRating',
    'addedBy',
    'active',
    'actions',
  ];
  displayedRecommendationColumns: string[] = [
    'recommendation',
    'description',
    'cost',
    'saving',
    'rating',
  ];
  rdSAPdataSets: any[] = [];
  activeDataset: RdSAPAssessmentReportUIDTOV0;
  resultMain1: any[] = [];
  resultMain2: any[] = [];
  hhrshsystem: string;
  mainSystem1StorageHeaters: any = {};
  mainSystem2StorageHeaters: any = {};
  hasAnActiveDataSet = false;
  detailsForActiveDataSet: any = {};
  eeStatusDetailsForActiveDataSet: any = {};
  eeGeneralDetailsForActiveDataSet: any = {};
  eeOpeningDetailsForActiveDataSet: any = {};
  eeHeatingForActiveDataSet: any = {};
  eeRRForActiveDataSet: any = {};
  eeBDMainBuildingForActiveDataSet: any = {};
  eeBDEx1ForActiveDataSet: any = {};
  eeBDEx2ForActiveDataSet: any = {};
  eeBDEx3ForActiveDataSet: any = {};
  eeBDEx4ForActiveDataSet: any = {};
  propertyAddress: any;
  heatedBasement = false;
  details: any;
  eeRecommendations: any;
  selectedTabIndex: number | null = 1;
  clickedTabs: boolean[] = [];
  tabDetails: string[] = [
    'Results',
    'General',
    'Openings',
    'Main Building',
    'Extension 1',
    'Extension 2',
    'Extension 3',
    'Extension 4',
    'Heating',
    'Water heating',
    'Renewables',
    'Recovery',
  ];
  private countryCodeSubject = new BehaviorSubject<string>('ENG'); // Default country code
  private glazingTypesSubject = new BehaviorSubject<any[]>([]);
  private subscriptions = new Subscription();
  saving: boolean;
  _lookUpCodesByDataItem: any;
  private _eeBDMainBuilding: RdSAPBuildingPartUIDTOV0 = {
    buildingPartAge: '',
  };
  private _eeBDEx1: RdSAPBuildingPartUIDTOV0;
  private _eeBDEx2: RdSAPBuildingPartUIDTOV0;
  private _eeBDEx4: RdSAPBuildingPartUIDTOV0;
  private _eeBDEx3: RdSAPBuildingPartUIDTOV0;
  private _eeOpeningDetails: RdSAPOpeningDetailUIDTOV0 = {
    draughtProofing: 0,
    externalDoors: 0,
    insulatedExternalDoors: 0,
    doorsUValue: 0,
    ventilationType: '',
    fixedAirConditioning: false,
    coverage: '',
    multiGlazing: 0,
    glazingType: '',
    glazingGap: '',
    UValue: 0,
    GValue: 0,
    windowTransmissionDataSource: '',
    sapWindows: [],
  };
  inputTypes$: Observable<AvailableInputTypeV0[]>;
  rdSAPLookUpCodes$: Observable<RdSAPLookupCodeDtoV0[]>;
  rdSAPDataSets$: Observable<RdSAPDataSetDtoV0[]>;
  rdSAPDetails$: Observable<RdSAPAssessmentReportUIDTOV0[]>;
  addressId: string;
  reportReferenceNumber: string;
  pvNumberOfBatteries = [0, 1, 2, 3, 4];
  isHealthy$: Observable<boolean> = of(true);
  addresstest$: Observable<any>;
  showVentilationTab = false;
  heatLossBuilding: number;
  eeGeneric: any;
  sapSpecialFeatures: any;
  mainSystems: string;
  solarWaterHeaterDetailsKnown: boolean;
  solarWaterHeaterCollectorDetailsKnown: boolean;
  solarWaterHeatersecoundaryHeatLossCoefficient: null;
  solarWaterHeaterStoreVolumeDetailsKnown: boolean;
  combinedCylinder: boolean;
  wasteWaterHeatRecovery: string;
  saveEditMessage: string;
  buildingParts: { name: string; id: number }[];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private ratingColorService: RatingColorService,
    private utilsService: UtilsService,
    @Inject(AGGREGATED_DATA_SERVICE_TOKEN)
    private aggregatedDataService: IAggregatedDataService,
    private healthCheckService: HealthCheckService,
    private assessmentService: AssessmentReportsService,
    private toastService: ToastService,
    private router: Router,
    private cookieService: CustomCookieService,
    private location: Location,
    private pcdbSearchManualServiceMain: PcdfSearchManualService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.subscriptions.add(this.setupGlazingTypesFiltering());
    this.aggregatedDataService.loadRdSAPLookUpCodes();
    this.rdSAPLookUpCodes$ = this.aggregatedDataService.rdSAPLookUpCodes$;
    this.aggregatedDataService.loadInputTypes();
    this.inputTypes$ = this.aggregatedDataService.inputTypes$;
  }

  ngOnInit() {
    const storedHeatLoss = sessionStorage.getItem('heatLossBuilding');
    if (storedHeatLoss !== null) {
      this.eeGeneralDetails.heatLossBuilding = Number(storedHeatLoss);
    }
    const savedClickedTabs = sessionStorage.getItem('clickedTabs');
    this.clickedTabs = savedClickedTabs ? JSON.parse(savedClickedTabs) : new Array(this.tabDetails.length).fill(false);
    this.setInitialTabAsClicked();
    this.initializeComponent();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isSidebarOpen) {
      this.closeSidebar();
      console.log("close sidebar func triggered")
    }
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  ngAfterViewInit() {
    this.validateFields();
    this.changeDetector.detectChanges();
  }

  private initializeComponent() {
    this.initializeTabDetails();
    this.isEdit = this.route.snapshot.queryParamMap.get('edit') === 'true' ? true : this.isEdit;
    this.route.params.pipe(
      distinctUntilChanged((prev, curr) => prev['id'] === curr['id']),
        switchMap((params) => {
          this.addressId = params['addressId'];
          this.reportReferenceNumber = params['reportReferenceNumber'];
          this.rdSAPLookUpCodes$ = this.aggregatedDataService.rdSAPLookUpCodes$;
          this.aggregatedDataService.loadRdSAPDetailsForAsset({
            quid: 'QUID202904',
            reportReferenceNumber: this.reportReferenceNumber,
            accept: environment.accept as RdSAPAssessmentReportMimeTypes,
          });
          this.rdSAPDetails$ = this.aggregatedDataService.rdSAPDetails$;
          return of(true);
        })
      ).subscribe();
    this.load();
    this.checkHealthStatus();
  }

  onHeatLossTypeChange() {
    this.eeBDMainBuilding.floorConstruction = null;
    this.eeBDMainBuilding.floorInsulationType = null;
    this.eeBDMainBuilding.floorInsulationThickness = null;
    this.eeBDMainBuilding.floorUValueKnown = false;
    this.eeBDMainBuilding.floorUValue = 0;
  }

  onHeatLossTypeChangeExtensions(buildingNumber: number) {
    const buildingPart = this.details.buildingParts[buildingNumber];
    if (buildingPart) {
      buildingPart.floorConstruction = null;
      buildingPart.floorInsulationType = null;
      buildingPart.floorInsulationThickness = null;
      buildingPart.floorUValueKnown = false;
      buildingPart.floorUValue = 0;
    }
  }

  showStandard(msg: string) {
    this.standardMessage = msg;
    this.toastService.show({ template: this.standardTpl });
  }

  showSuccess(msg: string) {
    this.successMessage = msg;
    this.toastService.show({
      template: this.successTpl,
      classname: 'bg-success text-light',
      delay: 10000,
    });
  }

  showDanger(msg: string) {
    this.errorMessage = msg;
    this.toastService.show({
      template: this.dangerTpl,
      classname: 'bg-danger text-light',
      delay: 15000,
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.toastService.clear();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.eeGeneralDetails) {
      this.updateBuildingExtensions();
    }
  }

  onAdditionalWallChangeMainBuilding() {
    if (!this.showAdditionalWall.eeBDMainBuilding) {
      this.resetAdditionalWallPropertiesMainBuilding();
    }
  }

  resetAdditionalWallPropertiesMainBuilding() {
    const mainBuildingPart = this.eeBDMainBuilding;
    if (mainBuildingPart) {
      mainBuildingPart.additionalWallWallArea = null;
      mainBuildingPart.additionalWallsConstruction = null;
      mainBuildingPart.additionalWallThicknessMeasured = null;
      mainBuildingPart.additionalWallsWallThickness = null;
      mainBuildingPart.additionalWallsInsulationType = null;
      mainBuildingPart.additionalWallsInsulationThickness = null;
      mainBuildingPart.additionalWallUValueKnown = null;
      mainBuildingPart.additionalWallsUValue = null;
      mainBuildingPart.additionalWallsDryLined = null;
      mainBuildingPart.shelteredWall = null;
    }
  }

  onAdditionalWallChange(buildingNumber: number) {
    if (!this.showAdditionalWall[`eeBDMainBuilding${buildingNumber}`]) {
      this.resetAdditionalWallProperties(buildingNumber);
    }
  }

  resetAdditionalWallProperties(buildingNumber: number) {
    const buildingPart = this.details.buildingParts[buildingNumber - 1];
    if (buildingPart) {
      buildingPart.additionalWallWallArea = null;
      buildingPart.additionalWallsConstruction = null;
      buildingPart.additionalWallThicknessMeasured = null;
      buildingPart.additionalWallsWallThickness = null;
      buildingPart.additionalWallsInsulationType = null;
      buildingPart.additionalWallsInsulationThickness = null;
      buildingPart.additionalWallUValueKnown = null;
      buildingPart.additionalWallsUValue = null;
      buildingPart.additionalWallsDryLined = null;
      buildingPart.shelteredWall = null;
    }
  }

  checkHealthStatus(): void {
    this.healthCheckService.checkHealth();
    this.isHealthy$ = this.healthCheckService.status$;
  }

  getBuildingParts() {
    const buildings = [{ name: 'Main Building', id: 0 }];

    for (const key in this.showBuildingExtensions) {
      if (
        Object.prototype.hasOwnProperty.call(
          this.showBuildingExtensions,
          key
        ) &&
        this.showBuildingExtensions[key]
      ) {
        const buildingPart = key.charAt(0).toUpperCase() + key.slice(1);
        buildings.push({ name: buildingPart, id: Number(key.slice(-1)) });
      }
    }

    return buildings;
  }
  
  onCorridorTypeChange() {
    if (
      this.eeGeneralDetails.corridorType === '1' ||
      this.eeGeneralDetails.corridorType === '0'
    ) {
      this.eeGeneralDetails.heatLossBuilding = null;
      this.eeBDMainBuilding.shelteredWall = false;
      this.eeBDEx1.shelteredWall = false;
      this.eeBDEx2.shelteredWall = false;
      this.eeBDEx3.shelteredWall = false;
      this.eeBDEx4.shelteredWall = false;
    }
    this.setBuildingHeatLoss();
  }

  onPropertyTypeChange() {
    this.setBuildingHeatLoss();
  }

  getDefaultOptionTextForHeatLoss(): string {
    if (this.eeBDMainBuilding.shelteredWall) {
      return 'Main Building';
    } else if (this.eeBDEx1.shelteredWall) {
      return 'Extension 1';
    } else if (this.eeBDEx2.shelteredWall) {
      return 'Extension 2';
    } else if (this.eeBDEx3.shelteredWall) {
      return 'Extension 3';
    } else if (this.eeBDEx4.shelteredWall) {
      return 'Extension 4';
    } else {
      return 'Select a building part';
    }
  }




  getStoredHeatLoss(): number {
    return Number(sessionStorage.getItem('heatLossBuilding'));
  }

  setBuildingHeatLoss() {
    const selectedBuilding = this.eeGeneralDetails.heatLossBuilding;
    if (selectedBuilding !== null) {
      sessionStorage.setItem('heatLossBuilding', selectedBuilding.toString());
    }
    if (this.eeGeneralDetails.heatLossBuilding === null) {
      return;
    }
    if (
      this.eeGeneralDetails.propertyType == '2' ||
      this.eeGeneralDetails.propertyType == '3'
    ) {
      if (this.eeGeneralDetails.heatLossBuilding == 0) {
        this.showAdditionalWall.eeBDMainBuilding = true;
        this.eeBDMainBuilding.shelteredWall = true;
        this.showAdditionalWall.eeBDEx1 = false;
        this.eeBDEx1.shelteredWall = false;
        this.showAdditionalWall.eeBDEx2 = false;
        this.eeBDEx2.shelteredWall = false;
        this.showAdditionalWall.eeBDEx3 = false;
        this.eeBDEx3.shelteredWall = false;
        this.showAdditionalWall.eeBDEx4 = false;
        this.eeBDEx4.shelteredWall = false;
      } else if (this.eeGeneralDetails.heatLossBuilding == 1) {
        this.showAdditionalWall.eeBDEx1 = true;
        this.eeBDEx1.shelteredWall = true;
        this.showAdditionalWall.eeBDMainBuilding = false;
        this.eeBDMainBuilding.shelteredWall = false;
        this.showAdditionalWall.eeBDEx2 = false;
        this.eeBDEx2.shelteredWall = false;
        this.showAdditionalWall.eeBDEx3 = false;
        this.eeBDEx3.shelteredWall = false;
        this.showAdditionalWall.eeBDEx4 = false;
        this.eeBDEx4.shelteredWall = false;
      } else if (this.eeGeneralDetails.heatLossBuilding == 2) {
        this.showAdditionalWall.eeBDEx2 = true;
        this.eeBDEx2.shelteredWall = true;
        this.showAdditionalWall.eeBDMainBuilding = false;
        this.eeBDMainBuilding.shelteredWall = false;
        this.showAdditionalWall.eeBDEx1 = false;
        this.eeBDEx1.shelteredWall = false;
        this.showAdditionalWall.eeBDEx3 = false;
        this.eeBDEx3.shelteredWall = false;
        this.showAdditionalWall.eeBDEx4 = false;
        this.eeBDEx4.shelteredWall = false;
      } else if (this.eeGeneralDetails.heatLossBuilding == 3) {
        this.showAdditionalWall.eeBDEx3 = true;
        this.eeBDEx3.shelteredWall = true;
        this.showAdditionalWall.eeBDMainBuilding = false;
        this.eeBDMainBuilding.shelteredWall = false;
        this.showAdditionalWall.eeBDEx1 = false;
        this.eeBDEx1.shelteredWall = false;
        this.showAdditionalWall.eeBDEx2 = false;
        this.eeBDEx2.shelteredWall = false;
        this.showAdditionalWall.eeBDEx4 = false;
        this.eeBDEx4.shelteredWall = false;
      } else if (this.eeGeneralDetails.heatLossBuilding == 4) {
        this.showAdditionalWall.eeBDEx4 = true;
        this.eeBDEx4.shelteredWall = true;
        this.showAdditionalWall.eeBDMainBuilding = false;
        this.eeBDMainBuilding.shelteredWall = false;
        this.showAdditionalWall.eeBDEx1 = false;
        this.eeBDEx1.shelteredWall = false;
        this.showAdditionalWall.eeBDEx2 = false;
        this.eeBDEx2.shelteredWall = false;
        this.showAdditionalWall.eeBDEx3 = false;
        this.eeBDEx3.shelteredWall = false;
      }
    } else {
      this.showAdditionalWall.eeBDMainBuilding = false;
      this.eeBDMainBuilding.shelteredWall = false;
      this.showAdditionalWall.eeBDEx1 = false;
      this.eeBDEx1.shelteredWall = false;
      this.showAdditionalWall.eeBDEx2 = false;
      this.eeBDEx2.shelteredWall = false;
      this.showAdditionalWall.eeBDEx3 = false;
      this.eeBDEx3.shelteredWall = false;
      this.showAdditionalWall.eeBDEx4 = false;
      this.eeBDEx4.shelteredWall = false;
    }
    if (this.eeGeneralDetails.heatLossBuilding !== 0) {
      this.eeBDMainBuilding.additionalWallWallArea = null;
      this.eeBDMainBuilding.additionalWallsConstruction = null;
      this.eeBDMainBuilding.additionalWallThicknessMeasured = null;
      this.eeBDMainBuilding.additionalWallsWallThickness = null;
      this.eeBDMainBuilding.additionalWallsInsulationType = null;
      this.eeBDMainBuilding.additionalWallsInsulationThickness = null;
      this.eeBDMainBuilding.additionalWallUValueKnown = null;
      this.eeBDMainBuilding.additionalWallsUValue = null;
      this.eeBDMainBuilding.additionalWallsDryLined = null;
    }
  }

  private _eeRR: RdSAPRenewablesRecoveryUIDTOV0 = {
    pvConfiguration: <PVConfigurationV0>{},
  };

  private _eeHeating: RdSAPHeatingUIDTOV0 = {
    mainGasAvailable: false,
    electricMeter: '',
    secoundaryHeatingFuel: '',
    secoundaryHeatingSystem: '',
  };

  set eeOpeningDetails(value) {
    this._eeOpeningDetails = {
      ...value,
      draughtProofing: value.draughtProofing ?? 0,
      externalDoors: value.externalDoors ?? 0,
      insulatedExternalDoors: value.insulatedExternalDoors ?? 0,
      doorsUValue: value.doorsUValue ?? 0,
      ventilationType: value.ventilationType ?? '',
      fixedAirConditioning: value.fixedAirConditioning ?? false,
      coverage: value.coverage ?? '',
      multiGlazing: value.multiGlazing ?? 0,
      glazingType: value.glazingType ?? '',
      glazingGap: value.glazingGap ?? '',
      UValue: value.UValue ?? 0,
      GValue: value.GValue ?? 0,
      windowTransmissionDataSource: value.windowTransmissionDataSource ?? '',
      sapWindows: value.sapWindows ?? [],
    };
    if (this._eeOpeningDetails.glazingType) {
      if (
        this.keyedLookUpCodes &&
        this.keyedLookUpCodes['Glazing Type'] &&
        this._eeOpeningDetails.glazingType !== this.keyedLookUpCodes['Glazing Type']['Double glazed (before 2002)'] &&
        this._eeOpeningDetails.glazingType !== this.keyedLookUpCodes['Glazing Type']['Double glazed (before 2003)'] &&
        this._eeOpeningDetails.glazingType !== this.keyedLookUpCodes['Glazing Type']['Double glazed (unknown age)']
      ) {
        this._eeOpeningDetails.upvcFramed = false;
      }
    }
    if (this._eeOpeningDetails.multiGlazing) {
      this.setGlazingTypeArray();
    }
    this.onOpeningsChange();
  }

  get eeOpeningDetails() {
    return this._eeOpeningDetails;
  }

  onOpeningsChange() {
    if (this._eeOpeningDetails.coverage) {
      if (
        this._eeOpeningDetails.coverage !== this.keyedLookUpCodes['GlazingCoverage']['Much more than typical'] &&
        this._eeOpeningDetails.coverage !== this.keyedLookUpCodes['GlazingCoverage']['Much less than typical']
      ) {
        this._eeOpeningDetails.sapWindows = null;
      }
    }
    if (this._eeOpeningDetails.glazingType) {
      if (
        this._eeOpeningDetails.glazingType === this.keyedLookUpCodes['Glazing Type']['Double glazed (2002 or later)']
      ) {
        this._eeOpeningDetails.upvcFramed = null;
        this._eeOpeningDetails.glazingGap = null;
      }
    }
  }

  get countryLookupCodes() {
    return this.eeRRLookupCodes.filter((x) => x.dataItem === 'CountryCode' && x.lookUpItem !== 'NIR');
  }

  get sortedEERecommendations() {
    return orderBy(this.eeRecommendations, ['sequence'], ['asc']);
  }

  filterLookupCodes(filter) {
    return this.utilsService.filterLookupCodes(filter);
  }

  get eeHeating(): RdSAPHeatingUIDTOV0 {
    return this._eeHeating;
  }

  set eeHeating(value: RdSAPHeatingUIDTOV0) {
    this._eeHeating = {
      ...value,
      mainGasAvailable: value.mainGasAvailable ?? false,
      electricMeter: value.electricMeter ?? '',
      mainSystem1TTZCIndexNumber: value.mainSystem1TTZCIndexNumber ?? 0,
      mainSystem2TTZCIndexNumber: value.mainSystem2TTZCIndexNumber ?? 0,
      mainSystem1WeatherCompensation: value.mainSystem1WeatherCompensation ?? false,
      mainSystem2WeatherCompensation: value.mainSystem2WeatherCompensation ?? false,
    };
    this.mainSystem1CommunityHeating = this.eeHeating.mainSystem1SystemSubType === '426' ? true : false;
    this.setHeatingMainSystemsValue('eeHeating');
    this.onEeHeatingChange();
  }

  onCommunityHeatingChange() {
    this.eeHeating.mainSystem1SystemSubType = '';
    this.eeHeating.mainSystem1System = '';
    this.setCommunityHeatingFuelArrays('mainSystem1');
    this.setCommunityHeatingFuelArrays('mainSystem2');
    this.setDataSystemType();
    this.eeHeating.mainSystem1Fuel = '';
  }

  setDataSystemType() {
    if (!this.mainSystem1CommunityHeating) {
      if (
        this.keyedLookUpCodes &&
        this.lookUpCodesByDataItem &&
        this.lookUpCodesByDataItem['PrimarySystemType']
      ) {
        let primarySystemType = this.lookUpCodesByDataItem['PrimarySystemType'];
        this.primarySystemTypes = filter(primarySystemType,(systemLookUpCode) => {
            return (systemLookUpCode.lookupValue === '2' || systemLookUpCode.lookupValue === '1');
          }
        );
      }
    } else {
      if (
        this.keyedLookUpCodes &&
        this.lookUpCodesByDataItem &&
        this.lookUpCodesByDataItem['PrimarySystemType']
      ) {
        let primarySystemType = this.lookUpCodesByDataItem['PrimarySystemType'];
        this.primarySystemTypes = filter(primarySystemType, (systemLookUpCode) => {
            return systemLookUpCode.lookupValue === '2';
          }
        );
      }
    }
  }

  onSecondaryHeatingChange() {
    if (!this.secondaryHeating) {
      this.eeHeating.secoundaryHeatingFuel = null;
      this.eeHeating.secoundaryHeatingSystem = null;
    }
    this.setWaterHeatingTypes();
  }

  onHeatingReset(heatingSystem) {
    this.eeHeating[`${heatingSystem}SystemSubType`] = null;
    this.eeHeating[`${heatingSystem}System`] = null;
    this.eeHeating[`${heatingSystem}Controls`] = null;
  }

  private onEeHeatingChange() {
    if (this._eeHeating) {
      this.setSecoundaryHeatingFuels();
      this.setCommunityHeatingFuelArrays('mainSystem1');
      this.setCommunityHeatingFuelArrays('mainSystem2');
      this.setDataSystemType();
      if (this._eeHeating.mainSystem1Fuel) {
        this.setHeatingCategoryByFuel('mainSystem1');
        this.setHeatingSystemTypes('mainSystem1');
        this.setWaterHeatingFuels();
      }
      if (this._eeHeating.mainSystem1SystemSubType) {
        this.setHeatingCategoryByFuel('mainSystem1');
        this.setHeatingControls('mainSystem1');
        this.setHeatingSystemTypes('mainSystem1');
        this.resetEmittersPumpAgeFlowTemp('mainSystem1');
      }
      if (this._eeHeating.mainSystem2SystemSubType) {
        this.setCommunityHeatingFuelArrays('mainSystem2');
        this.setHeatingControls('mainSystem2');
        this.setHeatingSystemTypes('mainSystem2');
        this.resetEmittersPumpAgeFlowTemp('mainSystem2');
      }
      if (this._eeHeating.mainSystem2Fuel) {
        this.setHeatingCategoryByFuel('mainSystem2');
        this.setHeatingSystemTypes('mainSystem2');
        this.setWaterHeatingFuels();
      }
      if (this._eeHeating.electricMeter) {
        this.setHeatingMainSystemCategoryArray('mainSystem2');
        this.setHeatingSystemTypes('mainSystem1');
        this.setHeatingSystemTypes('mainSystem2');
        this.setImmersionTypes();
      }
      if (this._eeHeating.mainGasAvailable) {
        this.setCommunityHeatingFuelArrays('mainSystem2');
        this.setSecoundaryHeatingFuels();
      }
      if (this._eeHeating.mainSystem1System) {
        this.setFlueTypeArrays('mainSystem1');
        this.setFanAssistedBoolean('mainSystem1');
      }
      if (this._eeHeating.mainSystem2System) {
        this.setFlueTypeArrays('mainSystem2');
        this.setFanAssistedBoolean('mainSystem2');
      }
      if (this.mainSystems) {
        this.setHeatingMainSystemCategoryArray('mainSystem2');
        this.setHeatingSystemTypes('mainSystem2');
        this.setWaterHeatingTypes();
      }
      if (this.eeHeating.mainSystem1FlueType) {
        this.setFlueTypeArrays('mainSystem1');
      }
      if (this.eeHeating.mainSystem2FlueType) {
        this.setFlueTypeArrays('mainSystem2');
      }
      if (this._eeHeating.mainSystem1Controls) {
        this.setHeatingSystemTypes('mainSystem1');
      }
      if (this._eeHeating.mainSystem2Controls) {
        this.setHeatingSystemTypes('mainSystem2');
      }
      if (this._eeHeating.waterHeatingSystem) {
        this.setWaterHeatingFuels();
      }
      if (this._eeHeating.secoundaryHeatingFuel) {
        this.setSecoundaryHeatingSystems();
        this.setWaterHeatingFuels();
      }
    }
    if (this.mainSystems === '1 Main system + 1 DHW only') {
      this.eeHeating.mainSystem2HeatingProportion = 0;
      this.updateMainSystem1Proportion();
    }
  }

  resetEmittersPumpAgeFlowTemp(heatingSystem) {
    if (this.eeHeating[`${heatingSystem}SystemSubType`]) {
      switch (this.eeHeating[`${heatingSystem}SystemSubType`]) {
        case '6':
        case '9':
        case '10':
        case '11':
        case '150':
        case '151':
        case '250':
        case '3':
        case '7':
        case '2':
        case '4':
        case '5':
        case '252':
        case '152':
        case '241':
        case '426':
          this.eeHeating[`${heatingSystem}Emitter`] = null;
          this.eeHeating[`${heatingSystem}PumpAge`] = null;
          this.eeHeating[`${heatingSystem}FlowTemp`] = null;

          break;
        case '8':
        case '149':
        case '249':
        case '251':
        case '373':
        case '148':
        case '240':
          this.eeHeating[`${heatingSystem}PumpAge`] = null;
          this.eeHeating[`${heatingSystem}FlowTemp`] = null;

          break;
        case '253':
          this.eeHeating[`${heatingSystem}PumpAge`] = null;

          break;
        default:
          break;
      }
    }
  }

  get eeRR(): RdSAPRenewablesRecoveryUIDTOV0 {
    return this._eeRR;
  }

  set eeRR(value: RdSAPRenewablesRecoveryUIDTOV0) {
    this._eeRR = {
      ...value,
      pvConfiguration: value?.pvConfiguration ?? 'None',
    };
    if (this._eeRR.array1Pitch) {
      this.setRenewablesArrayOrientations('array1');
    }
    if (this._eeRR.array2Pitch) {
      this.setRenewablesArrayOrientations('array2');
    }
    if (this._eeRR.array3Pitch) {
      this.setRenewablesArrayOrientations('array3');
    }
    if (this.eeRR.solarWaterHeaterPitch) {
      this.setRenewablesSWHOrientations();
    }
    if (this.eeRR.numberOfTurbines) {
      this.renewablesNumberOfTurbinesChanged();
    }
  }

  set lookUpCodesByDataItem(value: any) {
    this._lookUpCodesByDataItem = value;
    this.onLookUpCodesByDataItemChange();
  }

  get lookUpCodesByDataItem(): any {
    return this._lookUpCodesByDataItem;
  }

  dataSelectForMain1(data) {
    Object.keys(this.mainSystem1StorageHeaters).forEach((key) => {
      let val = this.mainSystem1StorageHeaters[key];
      data.forEach(function (item) {
        item.highHeatRetention = item.highHeatRetention === '1' ? true : false;
        item.numberOfHeaters = item.numberOfHeaters
          ? item.numberOfHeaters
          : null;
        if (val.value.id == item.indexNumber) {
          val.value.highHeatRetention = item.highHeatRetention;
          val.numberOfHeaters = item.numberOfHeaters;
        }
      });
    });
  }

  dataSelectForMain2(data) {
    Object.keys(this.mainSystem2StorageHeaters).forEach((key) => {
      let val = this.mainSystem2StorageHeaters[key];
      data.forEach(function (item) {
        item.highHeatRetention = item.highHeatRetention === '1' ? true : false;
        item.numberOfHeaters = item.numberOfHeaters
          ? item.numberOfHeaters
          : null;
        if (val.value.id == item.indexNumber) {
          val.value.highHeatRetention = item.highHeatRetention;
          val.numberOfHeaters = item.numberOfHeaters;
        }
      });
    });
  }

  dataSelectHeatingControlsForMain1(data) {
    const id = data.find((x) => x.indexNumber);
    this.eeHeating.mainSystem1TTZCIndexNumber = id?.indexNumber || 0;
  }

  dataSelectHeatingControlsForMain2(data) {
    const id = data.find((x) => x.indexNumber);
    this.eeHeating.mainSystem2TTZCIndexNumber = id?.indexNumber || 0;
  }

  dataSelectWeatherCompensationForMain1(data) {
    const id = data.find((x) => x.indexNumber);
    this.eeHeating.mainSystem1WeatherCompensation = id?.indexNumber || 0;
  }

  dataSelectWeatherCompensationForMain2(data) {
    const id = data.find((x) => x.indexNumber);
    this.eeHeating.mainSystem2WeatherCompensation = id?.indexNumber || 0;
  }

  private onLookUpCodesByDataItemChange(): void {
    this.setCommunityHeatingFuelArrays('mainSystem1');
    this.setCommunityHeatingFuelArrays('mainSystem2');
    this.setHeatingMainSystemCategoryArray('mainSystem1');
    this.setHeatingMainSystemCategoryArray('mainSystem2');
    this.setHeatingSystemTypes('mainSystem1');
    this.setHeatingSystemTypes('mainSystem2');
    this.setFlueTypeArrays('mainSystem1');
    this.setFlueTypeArrays('mainSystem2');
    this.setHeatingControls('mainSystem1');
    this.setHeatingControls('mainSystem2');
    this.setFanAssistedBoolean('mainSystem1');
    this.setFanAssistedBoolean('mainSystem2');
    this.setSecoundaryHeatingFuels();
    this.setSecoundaryHeatingSystems();
    this.setWaterHeatingTypes();
    this.setWaterHeatingFuels();
    this.setImmersionTypes();
    this.setRenewablesArrayOrientations('array1');
    this.setRenewablesArrayOrientations('array2');
    this.setRenewablesArrayOrientations('array3');
    this.setRenewablesSWHOrientations();
    this.renewablesNumberOfTurbinesChanged();
  }

  set eeBDMainBuilding(value: any) {
    this._eeBDMainBuilding = {
      ...value,
      buildingPartAge: value?.buildingPartAge ?? '',
    };
    this.onEeBDMainBuildingChange();
  }

  get eeBDMainBuilding(): any {
    return this._eeBDMainBuilding;
  }

  private onEeBDMainBuildingChange(): void {
    if (this.eeBDMainBuilding.roofRoomsInsulation) {
      this.setRoofRoomsInsulationThicknessArrays('eeBDMainBuilding');
    }
    if (this.eeBDMainBuilding.roofInsulationType) {
      this.setRoofInsulationThicknessArrays('eeBDMainBuilding');
    }
    if (this.eeBDMainBuilding.roofConstruction) {
      this.setRoofInsulationTypeArrays('eeBDMainBuilding');
    }
    if (this.eeBDMainBuilding.wallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDMainBuilding', 'wallsConstruction', 'wallsInsulationType');
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDMainBuilding');
    }
    if (this.eeBDMainBuilding.additionalWallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDMainBuilding', 'additionalWallsConstruction', 'additionalWallsInsulationType');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDMainBuilding');
    }
    if (this.eeBDMainBuilding.roofConstruction) {
      this.setShowRoofRoomToFalseBasedOnRoofConstruction('eeBDMainBuilding');
    }
    if (this.eeBDMainBuilding.buildingPartAge) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDMainBuilding');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDMainBuilding');
    }
    if (this.eeBDMainBuilding.wallsInsulationType) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDMainBuilding');
    }
    if (this.eeBDMainBuilding.additionalWallsInsulationType) {
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDMainBuilding');
    }
    if (this.eeGeneralDetails.corridorType == '2' && this.eeGeneralDetails.unheatedCorridorLength && this.eeGeneralDetails.heatLossBuilding == 0) {
      this.calculateAlternativeWallAreaOnLoad(this.eeGeneralDetails.unheatedCorridorLength);
    } else {
      this.eeBDMainBuilding.additionalWallWallArea = this.eeBDMainBuilding.additionalWallWallArea;
    }
  }

  set eeBDEx1(value: any) {
    this._eeBDEx1 = value;
    this.onEeBDEx1Change();
  }

  get eeBDEx1(): any {
    return this._eeBDEx1;
  }

  set eeBDEx2(value: any) {
    this._eeBDEx2 = value;
    this.onEeBDEx2Change();
  }

  get eeBDEx2(): any {
    return this._eeBDEx2;
  }

  set eeBDEx3(value: any) {
    this._eeBDEx3 = value;
    if (this._eeBDEx3.roofRoomsInsulation) {
      this.setRoofRoomsInsulationThicknessArrays('eeBDEx3');
    }
    if (this._eeBDEx3.roofInsulationType) {
      this.setRoofInsulationThicknessArrays('eeBDEx3');
    }
    if (this._eeBDEx3.roofConstruction) {
      this.setRoofInsulationTypeArrays('eeBDEx3');
    }
    if (this._eeBDEx3.wallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDEx3', 'wallsConstruction', 'wallsInsulationType');
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx3');
    }
    if (this._eeBDEx3.additionalWallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDEx3', 'additionalWallsConstruction', 'additionalWallsInsulationType');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx3');
    }
    if (this._eeBDEx3.roofConstruction) {
      this.setShowRoofRoomToFalseBasedOnRoofConstruction('eeBDEx3');
    }
    if (this._eeBDEx3.buildingPartAge) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx3');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx3');
    }
    if (this._eeBDEx3.wallsInsulationType) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx3');
    }
    if (this._eeBDEx3.additionalWallsInsulationType) {
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx3');
    }
  }

  get eeBDEx3(): any {
    return this._eeBDEx3;
  }

  set eeBDEx4(value: any) {
    this._eeBDEx4 = value;
    if (this._eeBDEx4.roofRoomsInsulation) {
      this.setRoofRoomsInsulationThicknessArrays('eeBDEx4');
    }
    if (this._eeBDEx4.roofInsulationType) {
      this.setRoofInsulationThicknessArrays('eeBDEx4');
    }
    if (this._eeBDEx4.roofConstruction) {
      this.setRoofInsulationTypeArrays('eeBDEx4');
    }
    if (this._eeBDEx4.wallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDEx4', 'wallsConstruction', 'wallsInsulationType');
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx4');
    }
    if (this._eeBDEx4.additionalWallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDEx4', 'additionalWallsConstruction', 'additionalWallsInsulationType');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx4');
    }
    if (this._eeBDEx4.roofConstruction) {
      this.setShowRoofRoomToFalseBasedOnRoofConstruction('eeBDEx4');
    }
    if (this._eeBDEx4.buildingPartAge) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx4');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx4');
    }
    if (this._eeBDEx4.wallsInsulationType) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx4');
    }
    if (this._eeBDEx4.additionalWallsInsulationType) {
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx4');
    }
  }

  get eeBDEx4(): any {
    return this._eeBDEx4;
  }

  private onEeBDEx1Change(): void {
    if (this.eeBDEx1.roofRoomsInsulation) {
      this.setRoofRoomsInsulationThicknessArrays('eeBDEx1');
    }
    if (this.eeBDEx1.roofInsulationType) {
      this.setRoofInsulationThicknessArrays('eeBDEx1');
    }
    if (this.eeBDEx1.roofConstruction) {
      this.setRoofInsulationTypeArrays('eeBDEx1');
    }
    if (this.eeBDEx1.wallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDEx1', 'wallsConstruction', 'wallsInsulationType');
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx1');
    }
    if (this.eeBDEx1.additionalWallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDEx1', 'additionalWallsConstruction', 'additionalWallsInsulationType');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx1');
    }
    if (this.eeBDEx1.roofConstruction) {
      this.setShowRoofRoomToFalseBasedOnRoofConstruction('eeBDEx1');
    }
    if (this.eeBDEx1.buildingPartAge) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx1');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx1');
    }
    if (this.eeBDEx1.wallsInsulationType) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx1');
    }
    if (this.eeBDEx1.additionalWallsInsulationType) {
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx1');
    }
  }

  private onEeBDEx2Change(): void {
    if (this.eeBDEx2.roofRoomsInsulation) {
      this.setRoofRoomsInsulationThicknessArrays('eeBDEx2');
    }
    if (this.eeBDEx2.roofInsulationType) {
      this.setRoofInsulationThicknessArrays('eeBDEx2');
    }
    if (this.eeBDEx2.roofConstruction) {
      this.setRoofInsulationTypeArrays('eeBDEx2');
    }
    if (this.eeBDEx2.wallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDEx2', 'wallsConstruction', 'wallsInsulationType');
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx2');
    }
    if (this.eeBDEx2.additionalWallsConstruction) {
      this.setWallsInsulationTypeToNull('eeBDEx2', 'additionalWallsConstruction', 'additionalWallsInsulationType');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx2');
    }
    if (this.eeBDEx2.roofConstruction) {
      this.setShowRoofRoomToFalseBasedOnRoofConstruction('eeBDEx2');
    }
    if (this.eeBDEx2.buildingPartAge) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx2');
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx2');
    }
    if (this.eeBDEx2.wallsInsulationType) {
      this.setMainWallsDryLinedToFalseForCertainAgeBands('eeBDEx2');
    }
    if (this.eeBDEx2.additionalWallsInsulationType) {
      this.setAdditionalWallsDryLinedToFalseForCertainAgeBands('eeBDEx2');
    }
  }

  getRowClass(row: any) {
    return {
      'blue-50-bg': this.isSelectedDataSet(row.id),
    };
  }

  resetExtensionProperties(buildingNumber: number) {
    const buildingPart = this.details.buildingParts[buildingNumber - 1];
    if (buildingPart) {
      const partyWallConstructionIsNotApplicable = this.eeGeneralDetails.builtForm === this.keyedLookUpCodes['BuiltForm']['Detached'];
      if (buildingPart.hasOwnProperty('dimensionsNumberOfFloors')) {
        buildingPart.dimensionsNumberOfFloors = 1;
      }
      buildingPart.dimensionsArray = [
        {
          floor: '0',
          area: '0',
          height: '0',
          perimeter: '0',
          partyWall: partyWallConstructionIsNotApplicable ? 0 : null,
        },
      ];
      buildingPart.buildingPartAge = null;
      buildingPart.floorConstruction = null;
      buildingPart.floorHeatLossType = null;
      buildingPart.floorInsulationThickness = null;
      buildingPart.floorInsulationType = null;
      buildingPart.floorUValue = null;
      buildingPart.floorUValueKnown = false;
      buildingPart.partyWallConstruction = null;
      buildingPart.roofConstruction = null;
      buildingPart.roofInsulationThickness = null;
      buildingPart.roofInsulationType = null;
      buildingPart.roofUValue = null;
      buildingPart.roofUValueKnown = false;
      buildingPart.slopingCeilingInsulationThickness = null;
      buildingPart.wallThicknessMeasured = false;
      buildingPart.wallsConstruction = null;
      buildingPart.wallsInsulationType = null;
      buildingPart.wallsInsulationThickness = null;
      buildingPart.wallsUValue = null;
      buildingPart.wallsWallThickness = null;
    }
  }

  resetMultipleExtensionProperties(buildingNumbers: number[]) {
    buildingNumbers.forEach((buildingNumber) => {
      let additionalWallProperty = `eeBDEx${buildingNumber - 1}`;
      if (this.showAdditionalWall.hasOwnProperty(additionalWallProperty)) {
        this.showAdditionalWall[additionalWallProperty] = false;
      }
      let roofRoomProperty = `eeBDEx${buildingNumber - 1}`;
      if (this.showRoofRoom.hasOwnProperty(roofRoomProperty)) {
        this.showRoofRoom[roofRoomProperty] = false;
      }
      this.resetExtensionProperties(buildingNumber);
      this.onAdditionalWallChange(buildingNumber);
      this.onRoofRoomChange(buildingNumber);
    });
  }

  private updateBuildingExtensions() {
    if (this.keyedLookUpCodes && this.keyedLookUpCodes['Extensions']) {
      switch (this.eeGeneralDetails.buildingConfiguration) {
        case this.keyedLookUpCodes['Extensions']['1']:
          this.showBuildingExtensions = {
            extension1: true,
            extension2: false,
            extension3: false,
            extension4: false,
          };
          this.resetMultipleExtensionProperties([3, 4, 5]);
          break;
        case this.keyedLookUpCodes['Extensions']['2']:
          this.showBuildingExtensions = {
            extension1: true,
            extension2: true,
            extension3: false,
            extension4: false,
          };
          this.resetMultipleExtensionProperties([4, 5]);
          break;
        case this.keyedLookUpCodes['Extensions']['3']:
          this.showBuildingExtensions = {
            extension1: true,
            extension2: true,
            extension3: true,
            extension4: false,
          };
          this.resetMultipleExtensionProperties([5]);
          break;
        case this.keyedLookUpCodes['Extensions']['4']:
          this.showBuildingExtensions = {
            extension1: true,
            extension2: true,
            extension3: true,
            extension4: true,
          };
          break;
        default:
          this.showBuildingExtensions = {
            extension1: false,
            extension2: false,
            extension3: false,
            extension4: false,
          };
          this.resetMultipleExtensionProperties([2, 3, 4, 5]);
      }
      this.changePartyWallConstruction();
    }
    this.setRoofRoomsInsulationThicknessArrays('eeBDMainBuilding');
    this.setRoofRoomsInsulationThicknessArrays('eeBDEx1');
    this.setRoofRoomsInsulationThicknessArrays('eeBDEx2');
    this.setRoofRoomsInsulationThicknessArrays('eeBDEx3');
    this.setRoofRoomsInsulationThicknessArrays('eeBDEx4');
    this.buildingParts = this.getBuildingParts();
  }

  onChange(value: any) {
    this.pvBatteryCapacity = Number(value.target.value);
  }

  setRoofRoomsInsulationThicknessArrays(buildingPartKey) {
    if (
      this.keyedLookUpCodes &&
      this.keyedLookUpCodes['RoofRoomInsulationType'] &&
      this.roofRoomsInsulationThicknesses &&
      this.roofRoomsInsulationThicknessesWithoutNotApplicable
    ) {
      if (this[buildingPartKey].roofRoomsInsulation === this.keyedLookUpCodes['RoofRoomInsulationType']['Flat ceiling only']) {
        this.roofRoomsInsulationThicknessesByBuildingPart[buildingPartKey] =
          this.roofRoomsInsulationThicknessesWithoutNotApplicable;
        if (this[buildingPartKey].roofRoomsThickness === this.keyedLookUpCodes['RoofRoomsInsulationThickness(AtCeiling)']['Not applicable']) {
          this[buildingPartKey].roofRoomsThickness = null;
        }
      } else {
        this.roofRoomsInsulationThicknessesByBuildingPart[buildingPartKey] = this.roofRoomsInsulationThicknesses;
      }
    }
  }

  calculateAlternativeWallArea(buildingPart) {
    const locationInBlock = Number(this.eeGeneralDetails.locationInBlock);
    const unheatedCorridorLength = this.eeGeneralDetails.unheatedCorridorLength;
    let additionalWallWallArea = null;
    if (buildingPart.dimensionsArray) {
      additionalWallWallArea = buildingPart.dimensionsArray[0].height * unheatedCorridorLength;
      buildingPart.additionalWallWallArea = parseFloat(additionalWallWallArea.toFixed(3));
    }
    this.eeBDMainBuilding.additionalWallWallArea = parseFloat(additionalWallWallArea.toFixed(3));
  }

  calculateAlternativeWallAreaOnLoad(unheatedCorridorLength) {
    const locationInBlock = Number(this.eeGeneralDetails.locationInBlock);
    let additionalWallWallArea = null;
    this.details.buildingParts.forEach(function (buildingPart: RdSAPBuildingPartUIDTOV0) {
      if (buildingPart.dimensionsArray) { 
        buildingPart.additionalWallWallArea = additionalWallWallArea = buildingPart.dimensionsArray[0].height * unheatedCorridorLength;
      }
    });
    this.eeBDMainBuilding.additionalWallWallArea = additionalWallWallArea;
  }

  onCorridorChange(value) {
    this.eeGeneralDetails.unheatedCorridorLength = value;
    this.calculateAlternativeWallAreaOnLoad(value);
  }

  getListOfDataSets(selectId?: number) {
    this.loading = true;
    this.rdSAPDataSets$
      .pipe(
        catchError((error) => {
          console.error('An error occurred:', error);
          this.loading = false;
          return throwError(() => error);
        })
      ).subscribe((data) => {
        this.rdSAPdataSets = data;
        this.selectedDataSet = null;
        this.loading = false;
        this.activeDataset = this.rdSAPdataSets.find((dataSet) => dataSet.isActive);
        if (this.activeDataset) {
          this.setActiveDataSetRatingInfo(this.activeDataset.results);
        }
        this.setActiveDataSetJsonData(this.activeDataset);
        if (selectId) {
          const targetDataSet = this.rdSAPdataSets.find((ds) => ds.id === selectId);
          if (targetDataSet) {
            this.selectDataSet(targetDataSet);
          }
        }
      });
  }

  private populateLookUpCodesDataVariables(data: any) {
    this.eeRRLookupCodes = data.lookupCodes;
    this.lookUpCodesByDataItem = data.lookUpCodesByDataItem;
    this.keyedLookUpCodes = data.keyedLookUpCodes;
    this.swhConfigurations = data.swhConfigurations;
    this.keyedSWHConfigurations = data.keyedSWHConfigurations;
    this.pvConfigurationsOptions = data.pvConfigurationsOptions;
    this.keyedPVConfigurationsOptions = data.keyedPVConfigurationsOptions;
    this.wallsInsulationTypes = data.wallsInsulationTypes;
    this.roofInsulationTypes = data.roofInsulationTypes;
    this.roofInsulationThicknesses = data.roofInsulationThicknesses;
    this.wallsInsulationTypesNoCavity = data.wallsInsulationTypesNoCavity;
    this.roofRoomsInsulationThicknesses = data.roofRoomsInsulationThicknesses;
    this.roofRoomsInsulationThicknessesWithoutNotApplicable = data.roofRoomsInsulationThicknessesWithoutNotApplicable;
    this.communityHeatingFuelCodes = data.communityHeatingFuelCodes;
    this.pcdbSelectorHeatingTypes = data.pcdbSelectorHeatingTypes;
  }

  load() {
    this.loading = true;
    this.form = new FormGroup({countryCode: new FormControl('')});
    this.initializeJsonObjects();
    if (this.hasAccess) {
      this.rdSAPLookUpCodes$.subscribe((data) => {
        if (data.length) {
          this.populateLookUpCodesDataVariables(cloneDeep(data[0]));
          this.getAndSetRdSAPDetails();
        }
      });
    }
  }

  updateEeRRLookupCodesWithCountryCodeSpecificLookupItems(countryCode: string) {
    this.setConstructionAgeItemsByCountryCode(countryCode);
    this.setGlazingTypeArray();
  }

  private initializeJsonObjects() {
    const jsonByBuildingPart = {
      eeBDMainBuilding: [],
      eeBDEx1: [],
      eeBDEx2: [],
      eeBDEx3: [],
      eeBDEx4: [],
    };
    this.roofInsulationTypesByBuildingPart = { ...jsonByBuildingPart };
    this.roofInsulationThicknessesByBuildingPart = { ...jsonByBuildingPart };
    this.roofRoomsInsulationThicknessesByBuildingPart = {
      ...jsonByBuildingPart,
    };
    const jsonByHeatingSystem = {
      mainSystem1: [],
      mainSystem2: [],
    };
    this.heatingMainSystemCategoriesBySystem = { ...jsonByHeatingSystem };
    this.heatingMainSystemCategoriesByFuel = { ...jsonByHeatingSystem };
    this.heatingFuelsBySystem = { ...jsonByHeatingSystem };
    this.heatingSystemTypesBySystem = { ...jsonByHeatingSystem };
    this.heatingFlueTypesBySystem = { ...jsonByHeatingSystem };
    this.heatingControlsBySystem = { ...jsonByHeatingSystem };
    this.renewablesOrientationsByArray = {
      array1: [],
      array2: [],
      array3: [],
    };
  }

  setConstructionAgeItemsByCountryCode(countryCode: string) {
    const constructionAgeLookUpItems: { [key: string]: string[] } = {
      EAW: [
        'Pre 1900', '1900 - 1929', '1930 - 1949', '1950 - 1966', '1967 - 1975',
        '1976 - 1982', '1983 - 1990', '1991 - 1995', '1996 - 2002', '2003 - 2006',
        '2007 - 2011', '2012 onwards'
      ],
      SCT: [
        'Pre 1919', '1919 - 1929', '1930 - 1949', '1950 - 1964', '1965 - 1975',
        '1976 - 1983', '1984 - 1991', '1992 - 1998', '1999 - 2002', '2003 - 2007',
        '2008 - 2011', '2012 onwards'
      ],
      NIR: [
        'Pre 1919', '1919 - 1929', '1930 - 1949', '1950 - 1973', '1974 - 1977', '1978 - 1985',
        '1986 - 1991', '1992 - 1999', '2000 - 2006', 'not applicable', '2007 - 2013',
        '2014 onwards'
      ]
    };
    const lookupItems = constructionAgeLookUpItems[countryCode] || constructionAgeLookUpItems.EAW;
    this.constructionAgeList = this.eeRRLookupCodes
      .filter((x) => x.dataItem === 'ConstructionAge')
      .filter((x) => lookupItems.includes(x.lookUpItem))
      .sort((a, b) => (a.lookupValue > b.lookupValue ? 1 : -1));
  }

  openRdSAPSurveyCreationModal() {
    const modalRef = this.modalService.open(CreateRdSAPSurveyModalComponent);
    modalRef.componentInstance.assetId = this.addressId;
    modalRef.result.then(() => {});
  }

  setGlazingTypeArray() {
    if (!this.eeOpeningDetails) {
      return;
    }
    if (this.eeOpeningDetails.multiGlazing === 0 && this.eeRRLookupCodes.length) {
      this.glazingTypes = this.eeRRLookupCodes.filter((lookUpCode) => lookUpCode.dataItem === 'Glazing Type' && lookUpCode.lookUpItem.trim() === 'Single glazed');
      this.eeOpeningDetails.glazingType = this.keyedLookUpCodes['Glazing Type']['Single glazed'];
    } else if (this.eeRRLookupCodes.length) {
      this.glazingTypes = this.eeRRLookupCodes.filter((lookUpCode) => lookUpCode.dataItem === 'Glazing Type' && lookUpCode.lookUpItem.trim() !== 'Single glazed');
      if (this.eeOpeningDetails.glazingType === this.keyedLookUpCodes['Glazing Type']['Single glazed']) {
        this.eeOpeningDetails.glazingType = null;
      }
    }
    if (this.eeGeneralDetails.address.countryCode === 'SCT') {
      this.glazingTypes = this.glazingTypes.filter((x) => x.lookUpItem !== 'Double glazed (before 2002)' && x.lookUpItem !== 'Double glazed (2002 or later)');
    } else {
      this.glazingTypes = this.glazingTypes.filter((x) => x.lookUpItem !== 'Double glazed (before 2003)' && x.lookUpItem !== 'Double glazed (2003 or later)');
    }
    this.glazingTypes.sort((a, b) => (a.lookupValue > b.lookupValue ? 1 : -1));
  }

  private setupGlazingTypesFiltering() {
    if (!this.eeRRLookupCodes) {
      return;
    }
    return this.countryCodeSubject.subscribe((countryCode) => {
      let filteredGlazingTypes = this.eeRRLookupCodes?.filter((code) => code.dataItem === 'Glazing Type');
      if (countryCode === 'SCT') {
        filteredGlazingTypes = filteredGlazingTypes.filter((type) => {
          return (type.lookUpItem !== 'Double glazed (before 2002)' && type.lookUpItem !== 'Double glazed (2002 or later)');
        });
      } else {
        filteredGlazingTypes = filteredGlazingTypes.filter((type) => {
          return (type.lookUpItem !== 'Double glazed (before 2003)' && type.lookUpItem !== 'Double glazed (2003 or later)');
        });
      }
      this.glazingTypesSubject.next(filteredGlazingTypes);
      this.glazingTypes = filteredGlazingTypes;
    });
  }

  updateCountryCode(newCountryCode: string) {
    this.countryCodeSubject.next(newCountryCode);
  }

  getRoomCounts() {
    const maxRooms = Math.min(this.eeGeneralDetails.habitableRoomCount || 0, 99);
    return Array.from({ length: maxRooms + 1 }, (_, index) => index);
  }
  getLightCounts() {
    const maxLights = Math.min(this.eeGeneralDetails.totalFixedLightOutlets || 0, 999);
    return Array.from({ length: maxLights + 1 }, (_, index) => index);
  }

  handleFuelType() {
    this.setCommunityHeatingFuelArrays('mainSystem1');
    this.setCommunityHeatingFuelArrays('mainSystem2');
    this.setSecoundaryHeatingFuels();
    const mainsGas = this.lookUpCodesByDataItem['HeatingFuel'].find((x) => x.lookUpItem === 'Mains Gas');
    if (this.eeHeating.mainGasAvailable && mainsGas) {
      this.eeHeating.mainSystem1Fuel = mainsGas.lookupValue;
    } else {
      this.eeHeating.mainSystem1Fuel = this.lookUpCodesByDataItem['HeatingFuel'][1].lookupValue;
    }
    this.setHeatingCategoryByFuel('mainSystem1');
    this.setHeatingCategoryByFuel('mainSystem2');
  }

  onSystemChange(value) {
    const systemType = this.lookUpCodesByDataItem['WaterHeatingType'].find((x) => x.lookupValue === value);
    this.eeHeating.waterHeatingSystem = value;
    this.setWaterHeatingFuels();
  }

  onSecoundaryHeatingFuelChange(value) {
    this.eeHeating.secoundaryHeatingFuel = value;
    this.setSecoundaryHeatingSystems();
    this.setWaterHeatingTypes();
  }

  deleteRdSAPdataSet(dataSet: any): void {
    const modalRef = this.modalService.open(ConfirmDialogComponent);
    modalRef.componentInstance.title = 'Confirm Dataset Deletion?';
    modalRef.componentInstance.message = 'Are you sure you want to delete this Dataset?';
    modalRef.result.then(() => {});
  }

  hasDataSets(): boolean {
    return this.rdSAPdataSets && this.rdSAPdataSets.length > 0;
  }

  selectDataSet(dataSet: any) {
    this.selectedDataSet = dataSet;
    this.selectedRdSapRatingInfo[0].rating = dataSet.sapRating;
    this.selectedRdSapRatingInfo[0].color = dataSet.sapRatingColorClass;
    this.selectedRdSapRatingInfo[1].rating = dataSet.potentialSAPRating;
    this.selectedRdSapRatingInfo[1].color = dataSet.potentialSAPRatingColorClass;
    this.selectedRdSapRatingInfo[2].rating = dataSet.eiRating;
    this.selectedRdSapRatingInfo[2].color = dataSet.eiRatingColorClass;
    this.selectedRdSapRatingInfo[3].rating = dataSet.potentialEI;
    this.selectedRdSapRatingInfo[3].color = dataSet.potentialEIColorClass;
  }

  setActiveDataSetRatingInfo(dataSet: RdSAPResultsDetailUIDTOV0) {
    const ratings: RatingDetails = {
      sapRating: dataSet.sapRating,
      potentialSAPRating: dataSet.potentialSAP,
      eiRating: dataSet.eiRating,
      potentialEIRating: dataSet.potentialEI,
    };
    const ratingClasses = this.getRatingColorClasses(ratings);
    this.activeRdSapRatingInfo[0].rating = dataSet.sapRating;
    this.activeRdSapRatingInfo[0].color = ratingClasses.sapRatingColorClass;
    this.activeRdSapRatingInfo[1].rating = dataSet.potentialSAP;
    this.activeRdSapRatingInfo[1].color = ratingClasses.potentialSAPRatingColorClass;
    this.activeRdSapRatingInfo[2].rating = dataSet.eiRating;
    this.activeRdSapRatingInfo[2].color = ratingClasses.eiRatingColorClass;
    this.activeRdSapRatingInfo[3].rating = dataSet.potentialEI;
    this.activeRdSapRatingInfo[3].color = ratingClasses.potentialEIColorClass;
  }

  getRatingColorClasses(asset: RatingDetails): RatingColorClasses {
    return this.ratingColorService.getColorClasses(asset);
  }

  setDataSetAsActive(dataSet: any): void {
    if (!dataSet) return;
    const modalRef = this.modalService.open(ConfirmDialogComponent);
    modalRef.componentInstance.title = 'Confirm Set Dataset Active?';
    modalRef.componentInstance.message = 'Any changes made to the live dataset that have not been calculated will be discarded.';
    modalRef.result.then((result) => {
      if (result) {
        this.getAndSetRdSAPDetails();
      }
    });
  }

  setActiveDataSetJsonData(dataset: any) {
    if (dataset != null && dataset.jsonDetails != null) {
      this.hasAnActiveDataSet = true;
      this.detailsForActiveDataSet = dataset.jsonDetails;
      this.eeStatusDetailsForActiveDataSet = this.detailsForActiveDataSet.results || {};
      this.eeGeneralDetailsForActiveDataSet = this.detailsForActiveDataSet.general || {};
      this.eeOpeningDetailsForActiveDataSet = this.detailsForActiveDataSet.opening || {};
      this.eeHeatingForActiveDataSet = this.detailsForActiveDataSet.heating || {};
      this.eeRRForActiveDataSet = this.detailsForActiveDataSet.renewables || {};
      this.setBuildingPartsForActiveDataSet();
    } else {
      this.resetActiveDataSet();
    }
  }

  private resetActiveDataSet() {
    this.hasAnActiveDataSet = false;
    this.detailsForActiveDataSet = {};
    this.eeStatusDetailsForActiveDataSet = {};
    this.eeGeneralDetailsForActiveDataSet = {};
    this.eeOpeningDetailsForActiveDataSet = {};
    this.eeHeatingForActiveDataSet = {};
    this.eeRRForActiveDataSet = {};
  }

  private setBuildingPartsForActiveDataSet() {
    this.eeBDMainBuildingForActiveDataSet = this.getBuildingPart(0);
    this.eeBDEx1ForActiveDataSet = this.getBuildingPart(1);
    this.eeBDEx2ForActiveDataSet = this.getBuildingPart(2);
    this.eeBDEx3ForActiveDataSet = this.getBuildingPart(3);
    this.eeBDEx4ForActiveDataSet = this.getBuildingPart(4);
  }

  private getBuildingPart(index: number): any {
    return this.detailsForActiveDataSet.buildingParts &&
      this.detailsForActiveDataSet.buildingParts.length > index
      ? this.detailsForActiveDataSet.buildingParts[index]
      : { buildingPartNumber: index + 1 };
  }

  hasSelectedDataSet(): boolean {
    return this.selectedDataSet !== null;
  }

  isSelectedDataSet(dataSetId: number): boolean {
    return this.selectedDataSet && this.selectedDataSet.id === dataSetId;
  }

  hasAdditionalWallData(mainOrExtensionVariableName: string): boolean {
    const detail: RdSAPBuildingPartUIDTOV0 = this[mainOrExtensionVariableName];
    if (!detail) {
      return false;
    }
    return (
      detail.additionalWallsConstruction != null ||
      detail.additionalWallsWallThickness != null ||
      detail.additionalWallsInsulationType != null ||
      detail.additionalWallsInsulationThickness != null ||
      detail.additionalWallsUValue != null ||
      detail.shelteredWall
    );
  }

  hasRoofRoomData(mainOrExtensionVariableName: string): boolean {
    const detail = this[mainOrExtensionVariableName];
    if (!detail) {
      return false;
    }
    return (
      (detail.roofRoomsArea != null && detail.roofRoomsArea > 0) ||
      detail.roofRoomsInsulation != null ||
      detail.roofRoomsThickness != null ||
      detail.roofRoomsAge != null
    );
  }

  getRDSAPLookUpCodes(): void {
    this.rdSAPLookUpCodes$.subscribe((data) => {
      this.populateLookUpCodesDataVariables(cloneDeep(data[0]));
    });
  }

  hasHeatingMainSystemData(heatingObjectName: string, heatingSystem: string): boolean {
    const heatingObject = this[heatingObjectName];
    return Object.keys(heatingObject).some((key) => key.startsWith(`${heatingSystem}System`) && heatingObject[key]);
  }

  hasNoMainSystem2DHWData(heatingObjectName: string): boolean {
    if (!this.keyedLookUpCodes) {
      return false;
    }
    const heatingObject = this[heatingObjectName];
    const systemSubType = heatingObject.mainSystem2SystemSubType;
    const system = heatingObject.mainSystem2System;
    const proportion = heatingObject.mainSystem2HeatingProportion;
    const excludedTypes = [
      'Electric storage systems',
      'Electric underfloor',
      'Community heating',
      'Other heating',
    ];
    const excludedSystemNumbers = [
      '601',
      '603',
      '609',
      '610',
      '611',
      '612',
      '621',
      '623',
      '631',
      '633',
      '635',
      '691',
      '694',
      '693',
    ];
    return (!excludedTypes.includes(this.keyedLookUpCodes['HeatingType'][systemSubType]) && !excludedSystemNumbers.includes(system) && proportion && proportion !== 0);
  }

  setHeatingMainSystemsValue(heatingObjectName: string): void {
    if (this.eeHeating.mainSystem1System === '699' && this.eeHeating.mainSystem1Controls === '2699') {
      this.mainSystems = 'None installed';
    } else {
      const hasMainSystem1Data = this.hasHeatingMainSystemData(heatingObjectName, 'mainSystem1');
      const hasMainSystem2Data = this.hasHeatingMainSystemData(heatingObjectName, 'mainSystem2');
      if (hasMainSystem1Data && hasMainSystem2Data && this.hasNoMainSystem2DHWData(heatingObjectName)) {
        this.mainSystems = '2 Main systems';
      } else if (hasMainSystem1Data && hasMainSystem2Data) {
        this.mainSystems = '1 Main system + 1 DHW only';
      } else if (hasMainSystem1Data) {
        this.mainSystems = '1 Main system';
      }
    }
  }

  renewablesHasArrayData(renewableEnergyObjectName: string, array: string): boolean {
    const renewableEnergyObject = this[renewableEnergyObjectName];
    return (
      renewableEnergyObject[`${array}Pitch`] != null || (renewableEnergyObject[`${array}Orientation`] != null &&
      renewableEnergyObject[`${array}Pitch`] != null) || renewableEnergyObject[`${array}Overshading`] != null ||
      (renewableEnergyObject[`${array}KWP`] != null && renewableEnergyObject[`${array}KWP`] !== 0)
    );
  }

  setSolarWaterHeaterCollectorDetailsKnown(renewableEnergyObjectName: string): void {
    if (this[renewableEnergyObjectName].solarWaterHeaterCollectorType === this.keyedLookUpCodes['CollectorType']['Flat plate']) {}
  }

  setSolarWaterHeaterStoreDetailsKnown(renewableEnergyObjectName: string): void {
    if (!this[renewableEnergyObjectName].solarWaterHeaterStoreVolumeDetailsKnown &&
      (this[renewableEnergyObjectName].solarWaterHeaterDedicatedSolarVolume != null ||
        this[renewableEnergyObjectName].solarWaterHeaterTotalCylenderVolume != null)
    ) {
      this[renewableEnergyObjectName].solarWaterHeaterStoreVolumeDetailsKnown = false;
    }
  }

  setRenewablesNumberOfTurbines(renewableEnergyObjectName: string): void {
    if (this.keyedLookUpCodes && this.keyedLookUpCodes['WindTurbines'] && (this[renewableEnergyObjectName].numberOfTurbines == null || this[renewableEnergyObjectName].numberOfTurbines === 0)) {
      this[renewableEnergyObjectName].numberOfTurbines = this.keyedLookUpCodes['WindTurbines']['None'];
    }
  }

  setFlueGasHeatRecovery(renewableEnergyObjectName: string, heatingObjectName: string): void {
    const heatingObject = this[heatingObjectName];
    const renewableEnergyObject = this[renewableEnergyObjectName];
    if (heatingObject.mainSystem1HasFGHRS === 'Y' && (!heatingObject.mainSystem2HasFGHRS || heatingObject.mainSystem2HasFGHRS === 'N')) {
      renewableEnergyObject.fghrHeatingSystem1ID = 'Main system 1 only';
    } else if (
      (!heatingObject.mainSystem1HasFGHRS || heatingObject.mainSystem1HasFGHRS === 'N') && heatingObject.mainSystem2HasFGHRS === 'Y') {
      renewableEnergyObject.fghrHeatingSystem1ID = 'Main system 2 only';
    } else if (heatingObject.mainSystem1HasFGHRS === 'Y' && heatingObject.mainSystem2HasFGHRS === 'Y') {
      renewableEnergyObject.fghrHeatingSystem1ID = 'Main systems 1 and 2';
    } else {
      renewableEnergyObject.fghrHeatingSystem1ID = 'None';
    }
  }

  setWasteWaterHeatRecovery(renewableEnergyObjectName: string): void {
    const renewableEnergyObject: RdSAPRenewablesRecoveryUIDTOV0 = this[renewableEnergyObjectName];
    if (renewableEnergyObject.wwhsrs1ID != null && renewableEnergyObject.wwhsrs1ID == null) {
      this.wasteWaterHeatRecovery = 'Instantaneous (1 system)';
    } else if (renewableEnergyObject.wwhsrs1ID != null && renewableEnergyObject.wwhsrs1ID != null) {
      this.wasteWaterHeatRecovery = 'Instantaneous (2 systems)';
    } else if (this.hasStorageWasteWaterHeatRecovery(renewableEnergyObject)) {
      this.wasteWaterHeatRecovery = 'Storage';
    } else {
      this.wasteWaterHeatRecovery = 'None';
    }
  }

  private hasStorageWasteWaterHeatRecovery(renewableEnergyObject: any): boolean {
    return Boolean(
      renewableEnergyObject.wWHSRSStorageID || renewableEnergyObject.wWHSRSStorageMake ||
      renewableEnergyObject.wWHSRSStorageModel || renewableEnergyObject.wWHSRSStorageEfficiency ||
      (renewableEnergyObject.wWHSRSStorageTotalShowersAndBaths && renewableEnergyObject.wWHSRSStorageTotalShowersAndBaths !== 0) ||
      (renewableEnergyObject.wWHSRSStorageShowersAndBathsToWWHRS && renewableEnergyObject.wWHSRSStorageShowersAndBathsToWWHRS !== 0) ||
      (renewableEnergyObject.wWHSRSStorageVolume && renewableEnergyObject.wWHSRSStorageVolume !== 0)
    );
  }

  setSelectedTab(params?: any): void {
    const tabParam = params?.['tab'];
    if (tabParam) {
      const requestedTabName = tabParam.toLowerCase().trim();
      const selectedSectionIndex = this.tabDetails.findIndex((x) => x.toLowerCase() === requestedTabName);
      if (selectedSectionIndex !== -1) {
        this.selectedTabIndex = selectedSectionIndex;
      } else {
        if (requestedTabName.startsWith('extension')) {
          this.selectedTabIndex = this.tabDetails.findIndex((x) => x.toLowerCase() === 'main building');
        }
      }
    }
  }

  private initializeTabDetails(): void {
    this.route.queryParams.subscribe((params) => {
      const tabParam = params?.['tab'];
      if (tabParam) {
        const requestedTabName = tabParam.toLowerCase().trim();
        const selectedSectionIndex = this.tabDetails.findIndex((x) => x.toLowerCase() === requestedTabName);
        if (selectedSectionIndex !== -1) {
          this.selectedTabIndex = selectedSectionIndex;
        } else {
          if (requestedTabName.startsWith('extension')) {
            this.selectedTabIndex = this.tabDetails.findIndex((x) => x.toLowerCase() === 'main building');
          }
        }
      }
    });
  }

  getAndSetRdSAPDetails() {
    this.loading = true;
    this.rdSAPDetails$.pipe(
        catchError((error) => {
          this.loading = false;
          return throwError(() => error);
        })
      ).subscribe((data) => {
        if (!data || !data.length) {
          this.loading = false;
          return;
        }
        this.activeDataset = cloneDeep(data[0]);
        this.details = cloneDeep(data[0]);
        this.propertyAddress = `${data[0].general.address.addressLine1 ? data[0].general.address.addressLine1 + ',' : ''}
        ${data[0].general.address.addressLine2 ? data[0].general.address.addressLine2 + ',' : ''}
        ${data[0].general.address.addressLine3 ? data[0].general.address.addressLine3 + ',' : ''}
        ${data[0].general.address.postalTown.charAt(0).toUpperCase()}${data[0].general.address.postalTown.slice(1).toLowerCase() + ',' || ''}
        ${data[0].general.address.postalCode || ''}`;
        this.setActiveDataSetRatingInfo(this.activeDataset.results as RdSAPResultsDetailUIDTOV0);
        this.eeStatusDetails = this.details.results ?? {};
        this.eeGeneralDetails = this.details.general ?? {};
        this.eeGeneralDetails.addendum = this.details.general?.addendum ?? {};
        this.eeGenericDetails = this.details.generic ?? {};
        this.sapSpecialFeatures = this.details.sapSpecialFeatures ?? [];
        this.eeGenericDetails.countryCode = this.eeGeneralDetails.address.countryCode;
        this.eeGeneralDetails.previousEpcCheckedCode = 'Y';
        this.setActiveDataSetJsonData(this.activeDataset);
        this.updateEeRRLookupCodesWithCountryCodeSpecificLookupItems(this.eeGeneralDetails.address.countryCode);
        this.eeOpeningDetails = this.details.opening ?? {};
        this.eeHeating = this.details.heating ?? {};
        this.eeHeating.mainSystem2HeatingProportion = this.eeHeating.mainSystem2HeatingProportion ?? 0;
        if (this.eeHeating.mainSystem1PCDFId) {
          const pcdb = rdsapPCDBData.data.pcdf.find((pcdbData) => Number(pcdbData.id) === this.eeHeating.mainSystem1PCDFId);
          if (pcdb) {
            (this.eeHeating as any).mainSystem1PCDFModel = pcdb.modelName;
            (this.eeHeating as any).mainSystem1PCDFQualifier = pcdb.modelQualifier;
            (this.eeHeating as any).mainSystem1PCDFBoilerId = pcdb.boilerId;
            (this.eeHeating as any).mainSystem1PCDFManufacturer = pcdb.brandName;
            (this.eeHeating as any).mainSystem1HeatingType = this.keyedLookUpCodes['HeatingType'][pcdb.type];
            (this.eeHeating as any).mainSystem1FanAssisted = pcdb.fanAssistance !== '2' ? false : true;
            this.setHeatingControls('mainSystem1');
            this.setFlueTypeArrays('mainSystem1');
          }
        }
        if (this.eeHeating.mainSystem2PCDFId) {
          const pcdb = rdsapPCDBData.data.pcdf.find((pcdbData) => Number(pcdbData.id) === this.eeHeating.mainSystem2PCDFId);
          if (pcdb) {
            (this.eeHeating as any).mainSystem2PCDFModel = pcdb.modelName;
            (this.eeHeating as any).mainSystem2PCDFQualifier = pcdb.modelQualifier;
            (this.eeHeating as any).mainSystem2PCDFBoilerId = pcdb.boilerId;
            (this.eeHeating as any).mainSystem2PCDFManufacturer = pcdb.brandName;
            (this.eeHeating as any).mainSystem2HeatingType = this.keyedLookUpCodes['HeatingType'][pcdb.type];
            (this.eeHeating as any).mainSystem2FanAssisted = pcdb.fanAssistance !== '2' ? false : true;
            this.setHeatingControls('mainSystem2');
            this.setFlueTypeArrays('mainSystem2');
          }
        }
        this.resultMain1 = this.resultMain2 = this.pcdbSearchManualServiceMain.viewPcdbStorageHeatersData();
        if (this.eeHeating.mainSystem1StorageHeaters) {
          this.resultMain1.forEach((element, key) => {
            this.mainSystem1StorageHeaters[key] = {};
            this.mainSystem1StorageHeaters[key].key = key;
            this.mainSystem1StorageHeaters[key].value = element;
            this.mainSystem1StorageHeaters[key].hhrshsystem = 'mainSystem1';
            if (this.eeHeating.mainSystem1StorageHeaters) {
              this.eeHeating.mainSystem1StorageHeaters.forEach((el, k) => {
                if (this.eeHeating.mainSystem1StorageHeaters[k].indexNumber && this.eeHeating.mainSystem1StorageHeaters[k].indexNumber == this.mainSystem1StorageHeaters[key].value.id) {
                  this.mainSystem1StorageHeaters[key].numberOfHeaters = this.eeHeating.mainSystem1StorageHeaters[k].numberOfHeaters || null;
                  this.mainSystem1StorageHeaters[key].selected = true;
                }
              });
            }
          });
        }
        if (this.eeHeating.mainSystem2StorageHeaters) {
          if (this.eeHeating.mainSystem2StorageHeaters) {
            this.resultMain2.forEach((element, key) => {
              this.mainSystem2StorageHeaters[key] = {};
              this.mainSystem2StorageHeaters[key].key = key;
              this.mainSystem2StorageHeaters[key].value = element;
              this.mainSystem2StorageHeaters[key].hhrshsystem = 'mainSystem2';
              if (this.eeHeating.mainSystem2StorageHeaters) {
                this.eeHeating.mainSystem2StorageHeaters.forEach((el, k) => {
                  if (this.eeHeating.mainSystem2StorageHeaters[k].indexNumber && this.eeHeating.mainSystem2StorageHeaters[k].indexNumber == this.mainSystem2StorageHeaters[key].value.id) {
                    this.mainSystem2StorageHeaters[key].numberOfHeaters = this.eeHeating.mainSystem2StorageHeaters[k].numberOfHeaters || null;
                    this.mainSystem2StorageHeaters[key].selected = true;
                  }
                });
              }
            });
          }
        }
        this.updateMainSystem1Proportion();
        this.eeRR = this.details.renewables ?? {};
        this.eeRR.swhConfiguration = this.details.renewables.swhConfiguration ?? this.swhConfigurations?.[0]?.value;
        this.windTurbinesDetailsKnown = this.eeRR.rotorDiameter || this.eeRR.hubHeight ? true : false;
        this.eeRecommendations = this.details.recommendations ?? {};
        this.previousEPCReasonChange(this.eeGeneralDetails.previousEpcReasonCode);
        const getBuildingPart = (index) => {
          if (this.details.buildingParts && this.details.buildingParts.length > index) {
            this.showBuildingExtensions['extension' + index] = true;
            return this.details.buildingParts[index] || {};
          }
          this.showBuildingExtensions['extension' + index] = false;
          return { buildingPartNumber: index + 1 };
        };
        this.eeBDMainBuilding = this.details.buildingParts && this.details.buildingParts.length ? this.details.buildingParts[0] : { buildingPartNumber: 1 };
        this.eeBDEx1 = getBuildingPart(1);
        this.eeBDEx2 = getBuildingPart(2);
        this.eeBDEx3 = getBuildingPart(3);
        this.eeBDEx4 = getBuildingPart(4);
        this.showAdditionalWall = {
          eeBDMainBuilding: this.hasAdditionalWallData('eeBDMainBuilding'),
          eeBDEx1: this.hasAdditionalWallData('eeBDEx1'),
          eeBDEx2: this.hasAdditionalWallData('eeBDEx2'),
          eeBDEx3: this.hasAdditionalWallData('eeBDEx3'),
          eeBDEx4: this.hasAdditionalWallData('eeBDEx4'),
        };
        this.showAdditionalWall2 = {
          eeBDMainBuilding: this.hasAdditionalWallData('eeBDMainBuilding'),
          eeBDEx1: this.hasAdditionalWallData('eeBDEx1'),
          eeBDEx2: this.hasAdditionalWallData('eeBDEx2'),
          eeBDEx3: this.hasAdditionalWallData('eeBDEx3'),
          eeBDEx4: this.hasAdditionalWallData('eeBDEx4'),
        };
        this.showRoofRoom = {
          eeBDMainBuilding: this.hasRoofRoomData('eeBDMainBuilding'),
          eeBDEx1: this.hasRoofRoomData('eeBDEx1'),
          eeBDEx2: this.hasRoofRoomData('eeBDEx2'),
          eeBDEx3: this.hasRoofRoomData('eeBDEx3'),
          eeBDEx4: this.hasRoofRoomData('eeBDEx4'),
        };
        const storedState = localStorage.getItem('heatedBasement');
        if (storedState !== null) {
          this.heatedBasement = JSON.parse(storedState);
        }
        this.secondaryHeating = this.eeHeating.secoundaryHeatingFuel !== null || this.eeHeating.secoundaryHeatingSystem !== null ? true : false;
        this.setHeatingMainSystemsValue('eeHeating');
        this.setSolarWaterHeaterCollectorDetailsKnown('eeRR');
        this.setRenewablesNumberOfTurbines('eeRR');
        this.setFlueGasHeatRecovery('eeRR', 'eeHeating');
        this.setWasteWaterHeatRecovery('eeRR');
        this.updateBuildingExtensions();
        this.setBuildingHeatLoss();
        this.form.reset();
        this.initializeTabDetails();
        this.loading = false;
      });
  }

  updateMainSystem1Proportion() {
    this.eeHeating.mainSystem1HeatingProportion = 100 - this.eeHeating.mainSystem2HeatingProportion;
  }

  onWindTurbinesDetailsKnownChange() {
    if (!this.windTurbinesDetailsKnown) {
      this.eeRR.rotorDiameter = null;
      this.eeRR.hubHeight = null;
    }
  }

  changePartyWallConstruction() {
    if (this.eeGeneralDetails.builtForm === this.keyedLookUpCodes['BuiltForm']['Detached']) {
      this.eeBDMainBuilding.partyWallConstruction = this.keyedLookUpCodes['PartyWallConstruction']['Not applicable'];
      this.eeBDEx1.partyWallConstruction = this.keyedLookUpCodes['PartyWallConstruction']['Not applicable'];
      this.eeBDEx2.partyWallConstruction = this.keyedLookUpCodes['PartyWallConstruction']['Not applicable'];
      this.eeBDEx3.partyWallConstruction = this.keyedLookUpCodes['PartyWallConstruction']['Not applicable'];
      this.eeBDEx4.partyWallConstruction = this.keyedLookUpCodes['PartyWallConstruction']['Not applicable'];
    }
  }

  resetHeatingMainSystemData(heatingSystem) {
    this.eeHeating[`${heatingSystem}SystemType`] = undefined;
    this.eeHeating[`${heatingSystem}SystemSubType`] = undefined;
    this.eeHeating[`${heatingSystem}Fuel`] = undefined;
    this.eeHeating[`${heatingSystem}PCDFId`] = undefined;
    this.eeHeating[`${heatingSystem}PCDFMake`] = undefined;
    this.eeHeating[`${heatingSystem}PCDFModel`] = undefined;
    this.eeHeating[`${heatingSystem}PCDFEfficiency`] = undefined;
    this.eeHeating[`${heatingSystem}PCDFManufacturer`] = undefined;
    this.eeHeating[`${heatingSystem}System`] = undefined;
    this.eeHeating[`${heatingSystem}Controls`] = undefined;
    this.eeHeating[`${heatingSystem}FlueType`] = undefined;
    this.eeHeating[`${heatingSystem}Emitter`] = undefined;
    this.eeHeating[`${heatingSystem}PumpAge`] = undefined;
    this.eeHeating[`${heatingSystem}FlowTemp`] = undefined;
  }

  resetSolarWaterHeatingCollectorDetails() {
    this.eeRR.solarWaterHeaterCollectorType = null;
    this.eeRR.solarWaterHeaterAreaOfPanel = null;
    this.eeRR.solarWaterHeaterZeroLossEfficiency = null;
    this.eeRR.solarWaterHeaterLinearHeatLossCoefficient = null;
    this.solarWaterHeatersecoundaryHeatLossCoefficient = null;
    this.solarWaterHeaterStoreVolumeDetailsKnown = false;
    this.eeRR.solarWaterHeaterDedicatedSolarVolume = null;
    this.eeRR.solarWaterHeaterTotalCylenderVolume = null;
    this.eeRR.combinedCylinder = false;
  }

  resetSolarWaterHeatingDetails() {
    this.eeRR.solarWaterHeaterPitch = null;
    this.eeRR.solarWaterHeaterOrientation = null;
    this.eeRR.solarWaterHeaterOvershading = null;
    this.eeRR.solarWaterHeaterShowerTypes = null;
    this.eeRR.solarWaterHeaterCirculatingPump = null;
    this.resetSolarWaterHeatingCollectorDetails();
  }

  resetWaterHeatingCylinderDetails() {
    this.eeHeating.cylinderDetailsInsulation = null;
    this.eeHeating.cylinderDetailsThickness = null;
    this.eeHeating.cylinderDetailsImmersion = 'NA';
  }

  resetPvArrayData(arrays, resetOnlyRoofData) {
    if (resetOnlyRoofData) {
      this.eeRR.pvConnectedToMeter = null;
      this.eeRR.percentageOfRoofCovered = null;
    }
    forEach(arrays, (array) => {
      this.eeRR[`array${array}Pitch`] = null;
      this.eeRR[`array${array}Orientation`] = null;
      this.eeRR[`array${array}Overshading`] = null;
      this.eeRR[`array${array}KWP`] = null;
      this.eeRR[`array${array}ConnectedToMeter`] = null;
    });
  }

  onRoofRoomChangeMainBuilding() {
    if (!this.showRoofRoom.eeBDMainBuilding) {
      this.resetRoofRoomDataMainBuilding();
    } else { 
      this.eeBDMainBuilding.roofRoomsAdjoining = (!this.eeBDMainBuilding?.roofRoomsAdjoining) ? false : this.eeBDMainBuilding.roofRoomsAdjoining;
    }
  }
  
  resetRoofRoomDataMainBuilding() {
    const mainBuildingPart = this.eeBDMainBuilding;
    if (mainBuildingPart) {
      mainBuildingPart.roofRoomsArea = null;
      mainBuildingPart.roofRoomsAge = null;
      mainBuildingPart.roofRoomsThickness = null;
      mainBuildingPart.roofRoomsInsulation = null;
      mainBuildingPart.slopeOneArea = null;
      mainBuildingPart.slopeOneUValue = null;
      mainBuildingPart.studWallOneArea = null;
      mainBuildingPart.roofRoomsAdjoining = false;
      mainBuildingPart.flatCeilingOneArea = null;
      mainBuildingPart.slopeTwoUValue = null;
      mainBuildingPart.studWallOneUValue = null;
      mainBuildingPart.gableWallOneArea = null;
      mainBuildingPart.gableWallOneUValue = null;
      mainBuildingPart.flatCeilingTwoArea = null;
      mainBuildingPart.flatCeilingTwoUValue = null;
      mainBuildingPart.slopeTwoArea = null;
      mainBuildingPart.slopeTwoUValue = null;
      mainBuildingPart.studWallTwoArea = null;
      mainBuildingPart.studWallTwoUValue = null;
      mainBuildingPart.gableWallTwoUValue = null;
      (mainBuildingPart.roofRoomsAge = null),
      (mainBuildingPart.gableWallOneArea = null),
      (mainBuildingPart.gableWallOneUValue = null),
      (mainBuildingPart.gableWallTwoArea = null),
      (mainBuildingPart.gableWallTwoUValue = null),
      (mainBuildingPart.gableWallOneUValue = null);
      mainBuildingPart.flatCeilingOneUValue = null;
      mainBuildingPart.slopeTwoUValue = null;
      mainBuildingPart.studWallOneUValue = null;
      mainBuildingPart.gableWallTwoArea = null;
      mainBuildingPart.gableWallOneUValue = null;
    }
  }

  onRoofRoomChange(buildingNumber: number) {
    const buildingPart = (buildingNumber - 1);
    if (!this.showRoofRoom[`eeBDEx${buildingPart}`]) {
      this.resetRoofRoomData(buildingNumber);
    } else {
      this[`eeBDEx${buildingPart}`].roofRoomsAdjoining = (!this[`eeBDEx${buildingPart}`]?.roofRoomsAdjoining) ? false : this[`eeBDEx${buildingPart}`].roofRoomsAdjoining;
    }
  }
  
  resetRoofRoomData(buildingNumber: number) {
    const buildingPart = this.details.buildingParts[buildingNumber - 1];
    if (buildingPart) {
      buildingPart.roofRoomsArea = null;
      buildingPart.roofRoomsAge = null;
      buildingPart.roofRoomsThickness = null;
      buildingPart.roofRoomsInsulation = null;
      buildingPart.slopeOneArea = null;
      buildingPart.slopeOneUValue = null;
      buildingPart.studWallOneArea = null;
      buildingPart.roofRoomsAdjoining = false;
      buildingPart.flatCeilingOneArea = null;
      buildingPart.slopeTwoUValue = null;
      buildingPart.studWallOneUValue = null;
      buildingPart.gableWallOneArea = null;
      buildingPart.gableWallOneUValue = null;
      buildingPart.flatCeilingTwoArea = null;
      buildingPart.flatCeilingTwoUValue = null;
      buildingPart.slopeTwoArea = null;
      buildingPart.slopeTwoUValue = null;
      buildingPart.studWallTwoArea = null;
      buildingPart.studWallTwoUValue = null;
      buildingPart.gableWallTwoUValue = null;
      (buildingPart.roofRoomsAge = null),
        (buildingPart.gableWallOneArea = null),
        (buildingPart.gableWallOneUValue = null),
        (buildingPart.gableWallTwoArea = null),
        (buildingPart.gableWallTwoUValue = null),
        (buildingPart.gableWallOneUValue = null);
      buildingPart.flatCeilingOneUValue = null;
      buildingPart.slopeTwoUValue = null;
      buildingPart.studWallOneUValue = null;
      buildingPart.gableWallTwoArea = null;
      buildingPart.gableWallOneUValue = null;
    }
  }

  resetOpeningsData() {
    if (this.eeOpeningDetails.coverage === this.keyedLookUpCodes['GlazingCoverage']['Much more than typical'] || this.eeOpeningDetails.coverage === this.keyedLookUpCodes['GlazingCoverage']['Much less than typical']) {
      this.eeOpeningDetails.glazingType = 'ND';
      this.eeOpeningDetails.upvcFramed = false;
      this.eeOpeningDetails.multiGlazing = null;
    }
    if (
      this.eeOpeningDetails.glazingType !== this.keyedLookUpCodes['Glazing Type']['Double glazed (before 2002)'] &&
      this.eeOpeningDetails.glazingType !== this.keyedLookUpCodes['Glazing Type']['Double glazed (before 2003)'] &&
      this.eeOpeningDetails.glazingType !== this.keyedLookUpCodes['Glazing Type']['Double glazed (unknown age)']
    ) {
      this.eeOpeningDetails.upvcFramed = false;
    }
    if (!this.eeOpeningDetails.upvcFramed) {
      this.eeOpeningDetails.glazingGap = null;
    }
    if (
      this.eeOpeningDetails.glazingType !== this.keyedLookUpCodes['Glazing Type']['Double glazed, data known'] &&
      this.eeOpeningDetails.glazingType !== this.keyedLookUpCodes['Glazing Type']['Triple glazed, data known']
    ) {
      this.eeOpeningDetails.UValue = null;
      this.eeOpeningDetails.GValue = null;
      this.eeOpeningDetails.windowTransmissionDataSource = null;
    }
  }

  rebuildDetails() {
    if (this.eeRR && this.eeRR.swhConfiguration === this.keyedSWHConfigurations['Solar water heating (details known)']) {
      this.eeRR.solarWaterHeatingPresent = true;
      this.solarWaterHeaterDetailsKnown = true;
    } else if (this.eeRR && this.eeRR.swhConfiguration === this.keyedSWHConfigurations['Solar water heating (details unknown)']) {
      this.eeRR.solarWaterHeatingPresent = true;
      this.solarWaterHeaterDetailsKnown = false;
      this.resetSolarWaterHeatingDetails();
    } else if (this.eeRR) {
      this.eeRR.solarWaterHeatingPresent = false;
      this.solarWaterHeaterDetailsKnown = false;
      this.resetSolarWaterHeatingDetails();
    } else if (this.eeGeneralDetails.propertyType !== this.keyedLookUpCodes['PropertyType']['Flat'] && this.eeGeneralDetails.propertyType !== this.keyedLookUpCodes['PropertyType']['Maisonette']) {
      this.eeGeneralDetails.flatType = null;
      this.eeGeneralDetails.locationInBlock = null;
      this.eeGeneralDetails.corridorType = null;
    }
    if (this.eeRR && this.solarWaterHeaterDetailsKnown && !this.solarWaterHeaterCollectorDetailsKnown) {
      this.resetSolarWaterHeatingCollectorDetails();
    }
    this.resetOpeningsData();
    if (this.mainSystems === 'None installed') {
      this.resetHeatingMainSystemData('mainSystem1');
      this.resetHeatingMainSystemData('mainSystem2');
    } else if (this.mainSystems === '1 Main system') {
      this.resetHeatingMainSystemData('mainSystem2');
    }
    if (!this.showWaterHeatingCylinderCard()) {
      this.eeHeating.cylinderDetailsSize = this.keyedLookUpCodes['CylinderSize']['No cylinder'];
      this.resetWaterHeatingCylinderDetails();
    } else if (
      this.eeHeating.cylinderDetailsSize === this.keyedLookUpCodes['CylinderSize']['No cylinder'] ||
      this.eeHeating.cylinderDetailsSize === this.keyedLookUpCodes['CylinderSize']['No access']
    ) {
      this.resetWaterHeatingCylinderDetails();
    }
    if (this.eeRR.pvConfiguration === this.keyedPVConfigurationsOptions['No PV system']) {
      this.resetPvArrayData([1, 2, 3], true);
    } else if (this.eeRR.pvConfiguration === this.keyedPVConfigurationsOptions['PV system (roof coverage only)']) {
      this.resetPvArrayData([1, 2, 3], false);
    } else if (this.eeRR.pvConfiguration === this.keyedPVConfigurationsOptions['3 PV Arrays (kWp known)']) {
      this.resetPvArrayData([], true);
    } else if (this.eeRR.pvConfiguration === this.keyedPVConfigurationsOptions['2 PV Arrays (kWp known)']) {
      this.resetPvArrayData([3], true);
    } else if (this.eeRR.pvConfiguration === this.keyedPVConfigurationsOptions['1 PV Array (kWp known)']) {
      this.resetPvArrayData([2, 3], true);
    }
    if (!this.secondaryHeating) {
      this.eeHeating.secoundaryHeatingFuel = null;
      this.eeHeating.secoundaryHeatingSystem = null;
    }
    if (this.eeHeating.mainSystem1SystemType === this.keyedLookUpCodes['PrimarySystemType']['Database']) {
      this.eeHeating.mainSystem1System = null;
    }
    if (this.eeHeating.mainSystem2SystemType === this.keyedLookUpCodes['PrimarySystemType']['Database']) {
      this.eeHeating.mainSystem2System = null;
    }
    if (this.eeGeneralDetails.corridorType !== this.keyedLookUpCodes['HeatlossCorridor']['Unheated']) {
      this.eeGeneralDetails.unheatedCorridorLength = null;
    }
    this.details.results = isEqual(this.eeStatusDetails, {}) ? null : this.eeStatusDetails;
    this.details.general = isEqual(this.eeGeneralDetails, {}) ? null : this.eeGeneralDetails;
    this.details.general.postCode = '12345'; 
    this.details.opening = isEqual(this.eeOpeningDetails, {}) ? null : this.eeOpeningDetails;
    this.details.heating = isEqual(this.eeHeating, {}) ? null : this.eeHeating;
    this.details.renewables = isEqual(this.eeRR, {}) ? null : this.eeRR;
    this.details.buildingParts = [];
    this.details.buildingParts[0] = this.eeBDMainBuilding;
    switch (this.eeGeneralDetails.buildingConfiguration) {
      case this.keyedLookUpCodes['Extensions']['1']:
        this.details.buildingParts[1] = this.eeBDEx1;
        this.eeBDEx2 = this.eeBDEx3 = this.eeBDEx4 = {};
        break;
      case this.keyedLookUpCodes['Extensions']['2']:
        this.details.buildingParts[1] = this.eeBDEx1;
        this.details.buildingParts[2] = this.eeBDEx2;
        this.eeBDEx3 = this.eeBDEx4 = {};
        break;
      case this.keyedLookUpCodes['Extensions']['3']:
        this.details.buildingParts[1] = this.eeBDEx1;
        this.details.buildingParts[2] = this.eeBDEx2;
        this.details.buildingParts[3] = this.eeBDEx3;
        this.eeBDEx4 = {};
        break;
      case this.keyedLookUpCodes['Extensions']['4']:
        this.details.buildingParts[1] = this.eeBDEx1;
        this.details.buildingParts[2] = this.eeBDEx2;
        this.details.buildingParts[3] = this.eeBDEx3;
        this.details.buildingParts[4] = this.eeBDEx4;
        break;
    }
    const originalBuildingParts = [
      'eeBDMainBuilding',
      'eeBDEx1',
      'eeBDEx2',
      'eeBDEx3',
      'eeBDEx4',
    ];
    this.details.buildingParts.forEach(function (buildingPart: RdSAPBuildingPartUIDTOV0, index) {
      if (!((this.eeGeneralDetails.propertyType === this.keyedLookUpCodes['PropertyType']['Flat'] ||
          this.eeGeneralDetails.propertyType === this.keyedLookUpCodes['PropertyType']['Maisonette']) &&
          this.eeGeneralDetails.corridorType === this.keyedLookUpCodes['HeatlossCorridor']['Unheated'])) {
            buildingPart.shelteredWall = false;
      }
      if (!this.showAdditionalWall[originalBuildingParts[index]]) {
        buildingPart.additionalWallsConstruction = null;
        buildingPart.additionalWallsInsulationType = null;
        buildingPart.additionalWallsInsulationThickness = null;
        buildingPart.additionalWallsWallThickness = null;
        buildingPart.additionalWallWallArea = null;
        buildingPart.additionalWallThicknessMeasured = null;
        buildingPart.additionalWallsUValue = null;
        buildingPart.additionalWallUValueKnown = false;
        buildingPart.additionalWallsDryLined = false;
        buildingPart.shelteredWall = false;
      }
      if (buildingPart.dimensionsArray && buildingPart.partyWallConstruction === this.keyedLookUpCodes['PartyWallConstruction']['Not applicable']) {
        buildingPart.dimensionsArray.forEach(function (dimension) {
          dimension.partyWall = 0;
        });
      }
      if (!buildingPart.additionalWallUValueKnown) buildingPart.additionalWallsUValue = null;
      if (!buildingPart.uValueknown) buildingPart.wallsUValue = null;
      if (!buildingPart.roofUValueKnown) buildingPart.roofUValue = null;
      if (!buildingPart.floorUValueKnown) buildingPart.floorUValue = null;
      const buildingPartName = index === 0 ? 'eeBDMainBuilding' : `eeBDEx${index}`;
      if (buildingPart.shelteredWall) buildingPart.additionalWallWallArea = this.calculateBuildingPartAdditionalWallArea(buildingPartName);
    });
  }

  cleanupConservatory(general: RdSAPGeneralDetailUIDTOV0) {
    if (general.conservationType !== this.keyedLookUpCodes['ConservatoryType']['Non-separated']) {
      general.doubleGlazed = null;
      general.floorArea = null;
      general.glazedPerimiter = null;
      general.conservatoryHeight = null;
    }
    return general;
  }

  cleanupUnheatedCorridor(general: RdSAPGeneralDetailUIDTOV0) {
    if (general.corridorType !== this.keyedLookUpCodes['HeatlossCorridor']['Unheated']) {
      general.unheatedCorridorLength = null;
    }
    return general;
  }

  cleanupPropertyType(general: RdSAPGeneralDetailUIDTOV0) {
    if (general.propertyType !== this.keyedLookUpCodes['PropertyType']['Flat'] && general.propertyType !== this.keyedLookUpCodes['PropertyType']['Maisonette']) {
      general.flatType = null;
      general.locationInBlock = null;
      general.flatType = null;
      general.locationInBlock = null;
      general.corridorType = null;
      (general as any).heatLossBuilding = null;
      general.unheatedCorridorLength = null;
    }
    return general;
  }

  cleanupOpeningCoverage(opening: RdSAPOpeningDetailUIDTOV0) {
    if (!(opening.coverage == this.keyedLookUpCodes['GlazingCoverage']['Typical'] ||
        opening.coverage == this.keyedLookUpCodes['GlazingCoverage']['More than typical'] ||
        opening.coverage == this.keyedLookUpCodes['GlazingCoverage']['Less than typical'])
    ) {
      opening.multiGlazing = null;
      opening.glazingType = null;
      opening.upvcFramed = null;
      opening.glazingGap = null;
      opening.UValue = null;
      opening.GValue = null;
      opening.windowTransmissionDataSource = null;
    }
    return opening;
  }

  cleanupPVCFramesCondition(opening: RdSAPOpeningDetailUIDTOV0) {
    if (!(opening.glazingType == this.keyedLookUpCodes['Glazing Type']['Double glazed (before 2002)'] ||
        opening.glazingType == this.keyedLookUpCodes['Glazing Type']['Double glazed (before 2003)'] ||
        opening.glazingType == this.keyedLookUpCodes['Glazing Type']['Double glazed (unknown age)'])) {
          opening.upvcFramed = null;
    }
    if (!opening.upvcFramed) {
      opening.glazingGap = null;
    }
    return opening;
  }

  cleanupUValueGValueCondition(opening: RdSAPOpeningDetailUIDTOV0) {
    if (!(opening.glazingType == this.keyedLookUpCodes['Glazing Type']['Double glazed, data known'] ||
        opening.glazingType == this.keyedLookUpCodes['Glazing Type']['Triple glazed, data known'])) {
      opening.UValue = null;
      opening.GValue = null;
      opening.windowTransmissionDataSource = null;
    }
    return opening;
  }

  cleanupBuildingAdditionalWallThickness(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (!buildingParts.additionalWallThicknessMeasured) {
      buildingParts.additionalWallsWallThickness = null;
    }
    return buildingParts;
  }

  cleanupRoofRoomCondition(buildingParts: RdSAPBuildingPartUIDTOV0, index: number) {
    const originalBuildingParts = [
      'eeBDMainBuilding',
      'eeBDEx1',
      'eeBDEx2',
      'eeBDEx3',
      'eeBDEx4',
    ];
    if (!this.showRoofRoom[originalBuildingParts[index]]) {
      buildingParts.roofRoomsArea = null;
      buildingParts.roofRoomsAge = null;
      buildingParts.roofRoomsInsulation = null;
      buildingParts.roofRoomsThickness = null;
      buildingParts.roofRoomsAdjoining = false;
    }
    return buildingParts;
  }
  
  cleanupWallThicknessMeasuredCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (!buildingParts.wallThicknessMeasured) {
      buildingParts.wallsWallThickness = null;
    }
    return buildingParts;
  }
  
  cleanupCavityWallInsulationTypeCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.wallsConstruction !== this.keyedLookUpCodes['WallConstruction']['Cavity']) {
      buildingParts.wallsInsulationType = null;
    }
    return buildingParts;
  }

  cleanupNonCavityWallInsulationTypeCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.wallsConstruction === this.keyedLookUpCodes['WallConstruction']['Cavity']) {
      buildingParts.wallsInsulationType = null;
    }
    return buildingParts;
  }
  
  cleanupWallInsulationThicknessCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.wallsInsulationType === this.keyedLookUpCodes['WallInsulation']['As built'] ||
      buildingParts.wallsInsulationType === this.keyedLookUpCodes['WallInsulation']['Filled cavity']) {
      buildingParts.wallsInsulationThickness = null;
    }
    return buildingParts;
  }

  cleanupWallUValueKnownCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (!buildingParts.uValueknown) {
      buildingParts.wallsUValue = null;
    }
    return buildingParts;
  }

  cleanupAlternativeWallCavityInsulationTypeCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.additionalWallsConstruction !== this.keyedLookUpCodes['WallConstruction']['Cavity']) {
      buildingParts.additionalWallsInsulationType = null;
    }
    return buildingParts;
  }
  
  cleanupAlternativeWallNonCavityInsulationTypeCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.additionalWallsConstruction === this.keyedLookUpCodes['WallConstruction']['Cavity']) {
      buildingParts.additionalWallsInsulationType = null;
    }
    return buildingParts;
  }

  cleanupAlternativeWallInsulationThicknessCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.additionalWallsInsulationType === this.keyedLookUpCodes['WallInsulation']['As built'] ||
      buildingParts.additionalWallsInsulationType === this.keyedLookUpCodes['WallInsulation']['Filled cavity'] ||
      buildingParts.additionalWallsInsulationType === this.keyedLookUpCodes['WallInsulation']['Unknown']) {
      buildingParts.additionalWallsInsulationThickness = null;
    }
    return buildingParts;
  }

  cleanupAlternativeWallUValueKnownCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (!buildingParts.additionalWallUValueKnown) {
      buildingParts.additionalWallsUValue = null;
    }
    return buildingParts;
  }

  cleanupFloorHeatLossTypeCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.floorHeatLossType === this.keyedLookUpCodes['FloorHeatloss']['Same dwelling below'] ||
      buildingParts.floorHeatLossType === this.keyedLookUpCodes['FloorHeatloss']['Above a partially heated space[commercial premises]'] ||
      buildingParts.floorHeatLossType === this.keyedLookUpCodes['FloorHeatloss']['Another dwelling below']) {
      buildingParts.floorConstruction = null;
      buildingParts.floorInsulationType = null;
      buildingParts.floorInsulationThickness = null;
      buildingParts.floorUValueKnown = null;
      buildingParts.floorUValue = null;
    }
    return buildingParts;
  }

  cleanupFloorInsulationThicknessCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.floorInsulationType !== this.keyedLookUpCodes['FloorInsulation']['Retro-fitted']) {
      buildingParts.floorInsulationThickness = null;
    }
    return buildingParts;
  }

  cleanupFloorUValueKnownCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (!buildingParts.floorUValueKnown) {
      buildingParts.floorUValue = null;
    }
    return buildingParts;
  }

  cleanupRoofInsulationTypeCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Same dwelling above'] ||
      buildingParts.roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Another dwelling above']) {
      buildingParts.roofInsulationType = null;
      buildingParts.roofInsulationThickness = null;
    }
    return buildingParts;
  }

  cleanupRoofInsulationThicknessCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['None'] ||
      buildingParts.roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['Unknown']) {
      buildingParts.roofInsulationThickness = null;
    }
    return buildingParts;
  }

  cleanupRoofUValueKnownCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Same dwelling above'] ||
      buildingParts.roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Another dwelling above']) {
      buildingParts.roofUValueKnown = null;
      buildingParts.roofUValue = null;
    }
    return buildingParts;
  }

  cleanupRoofUValueCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (!buildingParts.roofUValueKnown) {
      buildingParts.roofUValue = null;
    }
    return buildingParts;
  }

  cleanupRoofRoomInsulationThicknessCondition(buildingParts: RdSAPBuildingPartUIDTOV0) {
    if (buildingParts.roofRoomsInsulation ===this.keyedLookUpCodes['RoofRoomInsulationType']['As built'] ||
      buildingParts.roofRoomsInsulation === this.keyedLookUpCodes['RoofRoomInsulationType']['Unknown']) {
      buildingParts.roofRoomsThickness = null;
    }
    return buildingParts;
  }

  cleanupSecondaryHeatingCondition(heating: RdSAPHeatingUIDTOV0) {
    if (!this.secondaryHeating) {
      heating.secoundaryHeatingFuel = null;
      heating.secoundaryHeatingSystem = null;
    }
    return heating;
  }
  
  cleanupMainSystem1CommunityHeatingCondition(heating: RdSAPHeatingUIDTOV0) {
    if (this.mainSystems === 'None installed') {
      heating.mainSystem1Fuel = '29';
      heating.mainSystem1SystemSubType = '1';
      heating.mainSystem1SystemType = '2';
      heating.mainSystem1System = '699';
      heating.mainSystem1Controls = '2699';
      heating.mainSystem1WeatherCompensation = null;
      heating.mainSystem1FlueType = null;
      heating.mainSystem1FanAssisted = null;
      heating.mainSystem1Emitter = null;
      heating.mainSystem1PumpAge = null;
      heating.mainSystem1FlowTemp = null;
      heating.mainSystem1MCSInstalled = null;
    } else if (this.mainSystems === '1 Main System') {
      heating.mainSystem1Fuel = null;
      heating.mainSystem1SystemSubType = null;
      heating.mainSystem1SystemType = null;
      heating.mainSystem1System = null;
      heating.mainSystem1Controls = null;
    }
    return heating;
  }

  cleanupMainSystem1SystemTypeDatabaseCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.mainSystem1SystemType !== this.keyedLookUpCodes['PrimarySystemType']['Database']) {
      (heating as any).mainSystem1PCDFId = null;
    }
    return heating;
  }

  cleanupMainSystem1SystemTypeNotDatabaseCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.mainSystem1SystemType === this.keyedLookUpCodes['PrimarySystemType']['Database']) {
      heating.mainSystem1System = null;
    }
    return heating;
  }

  cleanupMainSystem1FlueTypeCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.mainSystem1Fuel === this.keyedLookUpCodes['HeatingFuel']['Electricity']) {
      heating.mainSystem1FlueType = null;
    }
    return heating;
  }

  cleanupMainSystem1FanAssistedCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.mainSystem1Fuel === this.keyedLookUpCodes['HeatingFuel']['Electricity']) {
      heating.mainSystem1FanAssisted = null;
    }
    return heating;
  }

  cleanupMainSystem2Condition(heating: RdSAPHeatingUIDTOV0) {
    if (this.mainSystems === 'None installed' || this.mainSystems === '1 Main system') {
      heating.mainSystem2HeatingProportion = null;
      heating.mainSystem2Fuel = null;
      heating.mainSystem2SystemType = null;
      (heating as any).mainSystem2PCDFId = null;
      heating.mainSystem2SystemSubType = null;
      heating.mainSystem2System = null;
      heating.mainSystem2Controls = null;
      heating.mainSystem2WeatherCompensation = null;
      heating.mainSystem2FlueType = null;
      heating.mainSystem2FanAssisted = null;
      heating.mainSystem2Emitter = null;
      heating.mainSystem2PumpAge = null;
      heating.mainSystem2FlowTemp = null;
      heating.mainSystem2MCSInstalled = null;
      heating.mainSystem2MainHeatingNumber = null;
      heating.mainSystem2HasFGHRS = null;
      heating.mainSystem2TTZCIndexNumber = null;

    }
    return heating;
  }

  cleanupMainSystem2SystemTypeDatabaseCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.mainSystem2SystemType !== this.keyedLookUpCodes['PrimarySystemType']['Database']) {
      (heating as any).mainSystem2PCDFId = null;
    }
    return heating;
  }

  cleanupMainSystem2SystemTypeNotDatabaseCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.mainSystem2SystemType ===this.keyedLookUpCodes['PrimarySystemType']['Database']) {
      heating.mainSystem2System = null;
    }
    return heating;
  }

  cleanupMainSystem2FlueTypeCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.mainSystem2Fuel === this.keyedLookUpCodes['HeatingFuel']['Electricity']) {
      heating.mainSystem2FlueType = null;
    }
    return heating;
  }

  cleanupMainSystem2FanAssistedCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.mainSystem2Fuel === this.keyedLookUpCodes['HeatingFuel']['Electricity'] ||
      heating.mainSystem2SystemType === this.keyedLookUpCodes['PrimarySystemType']['Database'] ||
      heating.mainSystem2System === this.keyedLookUpCodes['HeatingSystem']['Gas fire, closed fronted, fan assisted']) {
      heating.mainSystem2FanAssisted = null;
    }
    return heating;
  }

  cleanupCylinderDetailsInsulationAndThicknessCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.cylinderDetailsSize === this.keyedLookUpCodes['CylinderSize']['No access'] ||
      heating.cylinderDetailsSize === this.keyedLookUpCodes['CylinderSize']['No cylinder'] ||
      this.cylinderDetailsDeclaredHeatLossSelected) {
      heating.cylinderDetailsInsulation = null;
      heating.cylinderDetailsThickness = null;
    }
    return heating;
  }
  
  cleanupCylinderThickness(heating: RdSAPHeatingUIDTOV0) {
    if (heating.cylinderDetailsInsulation === this.keyedLookUpCodes['CylinderInsulationType']['None']) {
      heating.cylinderDetailsThickness = null;
    }
    return heating;
  }

  cleanupCylinderDetailsImmersionCondition(heating: RdSAPHeatingUIDTOV0) {
    if (heating.waterHeatingSystem !== this.keyedLookUpCodes['WaterHeatingType']['Electric immersion']) {
      heating.cylinderDetailsImmersion = null;
    }
    return heating;
  }

  cleanupPVBatteryCapacityCondition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (this.pvBatteryCapacity < 1 || this.pvBatteryCapacity > 4) {
      delete (renewables as any).pvBatteryCapacity1;
      delete (renewables as any).pvBatteryCapacity2;
      delete (renewables as any).pvBatteryCapacity3;
      delete (renewables as any).pvBatteryCapacity4;
    } else {
      if (this.pvBatteryCapacity < 2) {
        delete (renewables as any).pvBatteryCapacity2;
        delete (renewables as any).pvBatteryCapacity3;
        delete (renewables as any).pvBatteryCapacity4;
      }
      if (this.pvBatteryCapacity < 3) {
        delete (renewables as any).pvBatteryCapacity3;
        delete (renewables as any).pvBatteryCapacity4;
      }
      if (this.pvBatteryCapacity < 4) {
        delete (renewables as any).pvBatteryCapacity4;
      }
    }
    return renewables;
  }

  cleanupPVConfigurationCondition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (renewables.pvConfiguration !== this.keyedPVConfigurationsOptions['PV system (roof coverage only)']) {
      renewables.percentageOfRoofCovered = null;
      renewables.pvConnectedToMeter = null;
    }
    if (renewables.pvConfiguration !== this.keyedPVConfigurationsOptions['1 PV Array (kWp known)'] &&
      renewables.pvConfiguration !== this.keyedPVConfigurationsOptions['2 PV Arrays (kWp known)'] &&
      renewables.pvConfiguration !== this.keyedPVConfigurationsOptions['3 PV Arrays (kWp known)']) {
      renewables.array1Pitch = null;
      renewables.array1Orientation = null;
      renewables.array1Overshading = null;
      renewables.array1KWP = null;
      renewables.array1ConnectedToMeter = null;
      renewables.array2Pitch = null;
      renewables.array2Orientation = null;
      renewables.array2Overshading = null;
      renewables.array2KWP = null;
      renewables.array2ConnectedToMeter = null;
      renewables.array3Pitch = null;
      renewables.array3Orientation = null;
      renewables.array3Overshading = null;
      renewables.array3KWP = null;
      renewables.array3ConnectedToMeter = null;
    }
    if (renewables.pvConfiguration !== this.keyedPVConfigurationsOptions['2 PV Arrays (kWp known)'] &&
        renewables.pvConfiguration !== this.keyedPVConfigurationsOptions['3 PV Arrays (kWp known)']) {
        renewables.array2Pitch = null;
        renewables.array2Orientation = null;
        renewables.array2Overshading = null;
        renewables.array2KWP = null;
        renewables.array2ConnectedToMeter = null;
    }
    if (renewables.pvConfiguration !== this.keyedPVConfigurationsOptions['3 PV Arrays (kWp known)']) {
      renewables.array3Pitch = null;
      renewables.array3Orientation = null;
      renewables.array3Overshading = null;
      renewables.array3KWP = null;
      renewables.array3ConnectedToMeter = null;
    }
    return renewables;
  }

  cleanupSWHConfigurationCondition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (renewables.swhConfiguration !== this.keyedSWHConfigurations['Solar water heating (details known)']) {
      renewables.solarWaterHeaterPitch = null;
      renewables.solarWaterHeaterOrientation = null;
      renewables.solarWaterHeaterOvershading = null;
      renewables.solarWaterHeaterShowerTypes = null;
      renewables.solarWaterHeaterCirculatingPump = null;
      delete (renewables as any).solarWaterHeaterCollectorDetailsKnown;
      renewables.solarWaterHeaterCollectorType = null;
      renewables.solarWaterHeaterAreaOfPanel = null;
      renewables.solarWaterHeaterZeroLossEfficiency = null;
      renewables.solarWaterHeaterLinearHeatLossCoefficient = null;
      delete (renewables as any).solarWaterHeatersecoundaryHeatLossCoefficient;
      delete (renewables as any).solarWaterHeatLossRate;
      delete (renewables as any).solarWaterHeaterStoreVolumeDetailsKnown;
      renewables.solarWaterHeaterDedicatedSolarVolume = null;
      renewables.solarWaterHeaterTotalCylenderVolume = null;
      delete (renewables as any).combinedCylinder;
    }
    return renewables;
  }

  cleanupSWHStoreDetailsKnownCondition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (!(renewables as any).solarWaterHeaterStoreVolumeDetailsKnown) {
      renewables.solarWaterHeaterDedicatedSolarVolume = null;
      renewables.solarWaterHeaterTotalCylenderVolume = null;
      delete (renewables as any).combinedCylinder;
    }
    return renewables;
  }

  cleanupWindTurbinesDetailsKnownCondition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (!this.windTurbinesDetailsKnown) {
      renewables.rotorDiameter = null;
      renewables.hubHeight = null;
    }
    return renewables;
  }

  cleanupFGHRSMainSystem1Condition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (renewables.fghrHeatingSystem1ID !== 'Main system 1 only' && renewables.fghrHeatingSystem1ID !== 'Main systems 1 and 2') {
      renewables.fghrsHeatngSystem1Make = null;
      renewables.fghrsHeatngSystem1Model = null;
      renewables.fghrsHeatngSystem1Efficiency = null;
    }
    return renewables;
  }

  cleanupFGHRSMainSystem2Condition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (renewables.fghrHeatingSystem1ID !== 'Main system 2 only' && renewables.fghrHeatingSystem1ID !== 'Main systems 1 and 2') {
      renewables.fghrsHeatingSystem2ID = null;
      renewables.fghrsHeatngSystem2Make = null;
      renewables.fghrsHeatngSystem2Model = null;
      renewables.fghrsHeatngSystem2Efficiency = null;
    }
    return renewables;
  }

  cleanupWWHRSInstantaneous1Condition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (this.wasteWaterHeatRecovery !== 'Instantaneous (1 system)' && this.wasteWaterHeatRecovery !== 'Instantaneous (2 systems)') {
      (renewables as any).wwhsrs1ID = null;
      delete (renewables as any).wWHSRS1Make;
      delete (renewables as any).wWHSRS1Model;
      delete (renewables as any).wWHSRS1Efficiency;
      delete (renewables as any).wWHSRS1MixerShowersWithWWHRSAndBath;
      delete (renewables as any).wWHSRS1MixerShowersWithWWHRSNoBath;
    }
    return renewables;
  }

  cleanupWWHRSInstantaneous2Condition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (this.wasteWaterHeatRecovery !== 'Instantaneous (2 systems)') {
      delete (renewables as any).wWHSRS2ID;
      delete (renewables as any).wWHSRS2Make;
      delete (renewables as any).wWHSRS2Model;
      delete (renewables as any).wWHSRS2Efficiency;
      delete (renewables as any).wWHSRS2MixerShowersWithWWHRSAndBath;
      delete (renewables as any).wWHSRS2MixerShowersWithWWHRSNoBath;
      delete (renewables as any).wwhrsInstantaneous2Index;
    }
    return renewables;
  }

  cleanupWWHRSStorageCondition(renewables: RdSAPRenewablesRecoveryUIDTOV0) {
    if (this.wasteWaterHeatRecovery !== 'Storage') {
      delete (renewables as any).wWHSRSStorageID;
      delete (renewables as any).wWHSRSStorageMake;
      delete (renewables as any).wWHSRSStorageModel;
      delete (renewables as any).wWHSRSStorageEfficiency;
      delete (renewables as any).wWHSRSStorageTotalShowersAndBaths;
      delete (renewables as any).wWHSRSStorageShowersAndBathsToWWHRS;
      delete (renewables as any).wWHSRSStorageVolume;
      delete (renewables as any).wwhrsStorageIndex;
    }
    return renewables;
  }

  save(auto) {
    this.saving = true;
    const payload = {
      results: cloneDeep(this.eeStatusDetails),
      general: cloneDeep(this.eeGeneralDetails),
      opening: cloneDeep(this.eeOpeningDetails),
      heating: cloneDeep(this.eeHeating),
      renewables: cloneDeep(this.eeRR),
      buildingParts: [cloneDeep(this.eeBDMainBuilding)],
      generic: cloneDeep(this.eeGenericDetails),
      sapSpecialFeatures: cloneDeep(this.sapSpecialFeatures),
    };
    if (this.showBuildingExtensions.extension1) {
      payload.buildingParts.push(cloneDeep(this.eeBDEx1));
    }
    if (this.showBuildingExtensions.extension2) {
      payload.buildingParts.push(cloneDeep(this.eeBDEx2));
    }
    if (this.showBuildingExtensions.extension3) {
      payload.buildingParts.push(cloneDeep(this.eeBDEx3));
    }
    if (this.showBuildingExtensions.extension4) {
      payload.buildingParts.push(cloneDeep(this.eeBDEx4));
    }
    payload.general = this.cleanupConservatory(payload.general);
    payload.general = this.cleanupUnheatedCorridor(payload.general);
    payload.general = this.cleanupPropertyType(payload.general);
    payload.opening = this.cleanupOpeningCoverage(payload.opening);
    payload.opening = this.cleanupPVCFramesCondition(payload.opening);
    payload.opening = this.cleanupUValueGValueCondition(payload.opening);
    payload.buildingParts = payload.buildingParts.map((buildingPart, i) => {
      buildingPart = this.cleanupBuildingAdditionalWallThickness(buildingPart);
      buildingPart = this.cleanupRoofRoomCondition(buildingPart, i);
      buildingPart = this.cleanupWallThicknessMeasuredCondition(buildingPart);
      buildingPart = this.cleanupWallInsulationThicknessCondition(buildingPart);
      buildingPart = this.cleanupWallUValueKnownCondition(buildingPart);
      buildingPart = this.cleanupAlternativeWallUValueKnownCondition(buildingPart);
      buildingPart = this.cleanupFloorHeatLossTypeCondition(buildingPart);
      buildingPart = this.cleanupFloorInsulationThicknessCondition(buildingPart);
      buildingPart = this.cleanupFloorUValueKnownCondition(buildingPart);
      buildingPart = this.cleanupRoofInsulationTypeCondition(buildingPart);
      buildingPart = this.cleanupRoofInsulationThicknessCondition(buildingPart);
      buildingPart = this.cleanupRoofUValueKnownCondition(buildingPart);
      buildingPart = this.cleanupRoofUValueCondition(buildingPart);
      buildingPart = this.cleanupRoofRoomInsulationThicknessCondition(buildingPart);
      if((buildingPart.roofRoomsInsulation === '3' || buildingPart.roofRoomsInsulation === '4' || buildingPart.roofRoomsInsulation === '5') && buildingPart.roofRoomsThickness === '0') {
        buildingPart.roofRoomsThickness = null;
      }
      if (buildingPart.roofInsulationType === '6') {
        delete buildingPart.slopingCeilingInsulationThickness;
        delete buildingPart.rafterInsulationThickness;
        delete buildingPart.roofInsulationThickness;
      } else if (buildingPart.roofInsulationType === '7') {
        delete buildingPart.flatRoofInsulationThickness;
        delete buildingPart.rafterInsulationThickness;
        delete buildingPart.roofInsulationThickness;
      } else if (buildingPart.roofInsulationType === '1') {
        delete buildingPart.flatRoofInsulationThickness;
        delete buildingPart.slopingCeilingInsulationThickness;
        delete buildingPart.roofInsulationThickness;
      } else {
        delete buildingPart.flatRoofInsulationThickness;
        delete buildingPart.slopingCeilingInsulationThickness;
        delete buildingPart.rafterInsulationThickness;
      }
      delete buildingPart.dimensionsNumberOfFloors;
      return buildingPart;
    });
    payload.heating = this.cleanupSecondaryHeatingCondition(payload.heating);
    payload.heating = this.cleanupMainSystem1CommunityHeatingCondition(payload.heating);
    payload.heating = this.cleanupMainSystem1SystemTypeDatabaseCondition(payload.heating);
    payload.heating = this.cleanupMainSystem1SystemTypeNotDatabaseCondition(payload.heating);
    payload.heating = this.cleanupMainSystem1FanAssistedCondition(payload.heating);
    payload.heating = this.cleanupMainSystem2Condition(payload.heating);
    payload.heating = this.cleanupMainSystem2SystemTypeDatabaseCondition(payload.heating);
    payload.heating = this.cleanupMainSystem2SystemTypeNotDatabaseCondition(payload.heating);
    payload.heating = this.cleanupMainSystem2FanAssistedCondition(payload.heating);
    payload.heating = this.cleanupCylinderDetailsInsulationAndThicknessCondition(payload.heating);
    payload.heating = this.cleanupCylinderThickness(payload.heating);
    payload.heating = this.cleanupCylinderDetailsImmersionCondition(payload.heating);
    payload.heating.waterHeatingFuel = this.eeHeating.waterHeatingSystem === '999' ? '0' : this.eeHeating.waterHeatingFuel;
    payload.renewables = this.cleanupPVBatteryCapacityCondition(payload.renewables);
    payload.renewables = this.cleanupPVConfigurationCondition(payload.renewables);
    payload.renewables = this.cleanupSWHConfigurationCondition(payload.renewables);
    payload.renewables = this.cleanupSWHStoreDetailsKnownCondition(payload.renewables);
    payload.renewables = this.cleanupWindTurbinesDetailsKnownCondition(payload.renewables);
    payload.renewables = this.cleanupFGHRSMainSystem1Condition(payload.renewables);
    payload.renewables = this.cleanupFGHRSMainSystem2Condition(payload.renewables);
    payload.renewables = this.cleanupWWHRSInstantaneous1Condition(payload.renewables);
    payload.renewables = this.cleanupWWHRSInstantaneous2Condition(payload.renewables);
    payload.renewables = this.cleanupWWHRSStorageCondition(payload.renewables);
    payload.renewables.swhConfiguration = payload.renewables.swhConfiguration ?? this.swhConfigurations?.[0]?.value;
    this.payloadFix(payload);
    this.assessmentService .newUpdateAssessment(this.activeDataset.generic?.reportReferenceNumber, payload).pipe(
        catchError((error) => {
          console.error('Error occurred:', error);
          this.saving = false;
          this.isSaved = false;
          return throwError(() => error);
        })
      ).subscribe({
        next: (res) => {
          this.isSaved = res.status === 202;
          this.saveEditMessage = res.message;
          if (this.isSaved) {
            if (!auto) {
              this.showSuccess('Data saved successfully');
            }
          } else {
            this.showDanger('Error saving data');
          }
        },
        error: (error) => {
          this.isSaved = false;
          if (error.error?.message?.includes("invalid status 'LODGED'")) {
          } else {
            this.showDanger(
              'Error saving data: ' +
                (error.error.message ?? 'Error saving data')
            );
          }
        },
        complete: () => {
          this.saving = false;
        },
      });
  }
  
  getRoofInsulationThickness(building: any): string {
    switch (building.roofInsulationType) {
      case '1':
        return building.rafterInsulationThickness;
      case '6':
        return building.flatRoofInsulationThickness;
      case '7':
        return building.slopingCeilingInsulationThickness;
      default:
        return building.roofInsulationThickness;
    }
  }
  
  setRoofInsulationThickness(building: any, value: string): void {
    switch (building.roofInsulationType) {
      case '1':
        building.rafterInsulationThickness = value;
        break;
      case '6':
        building.flatRoofInsulationThickness = value;
        break;
      case '7':
        building.slopingCeilingInsulationThickness = value;
        break;
      default:
        building.roofInsulationThickness = value;
    }
  }
  
  get mainBuildingRoofInsulationThickness(): string {
    return this.getRoofInsulationThickness(this.eeBDMainBuilding);
  }

  set mainBuildingRoofInsulationThickness(value: string) {
    this.setRoofInsulationThickness(this.eeBDMainBuilding, value);
  }
  
  get extension1RoofInsulationThickness(): string {
    return this.getRoofInsulationThickness(this.eeBDEx1);
  }

  set extension1RoofInsulationThickness(value: string) {
    this.setRoofInsulationThickness(this.eeBDEx1, value);
  }

  get extension2RoofInsulationThickness(): string {
    return this.getRoofInsulationThickness(this.eeBDEx2);
  }

  set extension2RoofInsulationThickness(value: string) {
    this.setRoofInsulationThickness(this.eeBDEx2, value);
  }
  
  get extension3RoofInsulationThickness(): string {
    return this.getRoofInsulationThickness(this.eeBDEx3);
  }

  set extension3RoofInsulationThickness(value: string) {
    this.setRoofInsulationThickness(this.eeBDEx3, value);
  }

  get extension4RoofInsulationThickness(): string {
    return this.getRoofInsulationThickness(this.eeBDEx4);
  }

  set extension4RoofInsulationThickness(value: string) {
    this.setRoofInsulationThickness(this.eeBDEx4, value);
  }

  payloadFix(payload) {
    delete payload.heating.mainSystem1HeatingType;
    delete payload.heating.mainSystem2HeatingType;
    delete payload.heating.mainSystem1PCDFManufacturer;
    delete payload.heating.mainSystem2PCDFManufacturer;
    delete payload.heating.mainSystem1PCDFModel;
    delete payload.heating.mainSystem2PCDFModel;
    delete payload.heating.mainSystem1PCDFQualifier;
    delete payload.heating.mainSystem2PCDFQualifier;
    delete payload.heating.mainSystem1PCDFBoilerId;
    delete payload.heating.mainSystem2PCDFBoilerId;
  }

  openPcdbDataSelectorModal(heatingSystem: string) {
    const modalRef = this.modalService.open(PcdbDataSelectorComponent, { size: 'xl', backdrop: 'static', });
    modalRef.componentInstance.heatingCategoryOptions = this.pcdbSelectorHeatingTypes;
    modalRef.componentInstance.heatingCategory = this.eeHeating[`${heatingSystem}SystemSubType`];
    modalRef.componentInstance.heatingFuel = this.eeHeating[`${heatingSystem}Fuel`];
    modalRef.componentInstance.heatingFuelOptions = [...this.lookUpCodesByDataItem['HeatingFuel'],];
    modalRef.componentInstance.keyedLookUpCodes = this.keyedLookUpCodes;
    modalRef.componentInstance.communityHeatingFuelCodes = [...this.communityHeatingFuelCodes,];
    modalRef.componentInstance.mainGasAvailable = this.eeHeating.mainGasAvailable;
    modalRef.result.then((result) => {
      if (result) {
        if ((!this.form.dirty && (this.eeHeating[`${heatingSystem}HeatingType`] !== this.keyedLookUpCodes['HeatingType'][result.pcdbData.type] ||
              this.eeHeating[`${heatingSystem}Fuel`] !== result.fuel ||
              this.eeHeating[`${heatingSystem}PCDFId`] !== result.pcdbData.id ||
              this.eeHeating[`${heatingSystem}PCDFManufacturer`] !== result.pcdbData.brandName ||
              this.eeHeating[`${heatingSystem}PCDFModel`] !== result.pcdbData.modelName ||
              this.eeHeating[`${heatingSystem}SystemSubType`] !== this.keyedLookUpCodes['HeatingType'][result.pcdbData.type] ||
              this.eeHeating[`${heatingSystem}PCDFQualifier`] !== result.pcdbData.modelQualifier)) ||
              this.eeHeating[`${heatingSystem}PCDFBoilerId`] !== result.pcdbData.boilerId) {
              this.form.markAsDirty();
        }
        this.eeHeating[`${heatingSystem}SystemSubType`] = this.keyedLookUpCodes['HeatingType'][result.pcdbData.type];
        this.eeHeating[`${heatingSystem}HeatingType`] = this.keyedLookUpCodes['HeatingType'][result.pcdbData.type];
        this.eeHeating[`${heatingSystem}Fuel`] = result.fuel;
        this.eeHeating[`${heatingSystem}PCDFId`] = result.pcdbData.id;
        this.eeHeating[`${heatingSystem}PCDFManufacturer`] = result.pcdbData.brandName;
        this.eeHeating[`${heatingSystem}PCDFModel`] = result.pcdbData.modelName;
        this.eeHeating[`${heatingSystem}PCDFQualifier`] = result.pcdbData.modelQualifier;
        this.eeHeating[`${heatingSystem}PCDFBoilerId`] = result.pcdbData.boilerId;
        this.eeHeating[`${heatingSystem}FlueType`] = null;
        this.eeHeating[`${heatingSystem}FanAssisted`] = result.pcdbData.fanAssistance !== '2' ? false : true;
        this.setHeatingControls(heatingSystem);
      }
      this.onEeHeatingChange();
    });
  }

  setHeatingMainSystemCategoryArray(heatingSystem) {
    if (this.keyedLookUpCodes && this.keyedLookUpCodes['ElectricityMeter'] && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['HeatingType']) {
      let heatingTypes = this.lookUpCodesByDataItem['HeatingType'];
      if (heatingSystem === 'mainSystem2' && this.mainSystems === MAIN_SYSTEM_AND_DHW_ONLY) {
        heatingTypes = filter(heatingTypes, (heatingTypeLookUpCode) => {
          return (
            heatingTypeLookUpCode.lookUpItem !== 'Electric storage systems' &&
            heatingTypeLookUpCode.lookUpItem !== 'Electric underfloor' &&
            heatingTypeLookUpCode.lookUpItem !== 'Community heating' &&
            heatingTypeLookUpCode.lookUpItem !== 'Other heating'
          );
        });
      }
      if (this.eeHeating.electricMeter === this.keyedLookUpCodes['ElectricityMeter']['Single']) {
        this.heatingMainSystemCategoriesBySystem[heatingSystem] = filter(heatingTypes, (typeLookUpCode) => {
            return typeLookUpCode.lookUpItem !== 'Electric storage systems';
          });
      } else {
        this.heatingMainSystemCategoriesBySystem[heatingSystem] = heatingTypes;
      }
    } else {
      this.heatingMainSystemCategoriesBySystem[heatingSystem] = [];
    }
  }

  setHeatingFuelArrays(heatingSystem) {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['HeatingFuel']) {
      if (this.eeHeating[`${heatingSystem}SystemSubType`] === this.keyedLookUpCodes['HeatingType']['Community heating']) {
        if (this.eeHeating.mainGasAvailable) {
          this.heatingFuelsBySystem[heatingSystem] = this.communityHeatingFuelCodes;
        } else {
          this.heatingFuelsBySystem[heatingSystem] = filter(this.communityHeatingFuelCodes, (fuelLookUpCode) => {
              return (fuelLookUpCode.lookUpItem !== 'Mains gas (community heating)');
            });
        }
      } else {
        if (this.eeHeating.mainGasAvailable) {
          this.heatingFuelsBySystem[heatingSystem] = this.lookUpCodesByDataItem['HeatingFuel'];
          this.heatingFuelsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return !fuelLookUpCode.lookUpItem.includes('(community heating)');
            });
        } else {
          this.heatingFuelsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (fuelLookUpCode.lookUpItem !== 'Mains Gas' && !fuelLookUpCode.lookUpItem.includes('(community heating)'));
            });
        }
      }
    } else {
      this.heatingFuelsBySystem[heatingSystem] = [];
    }
  }

  setCommunityHeatingFuelArrays(heatingSystem) {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['HeatingFuel']) {
      if (this.mainSystem1CommunityHeating) {
        if (this.eeHeating.mainGasAvailable) {
          this.heatingFuelsBySystem['mainSystem1'] = this.communityHeatingFuelCodes;
          this.heatingFuelsBySystem['mainSystem2'] = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return !fuelLookUpCode.lookUpItem.includes('(community heating)');
            });
        } else {
          this.heatingFuelsBySystem['mainSystem1'] = filter(this.communityHeatingFuelCodes, (fuelLookUpCode) => {
              return (fuelLookUpCode.lookUpItem !== 'Mains gas (community heating)');
            });
          this.heatingFuelsBySystem['mainSystem2'] = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (fuelLookUpCode.lookUpItem !== 'Mains Gas' && !fuelLookUpCode.lookUpItem.includes('(community heating)'));
          });
        }
      } else {
        if (this.eeHeating.mainGasAvailable) {
          this.heatingFuelsBySystem[heatingSystem] = this.lookUpCodesByDataItem['HeatingFuel'];
          this.heatingFuelsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return !fuelLookUpCode.lookUpItem.includes('(community heating)');
          });
        } else {
          this.heatingFuelsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (fuelLookUpCode.lookUpItem !== 'Mains Gas' && !fuelLookUpCode.lookUpItem.includes('(community heating)'));
          });
        }
      }
    } else {
      this.heatingFuelsBySystem[heatingSystem] = [];
    }
  }

  setHeatingCategoryByFuel(heatingSystem) {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['HeatingType']) {
      const heatingTypes = this.lookUpCodesByDataItem['HeatingType'];
      switch (this.eeHeating[`${heatingSystem}Fuel`]) {
        case this.keyedLookUpCodes['HeatingFuel']['Bottled LPG']:
        case this.keyedLookUpCodes['HeatingFuel']['LPG special condition']:
        case this.keyedLookUpCodes['HeatingFuel']['Mains Gas']:
        case this.keyedLookUpCodes['HeatingFuel']['Bulk LPG']:
        case this.keyedLookUpCodes['HeatingFuel']['Biogas']:
          this.heatingMainSystemCategoriesByFuel[heatingSystem] = filter(heatingTypes, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '145' ||
                systemLookUpCode.lookupValue === '146' ||
                systemLookUpCode.lookupValue === '147' ||
                systemLookUpCode.lookupValue === '150' ||
                systemLookUpCode.lookupValue === '151' ||
                systemLookUpCode.lookupValue === '149' ||
                systemLookUpCode.lookupValue === '253' ||
                systemLookUpCode.lookupValue === '148' ||
                systemLookUpCode.lookupValue === '152'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingFuel']['Oil']:
        case this.keyedLookUpCodes['HeatingFuel']['Bioethanol from biomass']:
        case this.keyedLookUpCodes['HeatingFuel']['B30K']:
        case this.keyedLookUpCodes['HeatingFuel']['Biodiesel (biomass)']:
        case this.keyedLookUpCodes['HeatingFuel']['Biodiesel (cooking oil)']:
        case this.keyedLookUpCodes['HeatingFuel']['Biodiesel (vegetable oil)']:
        case this.keyedLookUpCodes['HeatingFuel']['Mineral oil/liquid biofuel']:
          this.heatingMainSystemCategoriesByFuel[heatingSystem] = filter(heatingTypes, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '253' ||
                systemLookUpCode.lookupValue === '250' ||
                systemLookUpCode.lookupValue === '252' ||
                systemLookUpCode.lookupValue === '248' ||
                systemLookUpCode.lookupValue === '249'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingFuel']['Electricity']:
          this.heatingMainSystemCategoriesByFuel[heatingSystem] = filter(heatingTypes, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '253' ||
                systemLookUpCode.lookupValue === '3' ||
                systemLookUpCode.lookupValue === '251' ||
                systemLookUpCode.lookupValue === '7' ||
                systemLookUpCode.lookupValue === '373' ||
                systemLookUpCode.lookupValue === '2' ||
                systemLookUpCode.lookupValue === '4' ||
                systemLookUpCode.lookupValue === '5'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingFuel']['Anthracite']:
        case this.keyedLookUpCodes['HeatingFuel']['Wood logs']:
        case this.keyedLookUpCodes['HeatingFuel']['Bulk wood pellets']:
        case this.keyedLookUpCodes['HeatingFuel']['Wood chips']:
        case this.keyedLookUpCodes['HeatingFuel']['Duel fuel (mineral + wood)']:
        case this.keyedLookUpCodes['HeatingFuel']['Smokeless coal']:
        case this.keyedLookUpCodes['HeatingFuel']['House coal']:
          this.heatingMainSystemCategoriesByFuel[heatingSystem] = filter(heatingTypes, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '240' ||
                systemLookUpCode.lookupValue === '241'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingFuel']['Mains gas (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Electricity (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['LPG (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Oil (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['B30D (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Coal (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Waste combustion (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Biomass (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Biogas (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Mineral / biodiesel (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Biodiesel from biomass source (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['Biodiesel from vegetable oil (community heating)']:
        case this.keyedLookUpCodes['HeatingFuel']['From heat network data (community heating)']:
          this.heatingMainSystemCategoriesByFuel[heatingSystem] = filter(heatingTypes, (systemLookUpCode) => {
              return systemLookUpCode.lookupValue === '426';
            });
          break;
        default:
          this.heatingMainSystemCategoriesByFuel[heatingSystem] = heatingTypes;
      }
    }
  }

  setHeatingSystemTypes(heatingSystem) {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['HeatingSystem']) {
      let heatingSystems = this.lookUpCodesByDataItem['HeatingSystem'];
      if (this.eeHeating.electricMeter === this.keyedLookUpCodes['ElectricityMeter']['24 hour']) {
        heatingSystems = filter(this.lookUpCodesByDataItem['HeatingSystem'], (systemLookUpCode) => {
            return (
              systemLookUpCode.lookupValue !== '401' &&
              systemLookUpCode.lookupValue !== '408' &&
              systemLookUpCode.lookupValue !== '424'
            );
          });
      } else if (this.eeHeating.electricMeter === this.keyedLookUpCodes['ElectricityMeter']['Single']) {
        heatingSystems = filter(this.lookUpCodesByDataItem['HeatingSystem'], (systemLookUpCode) => {
            return (systemLookUpCode.lookupValue !== this.keyedLookUpCodes['HeatingSystem']['In concrete slab (off-peak)'] &&
              systemLookUpCode.lookupValue !== this.keyedLookUpCodes['HeatingSystem']['Integrated (storage+direct-acting)'] &&
              systemLookUpCode.lookupValue !== this.keyedLookUpCodes['HeatingSystem']['Electric dry core storage boiler'] &&
              systemLookUpCode.lookupValue !== this.keyedLookUpCodes['HeatingSystem']['Electric water storage boiler'] &&
              systemLookUpCode.lookupValue !== this.keyedLookUpCodes['HeatingSystem']['Electric CPSU']);
          }
        );
      }
      if (heatingSystem === 'mainSystem2' && this.mainSystems === MAIN_SYSTEM_AND_DHW_ONLY) {
        heatingSystems = filter(heatingSystems, (systemLookUpCode) => {
          return (
            systemLookUpCode.lookupValue !== '601' &&
            systemLookUpCode.lookupValue !== '603' &&
            // systemLookUpCode.lookupValue !== '605' &&
            // systemLookUpCode.lookupValue !== '607' &&
            systemLookUpCode.lookupValue !== '609' &&
            systemLookUpCode.lookupValue !== '610' &&
            systemLookUpCode.lookupValue !== '611' &&
            systemLookUpCode.lookupValue !== '612' &&
            systemLookUpCode.lookupValue !== '621' &&
            systemLookUpCode.lookupValue !== '623' &&
            systemLookUpCode.lookupValue !== '631' &&
            systemLookUpCode.lookupValue !== '633' &&
            systemLookUpCode.lookupValue !== '635' &&
            systemLookUpCode.lookupValue !== '691' &&
            systemLookUpCode.lookupValue !== '694' &&
            systemLookUpCode.lookupValue !== '693'
          );
        });
      }

      switch (this.eeHeating[`${heatingSystem}SystemSubType`]) {
        case this.keyedLookUpCodes['HeatingType']['Gas boilers (including LPG) 1998 or later']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '101' ||
                systemLookUpCode.lookupValue === '102' ||
                systemLookUpCode.lookupValue === '103' ||
                systemLookUpCode.lookupValue === '104' ||
                systemLookUpCode.lookupValue === '105' ||
                systemLookUpCode.lookupValue === '107' ||
                systemLookUpCode.lookupValue === '109'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Gas boilers (including LPG) pre-1998, with fan-assisted flue']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems,(systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '111' ||
                systemLookUpCode.lookupValue === '112' ||
                systemLookUpCode.lookupValue === '113' ||
                systemLookUpCode.lookupValue === '114'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Gas boilers (including LPG) pre-1998, with balanced or open flue']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '115' ||
                systemLookUpCode.lookupValue === '116' ||
                systemLookUpCode.lookupValue === '117' ||
                systemLookUpCode.lookupValue === '118' ||
                systemLookUpCode.lookupValue === '119'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Gas-fired warm air with fan-assisted flue']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return systemLookUpCode.lookupValue === '502';
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Gas fired warm air with balanced or open flue']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '506' ||
                systemLookUpCode.lookupValue === '510' ||
                systemLookUpCode.lookupValue === '511'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Range cooker boilers (mains gas and LPG)']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '133' ||
                systemLookUpCode.lookupValue === '134' ||
                systemLookUpCode.lookupValue === '136'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Heat pump with radiators or underfloor heating']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '217' ||
                systemLookUpCode.lookupValue === '215' ||
                systemLookUpCode.lookupValue === '216' ||
                systemLookUpCode.lookupValue === '227' ||
                systemLookUpCode.lookupValue === '225' ||
                systemLookUpCode.lookupValue === '226'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Combined Primary Storage Units (CPSU) (mains gas and LPG)']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '120' ||
                systemLookUpCode.lookupValue === '121'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Gas (including LPG) room heaters']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '601' ||
                systemLookUpCode.lookupValue === '602' ||
                systemLookUpCode.lookupValue === '603' ||
                systemLookUpCode.lookupValue === '604' ||
                systemLookUpCode.lookupValue === '605' ||
                systemLookUpCode.lookupValue === '606' ||
                systemLookUpCode.lookupValue === '607' ||
                systemLookUpCode.lookupValue === '609' ||
                systemLookUpCode.lookupValue === '610' ||
                systemLookUpCode.lookupValue === '611' ||
                systemLookUpCode.lookupValue === '612' ||
                systemLookUpCode.lookupValue === '613'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Oil boilers']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems,(systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '125' ||
                systemLookUpCode.lookupValue === '126' ||
                systemLookUpCode.lookupValue === '127' ||
                systemLookUpCode.lookupValue === '128' ||
                systemLookUpCode.lookupValue === '129' ||
                systemLookUpCode.lookupValue === '130' ||
                systemLookUpCode.lookupValue === '131' ||
                systemLookUpCode.lookupValue === '132'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Oil-fired warm air']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return systemLookUpCode.lookupValue === '512';
            }
          );
          break;
        case this.keyedLookUpCodes['HeatingType']['Range cooker boilers (oil)']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '139' ||
                systemLookUpCode.lookupValue === '140'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['Oil room heaters']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '621' ||
                systemLookUpCode.lookupValue === '622' ||
                systemLookUpCode.lookupValue === '623' ||
                systemLookUpCode.lookupValue === '624' ||
                systemLookUpCode.lookupValue === '625'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['Electric boilers']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '191' ||
                systemLookUpCode.lookupValue === '195' ||
                systemLookUpCode.lookupValue === '192' ||
                systemLookUpCode.lookupValue === '193'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['Heat pump with radiators or underfloor heating']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '621' ||
                systemLookUpCode.lookupValue === '622' ||
                systemLookUpCode.lookupValue === '623' ||
                systemLookUpCode.lookupValue === '624' ||
                systemLookUpCode.lookupValue === '625'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['Electric warm air']:
          if (this.eeHeating[`${heatingSystem}Fuel`] === this.keyedLookUpCodes['HeatingFuel']['Electricity']) {
            this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
                return systemLookUpCode.lookupValue === '515';
            });
          }
          break;
        case this.keyedLookUpCodes['HeatingType']['Heat pump with warm air distribution']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '524' ||
                systemLookUpCode.lookupValue === '521' ||
                systemLookUpCode.lookupValue === '523'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['Electric (direct acting) room heaters']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '691' ||
                systemLookUpCode.lookupValue === '694'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Electric storage systems']:
          if (!(heatingSystem === 'mainSystem2' && this.mainSystems === MAIN_SYSTEM_AND_DHW_ONLY) && this.eeHeating[`${heatingSystem}Fuel`] === this.keyedLookUpCodes['HeatingFuel']['Electricity']) {
            this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
                return (
                  systemLookUpCode.lookupValue === '401' ||
                  systemLookUpCode.lookupValue === '402' ||
                  systemLookUpCode.lookupValue === '404' ||
                  systemLookUpCode.lookupValue === '408' ||
                  systemLookUpCode.lookupValue === '409'
                );
              });
          } else {
            this.heatingSystemTypesBySystem[heatingSystem] = [];
          }
          break;
        case this.keyedLookUpCodes['HeatingType']['Electric underfloor heating']:
          if (!(heatingSystem === 'mainSystem2' && this.mainSystems === MAIN_SYSTEM_AND_DHW_ONLY) && this.eeHeating[`${heatingSystem}Fuel`] === this.keyedLookUpCodes['HeatingFuel']['Electricity']) {
            this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
                return (
                  systemLookUpCode.lookupValue === '421' ||
                  systemLookUpCode.lookupValue === '422' ||
                  systemLookUpCode.lookupValue === '424'
                );
            });
          } else {
            this.heatingSystemTypesBySystem[heatingSystem] = [];
          }
          break;
        case this.keyedLookUpCodes['HeatingType']['Other space heating systems']:
          if (!(heatingSystem === 'mainSystem2' &&
              this.mainSystems === MAIN_SYSTEM_AND_DHW_ONLY ) && this.eeHeating[`${heatingSystem}Fuel`] === this.keyedLookUpCodes['HeatingFuel']['Electricity']) {
              this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
                return systemLookUpCode.lookupValue === '701';
              });
          } else {
            this.heatingSystemTypesBySystem[heatingSystem] = [];
          }
          break;
        case this.keyedLookUpCodes['HeatingType']['Solid fuel boilers']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '151' ||
                systemLookUpCode.lookupValue === '152' ||
                systemLookUpCode.lookupValue === '153' ||
                systemLookUpCode.lookupValue === '154' ||
                systemLookUpCode.lookupValue === '155' ||
                systemLookUpCode.lookupValue === '156' ||
                systemLookUpCode.lookupValue === '158' ||
                systemLookUpCode.lookupValue === '159' ||
                systemLookUpCode.lookupValue === '160'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['Solid fuel room heaters']:
          this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '631' ||
                systemLookUpCode.lookupValue === '632' ||
                systemLookUpCode.lookupValue === '633' ||
                systemLookUpCode.lookupValue === '634' ||
                systemLookUpCode.lookupValue === '635' ||
                systemLookUpCode.lookupValue === '636'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['Community Heating Schemes']:
          if (!(heatingSystem === 'mainSystem2' && this.mainSystems === MAIN_SYSTEM_AND_DHW_ONLY)) {
            this.heatingSystemTypesBySystem[heatingSystem] = filter(heatingSystems, (systemLookUpCode) => {
                return (
                  systemLookUpCode.lookupValue === '301' ||
                  systemLookUpCode.lookupValue === '302' ||
                  systemLookUpCode.lookupValue === '304' ||
                  systemLookUpCode.lookupValue === '310'
                );
            });
          } else {
            this.heatingSystemTypesBySystem[heatingSystem] = [];
          }
          break;
        default:
          this.heatingSystemTypesBySystem[heatingSystem] = [];
      }
    } else {
      this.heatingSystemTypesBySystem[heatingSystem] = [];
    }
  }

  setFlueTypeArrays(heatingSystem) {
    if (this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['FlueType']) {
      this.heatingFlueTypesBySystem[heatingSystem] =
        this.lookUpCodesByDataItem['FlueType'];
    }
    return this.heatingFlueTypesBySystem[heatingSystem];
  }

  setHeatingControls(heatingSystem) {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['HeatingControls']) {
      if (this.eeHeating[`${heatingSystem}HeatingType`] == this.keyedLookUpCodes['HeatingType']['Boiler']) {
        this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
            return (
              heatingControlLookUpCode.lookupValue === '2101' ||
              heatingControlLookUpCode.lookupValue === '2102' ||
              heatingControlLookUpCode.lookupValue === '2103' ||
              heatingControlLookUpCode.lookupValue === '2104' ||
              heatingControlLookUpCode.lookupValue === '2105' ||
              heatingControlLookUpCode.lookupValue === '2106' ||
              heatingControlLookUpCode.lookupValue === '2111' ||
              heatingControlLookUpCode.lookupValue === '2107' ||
              heatingControlLookUpCode.lookupValue === '2109' ||
              heatingControlLookUpCode.lookupValue === '2110'
            );
        });
      } else if (this.eeHeating[`${heatingSystem}HeatingType`] == this.keyedLookUpCodes['HeatingType']['HeatPump']) {
        this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
            return (
              heatingControlLookUpCode.lookupValue === '2201' ||
              heatingControlLookUpCode.lookupValue === '2202' ||
              heatingControlLookUpCode.lookupValue === '2203' ||
              heatingControlLookUpCode.lookupValue === '2204' ||
              heatingControlLookUpCode.lookupValue === '2205' ||
              heatingControlLookUpCode.lookupValue === '2206' ||
              heatingControlLookUpCode.lookupValue === '2207' ||
              heatingControlLookUpCode.lookupValue === '2208'
            );
        });
      }
      switch (this.eeHeating[`${heatingSystem}SystemSubType`]) {
        case this.keyedLookUpCodes['HeatingType']['Heat pump with radiators or underfloor heating']:
          this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
              return (
                heatingControlLookUpCode.lookupValue === '2201' ||
                heatingControlLookUpCode.lookupValue === '2202' ||
                heatingControlLookUpCode.lookupValue === '2203' ||
                heatingControlLookUpCode.lookupValue === '2204' ||
                heatingControlLookUpCode.lookupValue === '2205' ||
                heatingControlLookUpCode.lookupValue === '2206' ||
                heatingControlLookUpCode.lookupValue === '2207' ||
                heatingControlLookUpCode.lookupValue === '2208'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Gas-fired warm air with fan-assisted flue']:
        case this.keyedLookUpCodes['HeatingType']['Gas fired warm air with balanced or open flue']:
          this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
              return (
                heatingControlLookUpCode.lookupValue === '2501' ||
                heatingControlLookUpCode.lookupValue === '2502' ||
                heatingControlLookUpCode.lookupValue === '2503' ||
                heatingControlLookUpCode.lookupValue === '2504' ||
                heatingControlLookUpCode.lookupValue === '2505' ||
                heatingControlLookUpCode.lookupValue === '2506'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Gas (including LPG) room heaters']:
        case this.keyedLookUpCodes['HeatingType']['Electric (direct acting) room heaters']:
        case this.keyedLookUpCodes['HeatingType']['Solid fuel room heaters']:
          this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
              return (
                heatingControlLookUpCode.lookupValue === '2601' ||
                heatingControlLookUpCode.lookupValue === '2602' ||
                heatingControlLookUpCode.lookupValue === '2603' ||
                heatingControlLookUpCode.lookupValue === '2604' ||
                heatingControlLookUpCode.lookupValue === '2605'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['Gas boilers (including LPG) 1998 or later']:
        case this.keyedLookUpCodes['HeatingType']['Gas boilers (including LPG) pre-1998, with fan-assisted flue']:
        case this.keyedLookUpCodes['HeatingType']['Gas boilers (including LPG) pre-1998, with balanced or open flue']:
        case this.keyedLookUpCodes['HeatingType']['Combined Primary Storage Units (CPSU) (mains gas and LPG)']:
        case this.keyedLookUpCodes['HeatingType']['Range cooker boilers (mains gas and LPG)']:
        case this.keyedLookUpCodes['HeatingType']['Oil boilers']:
        case this.keyedLookUpCodes['HeatingType']['Electric boilers']:
        case this.keyedLookUpCodes['HeatingType']['Range cooker boilers (oil)']:
        case this.keyedLookUpCodes['HeatingType']['Solid fuel boilers']:
          this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
              return (
                heatingControlLookUpCode.lookupValue === '2101' ||
                heatingControlLookUpCode.lookupValue === '2102' ||
                heatingControlLookUpCode.lookupValue === '2103' ||
                heatingControlLookUpCode.lookupValue === '2104' ||
                heatingControlLookUpCode.lookupValue === '2105' ||
                heatingControlLookUpCode.lookupValue === '2106' ||
                heatingControlLookUpCode.lookupValue === '2111' ||
                heatingControlLookUpCode.lookupValue === '2107' ||
                heatingControlLookUpCode.lookupValue === '2108' ||
                heatingControlLookUpCode.lookupValue === '2109' ||
                heatingControlLookUpCode.lookupValue === '2110' ||
                heatingControlLookUpCode.lookupValue === '2112'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Electric storage systems']:
          this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
              return (
                heatingControlLookUpCode.lookupValue === '2401' ||
                heatingControlLookUpCode.lookupValue === '2402' ||
                heatingControlLookUpCode.lookupValue === '2404'
              );
            });
          break;
        case this.keyedLookUpCodes['HeatingType']['Community Heating Schemes']:
          if (!(heatingSystem === 'mainSystem2' && this.mainSystems === MAIN_SYSTEM_AND_DHW_ONLY)) {
            this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
                return (
                  heatingControlLookUpCode.lookupValue === '2301' ||
                  heatingControlLookUpCode.lookupValue === '2302' ||
                  heatingControlLookUpCode.lookupValue === '2303' ||
                  heatingControlLookUpCode.lookupValue === '2304' ||
                  heatingControlLookUpCode.lookupValue === '2305' ||
                  heatingControlLookUpCode.lookupValue === '2306' ||
                  heatingControlLookUpCode.lookupValue === '2307' ||
                  heatingControlLookUpCode.lookupValue === '2308' ||
                  heatingControlLookUpCode.lookupValue === '2309' ||
                  heatingControlLookUpCode.lookupValue === '2310' ||
                  heatingControlLookUpCode.lookupValue === '2311' ||
                  heatingControlLookUpCode.lookupValue === '2312'
                );
            });
          }
          break;
        case this.keyedLookUpCodes['HeatingType']['Boiler']:
          this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
              return (
                heatingControlLookUpCode.lookupValue === '2101' ||
                heatingControlLookUpCode.lookupValue === '2102' ||
                heatingControlLookUpCode.lookupValue === '2103' ||
                heatingControlLookUpCode.lookupValue === '2104' ||
                heatingControlLookUpCode.lookupValue === '2105' ||
                heatingControlLookUpCode.lookupValue === '2106' ||
                heatingControlLookUpCode.lookupValue === '2111' ||
                heatingControlLookUpCode.lookupValue === '2107' ||
                heatingControlLookUpCode.lookupValue === '2109' ||
                heatingControlLookUpCode.lookupValue === '2110' ||
                heatingControlLookUpCode.lookupValue === '2112'
              );
          });
          break;
        case this.keyedLookUpCodes['HeatingType']['HeatPump']:
          this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
              return (
                heatingControlLookUpCode.lookupValue === '2201' ||
                heatingControlLookUpCode.lookupValue === '2202' ||
                heatingControlLookUpCode.lookupValue === '2203' ||
                heatingControlLookUpCode.lookupValue === '2204' ||
                heatingControlLookUpCode.lookupValue === '2205' ||
                heatingControlLookUpCode.lookupValue === '2206' ||
                heatingControlLookUpCode.lookupValue === '2207' ||
                heatingControlLookUpCode.lookupValue === '2208'
              );
            }
          );
          break;
        default:
          this.heatingControlsBySystem[heatingSystem] = filter(this.lookUpCodesByDataItem['HeatingControls'], (heatingControlLookUpCode) => {
              return (
                heatingControlLookUpCode.lookupValue === '2101' ||
                heatingControlLookUpCode.lookupValue === '2102' ||
                heatingControlLookUpCode.lookupValue === '2103' ||
                heatingControlLookUpCode.lookupValue === '2104' ||
                heatingControlLookUpCode.lookupValue === '2705' ||
                heatingControlLookUpCode.lookupValue === '2506'
              );
            }
          );
      }
    } else {
      this.heatingControlsBySystem[heatingSystem] = [];
    }
  }

  setFanAssistedBoolean(heatingSystem) {
    if (this.keyedLookUpCodes) {
      if (this.eeHeating[`${heatingSystem}System`] === this.keyedLookUpCodes['HeatingSystem']['Gas fire, closed fronted, fan assisted']) {
        this.eeHeating[`${heatingSystem}FanAssisted`] = true;
      }
    }
  }

  setSecoundaryHeatingFuels() {
    if (this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['SecondaryHeatingFuel']) {
      if (this.eeHeating?.mainGasAvailable) {
        this.secondaryHeatingFuels = this.lookUpCodesByDataItem['SecondaryHeatingFuel'];
      } else {
        this.secondaryHeatingFuels = filter(this.lookUpCodesByDataItem['SecondaryHeatingFuel'], (heatingFuelLookUpCode) => {
            return heatingFuelLookUpCode.lookUpItem !== 'Mains Gas';
          }
        );
      }
    } else {
      this.secondaryHeatingFuels = [];
    }
  }

  setSecoundaryHeatingSystems() {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['SecondaryHeatingSystem']) {
      switch (this.eeHeating.secoundaryHeatingFuel) {
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Bottled LPG']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['LPG special condition']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Mains Gas']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Bulk LPG']:
          this.secoundaryHeatingSystems = filter(this.lookUpCodesByDataItem['SecondaryHeatingSystem'], (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '601' ||
                systemLookUpCode.lookupValue === '602' ||
                systemLookUpCode.lookupValue === '603' ||
                systemLookUpCode.lookupValue === '604' ||
                systemLookUpCode.lookupValue === '605' ||
                systemLookUpCode.lookupValue === '606' ||
                systemLookUpCode.lookupValue === '607' ||
                systemLookUpCode.lookupValue === '609' ||
                systemLookUpCode.lookupValue === '610' ||
                systemLookUpCode.lookupValue === '611' ||
                systemLookUpCode.lookupValue === '612' ||
                systemLookUpCode.lookupValue === '613'
              );
            }
          );
          break;
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['B30K']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Oil']:
          this.secoundaryHeatingSystems = filter(this.lookUpCodesByDataItem['SecondaryHeatingSystem'], (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '621' ||
                systemLookUpCode.lookupValue === '622' ||
                systemLookUpCode.lookupValue === '623' ||
                systemLookUpCode.lookupValue === '624' ||
                systemLookUpCode.lookupValue === '625'
              );
            }
          );
          break;
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Anthracite']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Wood logs']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Wood chips']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Duel fuel (mineral + wood)']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Smokeless coal']:
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['House coal']:
          this.secoundaryHeatingSystems = filter(this.lookUpCodesByDataItem['SecondaryHeatingSystem'], (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '631' ||
                systemLookUpCode.lookupValue === '632' ||
                systemLookUpCode.lookupValue === '633' ||
                systemLookUpCode.lookupValue === '634' ||
                systemLookUpCode.lookupValue === '635' ||
                systemLookUpCode.lookupValue === '636'
              );
            }
          );
          break;
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Bioethanol']:
          this.secoundaryHeatingSystems = filter(this.lookUpCodesByDataItem['SecondaryHeatingSystem'], (systemLookUpCode) => {
              return systemLookUpCode.lookupValue === '625';
            }
          );
          break;
        case this.keyedLookUpCodes['SecondaryHeatingFuel']['Electricity']:
          this.secoundaryHeatingSystems = filter(this.lookUpCodesByDataItem['SecondaryHeatingSystem'], (systemLookUpCode) => {
              return (
                systemLookUpCode.lookupValue === '691' ||
                systemLookUpCode.lookupValue === '694'
              );
            }
          );
          break;
        default:
          this.secoundaryHeatingSystems = [];
      }
    } else {
      this.secoundaryHeatingSystems = [];
    }
  }

  setWaterHeatingTypes() {
    if (!this.eeHeating) {
      return;
    }
    if (this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['WaterHeatingType']) {
      this.waterHeatingTypes = [];
      if (this.mainSystems === MAIN_SYSTEM_AND_DHW_ONLY) {
        if (this.eeHeating.secoundaryHeatingFuel?.length) {
          this.waterHeatingTypes = filter(this.lookUpCodesByDataItem['WaterHeatingType'], (typeLookUpCode) => {
              return (
                typeLookUpCode.lookUpItem === 'From Main System 2' ||
                typeLookUpCode.lookUpItem === 'From Secondary system'
              );
            }
          );
        } else {
          this.waterHeatingTypes = filter(this.lookUpCodesByDataItem['WaterHeatingType'], (typeLookUpCode) => {
              return typeLookUpCode.lookUpItem === 'From Main System 2';
            }
          );
        }
        this.eeHeating.waterHeatingSystem = this.eeHeating.waterHeatingSystem ?? null;
      } else if (this.mainSystems === 'None installed') {
        if (this.eeHeating.secoundaryHeatingFuel?.length) {
          this.waterHeatingTypes = filter(this.lookUpCodesByDataItem['WaterHeatingType'], (typeLookUpCode) => {
              return (
                typeLookUpCode.lookupValue !== '901' &&
                typeLookUpCode.lookupValue !== '914'
              );
            }
          );
        } else {
          this.waterHeatingTypes = filter(this.lookUpCodesByDataItem['WaterHeatingType'], (typeLookUpCode) => {
              return (
                typeLookUpCode.lookupValue !== '901' &&
                typeLookUpCode.lookupValue !== '902' &&
                typeLookUpCode.lookupValue !== '914'
              );
            }
          );
        }
        this.eeHeating.waterHeatingSystem = this.eeHeating.waterHeatingSystem ?? null;
      } else if (this.mainSystems === '1 Main system') {
        if (this.eeHeating.secoundaryHeatingFuel?.length) {
          this.waterHeatingTypes = filter(this.lookUpCodesByDataItem['WaterHeatingType'], (typeLookUpCode) => {
              return typeLookUpCode.lookupValue !== '914';
            }
          );
        } else {
          this.waterHeatingTypes = filter(this.lookUpCodesByDataItem['WaterHeatingType'], (typeLookUpCode) => {
              return (
                typeLookUpCode.lookupValue !== '902' &&
                typeLookUpCode.lookupValue !== '914'
              );
            }
          );
        }
        this.eeHeating.waterHeatingSystem = this.eeHeating.waterHeatingSystem ?? null;
      } else {
        if (!this.eeHeating.secoundaryHeatingFuel?.length) {
          this.waterHeatingTypes = filter(this.lookUpCodesByDataItem['WaterHeatingType'], (typeLookUpCode) => {
              return typeLookUpCode.lookupValue !== '902';
            }
          );
        } else {
          this.waterHeatingTypes = this.lookUpCodesByDataItem['WaterHeatingType'];
        }
      }
    } else {
      this.waterHeatingTypes = [];
    }
  }

  setWaterHeatingFuels() {
    if (this.keyedLookUpCodes && this.keyedLookUpCodes['WaterHeatingType'] && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['HeatingFuel']) {
      switch (this.eeHeating.waterHeatingSystem) {
        case this.keyedLookUpCodes['WaterHeatingType']['None']:
          this.eeHeating.waterHeatingFuel = '0';
          this.waterHeatingFuels = [];
          break;
        case this.keyedLookUpCodes['WaterHeatingType']['From Main System 1']:
          this.eeHeating.waterHeatingFuel = this.eeHeating.mainSystem1Fuel;
          this.waterHeatingFuels = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (fuelLookUpCode.lookupValue === this.eeHeating.mainSystem1Fuel);
          });
          break;
        case this.keyedLookUpCodes['WaterHeatingType']['From Main System 2']:
          this.eeHeating.waterHeatingFuel = this.eeHeating.mainSystem2Fuel;
          this.waterHeatingFuels = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (fuelLookUpCode.lookupValue === this.eeHeating.mainSystem2Fuel);
          });
          break;
        case this.keyedLookUpCodes['WaterHeatingType']['From Secondary system']:
          this.eeHeating.waterHeatingFuel = this.eeHeating.secoundaryHeatingFuel;
          this.waterHeatingFuels = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (fuelLookUpCode.lookupValue === this.eeHeating.secoundaryHeatingFuel);
          });
          break;
        case this.keyedLookUpCodes['WaterHeatingType']['Electric immersion']:
        case this.keyedLookUpCodes['WaterHeatingType']['Electric instantaneous at point of use']:
        case this.keyedLookUpCodes['WaterHeatingType']['Electric heat pump for water heating only']:
          this.waterHeatingFuels = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return fuelLookUpCode.lookupValue === '29';
            }
          );
          this.eeHeating.waterHeatingFuel = this.waterHeatingFuels[0].lookupValue;
          break;
        case this.keyedLookUpCodes['WaterHeatingType']['Single-point gas water heater (instantaneous at point of use)']:
        case this.keyedLookUpCodes['WaterHeatingType']['Multi-point gas water heater (instantaneous serving several taps)']:
        case this.keyedLookUpCodes['WaterHeatingType']['Gas boiler/circulator for water heating only']:
        case this.keyedLookUpCodes['WaterHeatingType']['Range cooker, gas, single burner, with permanent pilot']:
        case this.keyedLookUpCodes['WaterHeatingType']['Range cooker, gas, single burner, with automatic ignition']:
        case this.keyedLookUpCodes['WaterHeatingType']['Range cooker, gas, twin burner, with automatic ignition (pre 1998)']:
          this.waterHeatingFuels = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (
                fuelLookUpCode.lookupValue === '26' ||
                fuelLookUpCode.lookupValue === '27' ||
                fuelLookUpCode.lookupValue === '3' ||
                fuelLookUpCode.lookupValue === '17' ||
                fuelLookUpCode.lookupValue === '51'
              );
            }
          );
          break;
        case this.keyedLookUpCodes['WaterHeatingType']['Oil boiler/circulator for water heating only']:
        case this.keyedLookUpCodes['WaterHeatingType']['Range cooker, oil, single burner']:
        case this.keyedLookUpCodes['WaterHeatingType']['Range cooker, oil, twin burner (pre 1998)']:
          this.waterHeatingFuels = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (
                fuelLookUpCode.lookupValue === '28' ||
                fuelLookUpCode.lookupValue === '18' ||
                fuelLookUpCode.lookupValue === '37'
              );
            }
          );
          break;
        case this.keyedLookUpCodes['WaterHeatingType']['Solid fuel boiler/circulator for water heating only']:
        case this.keyedLookUpCodes['WaterHeatingType']['Range cooker, solid fuel, integral oven and boiler']:
        case this.keyedLookUpCodes['WaterHeatingType']['Range cooker, solid fuel, independent oven and boiler']:
          this.waterHeatingFuels = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (
                fuelLookUpCode.lookupValue === '5' ||
                fuelLookUpCode.lookupValue === '6' ||
                fuelLookUpCode.lookupValue === '7' ||
                fuelLookUpCode.lookupValue === '8' ||
                fuelLookUpCode.lookupValue === '9' ||
                fuelLookUpCode.lookupValue === '15' ||
                fuelLookUpCode.lookupValue === '33'
              );
            }
          );
          break;
        case this.keyedLookUpCodes['WaterHeatingType']['Hot water only community scheme - boilers']:
        case this.keyedLookUpCodes['WaterHeatingType']['Hot water only community scheme - CHP']:
        case this.keyedLookUpCodes['WaterHeatingType']['Hot water only community scheme - heat pump']:
        case this.keyedLookUpCodes['WaterHeatingType']['Hot water only community scheme - heat network']:
          this.waterHeatingFuels = filter(this.lookUpCodesByDataItem['HeatingFuel'], (fuelLookUpCode) => {
              return (
                fuelLookUpCode.lookupValue === '20' ||
                fuelLookUpCode.lookupValue === '21' ||
                fuelLookUpCode.lookupValue === '22' ||
                fuelLookUpCode.lookupValue === '23' ||
                fuelLookUpCode.lookupValue === '24' ||
                fuelLookUpCode.lookupValue === '25' ||
                fuelLookUpCode.lookupValue === '30' ||
                fuelLookUpCode.lookupValue === '31' ||
                fuelLookUpCode.lookupValue === '32' ||
                fuelLookUpCode.lookupValue === '56' ||
                fuelLookUpCode.lookupValue === '57' ||
                fuelLookUpCode.lookupValue === '58' ||
                fuelLookUpCode.lookupValue === '99'
              );
            }
          );
          break;
        default:
          this.eeHeating.waterHeatingFuel = null;
          this.waterHeatingFuels = [];
      }
    } else {
      this.waterHeatingFuels = [];
    }
  }

  hasExcludedMainHeatingSystemsForWaterHeatingCylinder(heatingSystem) {
    if (
      this.eeHeating[`${heatingSystem}System`] === '103' ||
      this.eeHeating[`${heatingSystem}System`] === '104' ||
      this.eeHeating[`${heatingSystem}System`] === '107' ||
      this.eeHeating[`${heatingSystem}System`] === '108' ||
      this.eeHeating[`${heatingSystem}System`] === '112' ||
      this.eeHeating[`${heatingSystem}System`] === '113' ||
      this.eeHeating[`${heatingSystem}System`] === '118' ||
      this.eeHeating[`${heatingSystem}System`] === '128' ||
      this.eeHeating[`${heatingSystem}System`] === '129' ||
      this.eeHeating[`${heatingSystem}System`] === '130'
    ) {
      return true;
    }
    return false;
  }

  showWaterHeatingCylinderCard() {
    if (this.keyedLookUpCodes) {
      if (!this.eeHeating.waterHeatingSystem ||
        this.eeHeating.waterHeatingSystem === '907' ||
        this.eeHeating.waterHeatingSystem === '908' ||
        this.eeHeating.waterHeatingSystem === '909') {
        this.eeHeating.cylinderDetailsSize = '1';
        return false;
      } else if (
        (this.eeHeating.waterHeatingSystem === this.keyedLookUpCodes['WaterHeatingType']['From Main System 1'] && this.hasExcludedMainHeatingSystemsForWaterHeatingCylinder('mainSystem1')) ||
        (this.eeHeating.waterHeatingSystem === this.keyedLookUpCodes['WaterHeatingType']['From Main System 2'] && this.hasExcludedMainHeatingSystemsForWaterHeatingCylinder('mainSystem2'))
      ) {
        this.eeHeating.cylinderDetailsSize = '1';
        return false;
      } else {
        return true;
      }
    }
    this.eeHeating.cylinderDetailsSize = '1';
    return false;
  }

  setImmersionTypes() {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['ImmersionType']) {
      if (this.eeHeating.electricMeter === this.keyedLookUpCodes['ElectricityMeter']['Single']) {
        this.immersionTypes = filter(this.lookUpCodesByDataItem['ImmersionType'], (imersionTypeLookUpCode) => {
            return imersionTypeLookUpCode.lookUpItem !== 'Dual immersion';
          }
        );
        this.eeHeating.cylinderDetailsImmersion = this.immersionTypes[0].lookupValue;
      } else {
        this.immersionTypes = this.lookUpCodesByDataItem['ImmersionType'];
      }
    } else {
      this.immersionTypes = [];
    }
  }

  setRenewablesArrayOrientations(arrayName) {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['Orientation']) {
      if (this.eeRR[`${arrayName}Pitch`] !== this.keyedLookUpCodes['VerticalPitch']['Horizontal']) {
        this.renewablesOrientationsByArray[arrayName] = filter(this.lookUpCodesByDataItem['Orientation'], (orientationLookUpCode) => {
            return orientationLookUpCode.lookUpItem !== 'Horizontal';
          }
        );
        if (this.eeRR[`${arrayName}Orientation`] === this.keyedLookUpCodes['Orientation']['Horizontal']) {
          this.eeRR[`${arrayName}Orientation`] = null;
        }
      } else {
        this.renewablesOrientationsByArray[arrayName] = filter(this.lookUpCodesByDataItem['Orientation'], (orientationLookUpCode) => {
            return orientationLookUpCode.lookUpItem === 'Horizontal';
          }
        );
        this.eeRR[`${arrayName}Orientation`] = this.renewablesOrientationsByArray[arrayName][0].lookupValue;
      }
    } else {
      this.renewablesOrientationsByArray[arrayName] = [];
    }
  }

  setRenewablesSWHOrientations() {
    if (this.keyedLookUpCodes && this.lookUpCodesByDataItem && this.lookUpCodesByDataItem['Orientation']) {
      if (this.eeRR.solarWaterHeaterPitch !== this.keyedLookUpCodes['VerticalPitch']['Horizontal']) {
        this.renewablesSwhOrientations = filter(this.lookUpCodesByDataItem['Orientation'], (orientationLookUpCode) => {
            return orientationLookUpCode.lookUpItem !== 'Horizontal';
          }
        );
        if (this.eeRR.solarWaterHeaterOrientation === this.keyedLookUpCodes['Orientation']['Horizontal']) {
          this.eeRR.solarWaterHeaterOrientation = null;
        }
      } else {
        this.renewablesSwhOrientations = filter(this.lookUpCodesByDataItem['Orientation'], (orientationLookUpCode) => {
            return orientationLookUpCode.lookUpItem === 'Horizontal';
          }
        );
        this.eeRR.solarWaterHeaterOrientation = this.renewablesSwhOrientations[0].lookupValue;
      }
    } else {
      this.renewablesSwhOrientations = [];
    }
  }

  renewablesNumberOfTurbinesChanged() {
    if (this.keyedLookUpCodes && this.keyedLookUpCodes['WindTurbines']) {
      if (!this.eeRR.numberOfTurbines || this.eeRR.numberOfTurbines === this.keyedLookUpCodes['WindTurbines']['None']) {}
    }
  }

  setRoofInsulationThicknessArrays(buildingPartKey) {
    if (this.keyedLookUpCodes && this.roofInsulationThicknesses && this.keyedLookUpCodes['RoofInsulationLocation']) {
      if (this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['At joists']) {
        if (this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched (slates or tiles), access to loft'] ||
          this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched (slates or tiles), no loft access'] ||
          this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched (thatched)']) {
          this.roofInsulationThicknessesByBuildingPart[buildingPartKey] = filter(this.roofInsulationThicknesses, (thickness) => {
              return (
                thickness.lookUpItem !== '150mm+' &&
                thickness.lookUpItem !== 'As built'
              );
            });
        } else {
          this.roofInsulationThicknessesByBuildingPart[buildingPartKey] = filter(this.roofInsulationThicknesses, (thickness) => {
              return thickness.lookUpItem !== '150mm+';
            });
        }
      } else if (
        this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['At rafters'] ||
        this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['Flat roof insulation'] ||
        this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['Sloping ceiling insulation']
      ) {
        this.roofInsulationThicknessesByBuildingPart[buildingPartKey] = filter(this.roofInsulationThicknesses, (thickness) => {
            return (
              thickness.lookUpItem === 'As built' ||
              thickness.lookUpItem === '50mm' ||
              thickness.lookUpItem === '100mm' ||
              thickness.lookUpItem === '150mm+' ||
              thickness.lookUpItem === 'Unknown'
            );
          }
        ).map((thickness) => {
          if (thickness.lookUpItem === '150mm+') {
            return { ...thickness, lookupValue: '150mm' };
          }
          return thickness;
        });
        if (this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['Flat roof insulation'] ||
          this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['Sloping ceiling insulation']) {
          if (!this[buildingPartKey].roofInsulationThickness) {
            this[buildingPartKey].roofInsulationThickness = this.roofInsulationThicknessesByBuildingPart[buildingPartKey][1].lookupValue;
          }
        }
        if (this[buildingPartKey].roofInsulationThickness !== this.keyedLookUpCodes['RoofInsulationThickness']['As built'] &&
          this[buildingPartKey].roofInsulationThickness !== this.keyedLookUpCodes['RoofInsulationThickness']['50mm'] &&
          this[buildingPartKey].roofInsulationThickness !== this.keyedLookUpCodes['RoofInsulationThickness']['100mm'] &&
          this[buildingPartKey].roofInsulationThickness !== this.keyedLookUpCodes['RoofInsulationThickness']['150mm'] &&
          this[buildingPartKey].roofInsulationThickness !== this.keyedLookUpCodes['RoofInsulationThickness']['150mm+'] &&
          this[buildingPartKey].roofInsulationThickness !== this.keyedLookUpCodes['RoofInsulationThickness']['Unknown']
        ) {
          this[buildingPartKey].roofInsulationThickness = null;
        }
      } else if (
        this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['None'] ||
        this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['Unknown']
      ) {
        this.roofInsulationThicknessesByBuildingPart[buildingPartKey] = [];
        this[buildingPartKey].roofInsulationThickness = null;
      } else {
        this.roofInsulationThicknessesByBuildingPart[buildingPartKey] = this.roofInsulationThicknesses;
      }
    } else {
      this.roofInsulationThicknessesByBuildingPart[buildingPartKey] = [];
    }
  }

  setRoofInsulationTypeArrays(buildingPartKey) {
    if (this.keyedLookUpCodes && this.roofInsulationTypes && this.keyedLookUpCodes['RoofConstruction']) {
      if (this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched (slates or tiles), no loft access'] ||
        this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['None'] ||
        this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Unknown']
      ) {
        this.roofInsulationTypesByBuildingPart[buildingPartKey] = filter(this.roofInsulationTypes, (insulationType) => {
            return (
              insulationType.lookUpItem === 'At joists' ||
              insulationType.lookUpItem === 'At rafters' ||
              insulationType.lookUpItem === 'None' ||
              insulationType.lookUpItem === 'Unknown'
            );
          }
        );
        if (this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['At joists'] &&
          this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['At rafters'] &&
          this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['None'] &&
          this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['Unknown']
        ) {
          this[buildingPartKey].roofInsulationType = null;
        }
      } else if (
        this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched, sloping ceiling']
      ) {
        this.roofInsulationTypesByBuildingPart[buildingPartKey] = filter(this.roofInsulationTypes, (insulationType) => {
            return (insulationType.lookUpItem === 'Sloping ceiling insulation' || insulationType.lookUpItem === 'Unknown');
          }
        );
        if (!this[buildingPartKey].roofInsulationType) {
          this[buildingPartKey].roofInsulationType = this.roofInsulationTypesByBuildingPart[buildingPartKey][1].lookupValue;
        }
        if (this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['Sloping ceiling insulation'] && this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['Unknown']) {
          this[buildingPartKey].roofInsulationType = null;
        }
      } else if (this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Flat roof']) {
        this.roofInsulationTypesByBuildingPart[buildingPartKey] = filter( this.roofInsulationTypes, (insulationType) => {
            return (insulationType.lookUpItem === 'Flat roof insulation' || insulationType.lookUpItem === 'Unknown');
          }
        );
        if (!this[buildingPartKey].roofInsulationType) {
          this[buildingPartKey].roofInsulationType = this.roofInsulationTypesByBuildingPart[buildingPartKey][1].lookupValue;
        }
        if (this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['Flat roof insulation'] &&
          this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['Unknown']) {
          this[buildingPartKey].roofInsulationType = null;
        }
      } else if (this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Another dwelling above'] ||
        this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Same dwelling above']) {
        this.roofInsulationTypesByBuildingPart[buildingPartKey] = [];
        this[buildingPartKey].roofInsulationType = null;
        this[buildingPartKey].roofInsulationThickness = null;
      } else if (
        this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched (slates or tiles), access to loft'] ||
        this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched (thatched)']) {
        this.roofInsulationTypesByBuildingPart[buildingPartKey] = filter(this.roofInsulationTypes, (insulationType) => {
            return (
              insulationType.lookUpItem === 'Unknown' ||
              insulationType.lookUpItem === 'None' ||
              insulationType.lookUpItem === 'At rafters' ||
              insulationType.lookUpItem === 'At joists'
            );
          }
        );
        if (this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['Unknown'] &&
          this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['None'] &&
          this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['At rafters'] &&
          this[buildingPartKey].roofInsulationType !== this.keyedLookUpCodes['RoofInsulationLocation']['At joists']
        ) {
          this[buildingPartKey].roofInsulationType = null;
        }
      } else {
        this.roofInsulationTypesByBuildingPart[buildingPartKey] =
          this.roofInsulationTypes;
      }
    } else {
      this.roofInsulationTypesByBuildingPart[buildingPartKey] = [];
    }
  }

  onFloorConstructionChange(buildingPartKey: string) {
    if(this[buildingPartKey].floorConstruction !== null) {
      this[buildingPartKey].floorInsulationType = this.keyedLookUpCodes['FloorInsulation']['As-built'];
    }
  }

  onRoofConstructionChange(value, buildingPartKey) {
    this[buildingPartKey].roofConstruction = value;
    this.setRoofInsulationTypeArrays(buildingPartKey);
    if (this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Flat roof']) {
      this[buildingPartKey].flatRoofInsulationThickness = 'AB';
      this[buildingPartKey].roofInsulationType = '6';
    } else if (this[buildingPartKey].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched, sloping ceiling']) {
      this[buildingPartKey].slopingCeilingInsulationThickness = 'AB';
      this[buildingPartKey].roofInsulationType = '7';
    }
    this.setRoofInsulationThicknessArrays(buildingPartKey);
    if (this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['Flat roof insulation'] ||
      this[buildingPartKey].roofInsulationType === this.keyedLookUpCodes['RoofInsulationLocation']['Sloping ceiling insulation']) {
      if (!this[buildingPartKey].roofInsulationThickness) {
        this[buildingPartKey].roofInsulationThickness = this.roofInsulationThicknessesByBuildingPart[buildingPartKey][1].lookupValue;
      }
    }
  }

  onRoofInsulationTypeChange(buildingPartKey) {
    if (this[buildingPartKey].roofInsulationType == this.keyedLookUpCodes['RoofInsulationLocation']['Unknown'] || this[buildingPartKey].roofInsulationType == this.keyedLookUpCodes['RoofInsulationLocation']['None']) {
      this[buildingPartKey].roofInsulationThickness = null;
    }
  }

  onWallConstructionChange(buildingPartKey) {
    this[buildingPartKey].wallsInsulationType = this.keyedLookUpCodes['WallInsulation']['As built'];
  }

  onaAlternativeWallConstructionChange(buildingPartKey) {
    this[buildingPartKey].additionalWallsInsulationType = this.keyedLookUpCodes['WallInsulation']['As built'];
  }

  setWallsInsulationTypeToNull(buildingPartKey, wallsConstructionKey, wallsInsulationTypeKey) {
    if (this.keyedLookUpCodes && this.keyedLookUpCodes['WallConstruction'] && this[buildingPartKey][wallsConstructionKey] !== this.keyedLookUpCodes['WallConstruction']['Cavity'] &&
      (this[buildingPartKey][wallsInsulationTypeKey] === this.keyedLookUpCodes['WallInsulation']['Filled cavity'] ||
        this[buildingPartKey][wallsInsulationTypeKey] === this.keyedLookUpCodes['WallInsulation']['Filled cavity and internal'] ||
        this[buildingPartKey][wallsInsulationTypeKey] === this.keyedLookUpCodes['WallInsulation']['Filled cavity and external'])) {
        this[buildingPartKey][wallsInsulationTypeKey] = null;
    }
  }

  openEEOpeningsMeasurementWindowsModal(openingId: number, buildingPartNumber: number): void {
    const windowsDetailsForActiveDataSet = this.eeOpeningDetailsForActiveDataSet.measuredWindowsDetails != null ? this.eeOpeningDetailsForActiveDataSet.measuredWindowsDetails.filter((details) => details.buildingPartNumber == buildingPartNumber) : [];
    const modalRef = this.modalService.open(MeasurementWindowsModalComponent, {backdrop: 'static', windowClass: 'custom-modal-class',});
    modalRef.componentInstance.openingId = openingId;
    modalRef.componentInstance.windowLocation = buildingPartNumber;
    modalRef.componentInstance.windowsDetails = cloneDeep(this.eeOpeningDetails.sapWindows);
    modalRef.componentInstance.windowsDetailsForActiveDataSet = windowsDetailsForActiveDataSet;
    modalRef.componentInstance.hasActiveDataSet = this.hasAnActiveDataSet;
    modalRef.componentInstance.eeRRLookupCodes = this.eeRRLookupCodes;
    modalRef.componentInstance.keyedLookUpCodes = this.keyedLookUpCodes;
    modalRef.componentInstance.lookUpCodesByDataItem = this.lookUpCodesByDataItem;
    modalRef.componentInstance.isEdit = this.isEdit;
    modalRef.componentInstance.modifiedBackgroundClass = this.modifiedBackgroundClass;
    modalRef.componentInstance.countryCode = this.eeGeneralDetails.address.countryCode;
    modalRef.result.then((windowsDetails) => {
      if (!this.form.dirty && !isEqual(cloneDeep(this.eeOpeningDetails.sapWindows), windowsDetails)) {
        this.form.markAsDirty();
      }
      windowsDetails.forEach((detail) => {
        delete detail.openingId;
        detail.windowType = detail.windowType === true ? '2' : '1';
      });
      this.eeOpeningDetails.sapWindows = cloneDeep(windowsDetails);
    });
  }
  
  onHeatedBasementChange(event: Event) {
    const elem = event.target as HTMLInputElement;
    this.heatedBasement = elem.checked;
    localStorage.setItem('heatedBasement', JSON.stringify(this.heatedBasement));
  }

  openDimensionDetailsModal(buildingPart) {
    
    if (!this.keyedLookUpCodes) {
      return;
    }
    const partyWallConstructionIsNotApplicable = this.eeGeneralDetails.builtForm === this.keyedLookUpCodes['BuiltForm']['Detached'];
    if (this[buildingPart].dimensionsArray != null) {} else {
      this[buildingPart].dimensionsArray = [
        {
          floor: '0',
          area: '0',
          height: '0',
          perimeter: '0',
          partyWall: partyWallConstructionIsNotApplicable ? 0 : null,
        },
      ];
    }
    const modalRef = this.modalService.open(RdSAPDimensionDetailsModalComponent, { backdrop: 'static', windowClass: 'dimension-modal-class', });
    modalRef.componentInstance.numberOfFloors = this[buildingPart].dimensionsNumberOfFloors ?? this[buildingPart].dimensionsArray?.length;
    modalRef.componentInstance.buildingDimensionDetails = cloneDeep(this[buildingPart].dimensionsArray);
    modalRef.componentInstance.hasActiveDataSet = this.hasAnActiveDataSet;
    modalRef.componentInstance.activeDataSetBuildingDimensionDetails = this[`${buildingPart}ForActiveDataSet`].dimensionsArray;
    modalRef.componentInstance.isEdit = this.isEdit;
    modalRef.componentInstance.modifiedBackgroundClass = this.modifiedBackgroundClass;
    modalRef.componentInstance.partyWallConstructionNotApplicable = partyWallConstructionIsNotApplicable;
    if (buildingPart === 'eeBDMainBuilding') {
      const storedState = localStorage.getItem('heatedBasement');
      if (storedState !== null) {
        this.heatedBasement = JSON.parse(storedState);
      }
    } else {
      this.heatedBasement = false;
    }
    modalRef.componentInstance.heatedBasement = this.heatedBasement;
    modalRef.result.then((result) => {
      if (result && !this.form.dirty && !isEqual(cloneDeep(this[buildingPart].dimensionsArray), result.dimensionDetails)) {
        this.form.markAsDirty();
      }
      if (result) {
        this[buildingPart].dimensionsArray = cloneDeep(result.dimensionDetails);
        this[buildingPart].dimensionsNumberOfFloors = result.numberOfFloors;
        if (this.eeGeneralDetails.corridorType == '2') {
          this.calculateAlternativeWallArea(this[buildingPart]);
        }
      }
    });
  }

  openShowerProfileModal(): void {
    const modalRef = this.modalService.open(ShowerProfileDetailsComponent, {backdrop: 'static',});
    modalRef.result.then(() => {
      this.load();
    });
  }

  openEEBDMainBuildingExtendedDataModal(buildingPartNumber: number): void {
    const modalRef = this.modalService.open(EEBDMainBuildingRoofExtendedDataModalComponent, { windowClass: 'small-modal' });
    modalRef.componentInstance.buildingPartNumber = buildingPartNumber;
    modalRef.componentInstance.isEdit = this.isEdit;
    modalRef.componentInstance.buildingRoofExtendedDataDetails = cloneDeep(this.eeBDMainBuilding);
    modalRef.result.then((result) => {
      if (!this.form.dirty && !isEqual(cloneDeep(this.eeBDMainBuilding), result)) {
        this.form.markAsDirty();
      }
      result.forEach((detail) => {
        this.eeBDMainBuilding.flatCeilingOneArea = detail.flatCeilingOneArea || null;
        this.eeBDMainBuilding.flatCeilingOneUValue = detail.flatCeilingOneUValue || null;
        this.eeBDMainBuilding.flatCeilingTwoArea = detail.flatCeilingTwoArea || null;
        this.eeBDMainBuilding.flatCeilingTwoUValue = detail.flatCeilingTwoUValue || null;
        this.eeBDMainBuilding.slopeOneArea = detail.slopeOneArea || null;
        this.eeBDMainBuilding.slopeOneUValue = detail.slopeOneUValue || null;
        this.eeBDMainBuilding.slopeTwoArea = detail.slopeTwoArea || null;
        this.eeBDMainBuilding.slopeTwoUValue = detail.slopeTwoUValue || null;
        this.eeBDMainBuilding.studWallOneArea = detail.studWallOneArea || null;
        this.eeBDMainBuilding.studWallOneUValue = detail.studWallOneUValue || null;
        this.eeBDMainBuilding.studWallTwoArea = detail.studWallTwoArea || null;
        this.eeBDMainBuilding.studWallTwoUValue = detail.studWallTwoUValue || null;
        this.eeBDMainBuilding.gableWallOneArea = detail.gableWallOneArea || null;
        this.eeBDMainBuilding.gableWallOneUValue = detail.gableWallOneUValue || null;
        this.eeBDMainBuilding.gableWallTwoArea = detail.gableWallTwoArea || null;
        this.eeBDMainBuilding.gableWallTwoUValue = detail.gableWallTwoUValue || null;
      });
    });
  }

  openEEBDEx1ExtendedDataModal(buildingPartNumber: number): void {
    const modalRef = this.modalService.open(EEBDMainBuildingRoofExtendedDataModalComponent,{ windowClass: 'small-modal' });
    modalRef.componentInstance.buildingPartNumber = buildingPartNumber;
    modalRef.componentInstance.isEdit = this.isEdit;
    modalRef.componentInstance.buildingRoofExtendedDataDetails = cloneDeep(this.eeBDEx1);
    modalRef.result.then((result) => {
      if (!this.form.dirty && !isEqual(cloneDeep(this.eeBDEx1), result)) {
        this.form.markAsDirty();
      }
      result.forEach((detail) => {
        this.eeBDEx1.flatCeilingOneArea = detail.flatCeilingOneArea || null;
        this.eeBDEx1.flatCeilingOneUValue = detail.flatCeilingOneUValue || null;
        this.eeBDEx1.flatCeilingTwoArea = detail.flatCeilingTwoArea || null;
        this.eeBDEx1.flatCeilingTwoUValue = detail.flatCeilingTwoUValue || null;
        this.eeBDEx1.slopeOneArea = detail.slopeOneArea || null;
        this.eeBDEx1.slopeOneUValue = detail.slopeOneUValue || null;
        this.eeBDEx1.slopeTwoArea = detail.slopeTwoArea || null;
        this.eeBDEx1.slopeTwoUValue = detail.slopeTwoUValue || null;
        this.eeBDEx1.studWallOneArea = detail.studWallOneArea || null;
        this.eeBDEx1.studWallOneUValue = detail.studWallOneUValue || null;
        this.eeBDEx1.studWallTwoArea = detail.studWallTwoArea || null;
        this.eeBDEx1.studWallTwoUValue = detail.studWallTwoUValue || null;
        this.eeBDEx1.gableWallOneArea = detail.gableWallOneArea || null;
        this.eeBDEx1.gableWallOneUValue = detail.gableWallOneUValue || null;
        this.eeBDEx1.gableWallTwoArea = detail.gableWallTwoArea || null;
        this.eeBDEx1.gableWallTwoUValue = detail.gableWallTwoUValue || null;
      });
    });
  }

  openEEBDEx2ExtendedDataModal(buildingPartNumber: number): void {
    const modalRef = this.modalService.open(EEBDMainBuildingRoofExtendedDataModalComponent, { windowClass: 'small-modal' });
    modalRef.componentInstance.buildingPartNumber = buildingPartNumber;
    modalRef.componentInstance.isEdit = this.isEdit;
    modalRef.componentInstance.buildingRoofExtendedDataDetails = cloneDeep(this.eeBDEx2);
    modalRef.result.then((result) => {
      if (!this.form.dirty && !isEqual(cloneDeep(this.eeBDEx2), result)) {
        this.form.markAsDirty();
      }
      result.forEach((detail) => {
        this.eeBDEx2.flatCeilingOneArea = detail.flatCeilingOneArea || null;
        this.eeBDEx2.flatCeilingOneUValue = detail.flatCeilingOneUValue || null;
        this.eeBDEx2.flatCeilingTwoArea = detail.flatCeilingTwoArea || null;
        this.eeBDEx2.flatCeilingTwoUValue = detail.flatCeilingTwoUValue || null;
        this.eeBDEx2.slopeOneArea = detail.slopeOneArea || null;
        this.eeBDEx2.slopeOneUValue = detail.slopeOneUValue || null;
        this.eeBDEx2.slopeTwoArea = detail.slopeTwoArea || null;
        this.eeBDEx2.slopeTwoUValue = detail.slopeTwoUValue || null;
        this.eeBDEx2.studWallOneArea = detail.studWallOneArea || null;
        this.eeBDEx2.studWallOneUValue = detail.studWallOneUValue || null;
        this.eeBDEx2.studWallTwoArea = detail.studWallTwoArea || null;
        this.eeBDEx2.studWallTwoUValue = detail.studWallTwoUValue || null;
        this.eeBDEx2.gableWallOneArea = detail.gableWallOneArea || null;
        this.eeBDEx2.gableWallOneUValue = detail.gableWallOneUValue || null;
        this.eeBDEx2.gableWallTwoArea = detail.gableWallTwoArea || null;
        this.eeBDEx2.gableWallTwoUValue = detail.gableWallTwoUValue || null;
      });
    });
  }

  openEEBDEx3ExtendedDataModal(buildingPartNumber: number): void {
    const modalRef = this.modalService.open(EEBDMainBuildingRoofExtendedDataModalComponent, { windowClass: 'small-modal' });
    modalRef.componentInstance.buildingPartNumber = buildingPartNumber;
    modalRef.componentInstance.isEdit = this.isEdit;
    modalRef.componentInstance.buildingRoofExtendedDataDetails = cloneDeep(this.eeBDEx3);
    modalRef.result.then((result) => {
      if (!this.form.dirty && !isEqual(cloneDeep(this.eeBDEx3), result)) {
        this.form.markAsDirty();
      }
      result.forEach((detail) => {
        this.eeBDEx3.flatCeilingOneArea = detail.flatCeilingOneArea || null;
        this.eeBDEx3.flatCeilingOneUValue = detail.flatCeilingOneUValue || null;
        this.eeBDEx3.flatCeilingTwoArea = detail.flatCeilingTwoArea || null;
        this.eeBDEx3.flatCeilingTwoUValue = detail.flatCeilingTwoUValue || null;
        this.eeBDEx3.slopeOneArea = detail.slopeOneArea || null;
        this.eeBDEx3.slopeOneUValue = detail.slopeOneUValue || null;
        this.eeBDEx3.slopeTwoArea = detail.slopeTwoArea || null;
        this.eeBDEx3.slopeTwoUValue = detail.slopeTwoUValue || null;
        this.eeBDEx3.studWallOneArea = detail.studWallOneArea || null;
        this.eeBDEx3.studWallOneUValue = detail.studWallOneUValue || null;
        this.eeBDEx3.studWallTwoArea = detail.studWallTwoArea || null;
        this.eeBDEx3.studWallTwoUValue = detail.studWallTwoUValue || null;
        this.eeBDEx3.gableWallOneArea = detail.gableWallOneArea || null;
        this.eeBDEx3.gableWallOneUValue = detail.gableWallOneUValue || null;
        this.eeBDEx3.gableWallTwoArea = detail.gableWallTwoArea || null;
        this.eeBDEx3.gableWallTwoUValue = detail.gableWallTwoUValue || null;
      });
    });
  }

  openEEBDEx4ExtendedDataModal(buildingPartNumber: number): void {
    const modalRef = this.modalService.open(EEBDMainBuildingRoofExtendedDataModalComponent, { windowClass: 'small-modal' });
    modalRef.componentInstance.buildingPartNumber = buildingPartNumber;
    modalRef.componentInstance.isEdit = this.isEdit;
    modalRef.componentInstance.buildingRoofExtendedDataDetails = cloneDeep(this.eeBDEx4);
    modalRef.result.then((result) => {
      if (!this.form.dirty && !isEqual(cloneDeep(this.eeBDEx4), result)) {
        this.form.markAsDirty();
      }
      result.forEach((detail) => {
        this.eeBDEx4.flatCeilingOneArea = detail.flatCeilingOneArea || null;
        this.eeBDEx4.flatCeilingOneUValue = detail.flatCeilingOneUValue || null;
        this.eeBDEx4.flatCeilingTwoArea = detail.flatCeilingTwoArea || null;
        this.eeBDEx4.flatCeilingTwoUValue = detail.flatCeilingTwoUValue || null;
        this.eeBDEx4.slopeOneArea = detail.slopeOneArea || null;
        this.eeBDEx4.slopeOneUValue = detail.slopeOneUValue || null;
        this.eeBDEx4.slopeTwoArea = detail.slopeTwoArea || null;
        this.eeBDEx4.slopeTwoUValue = detail.slopeTwoUValue || null;
        this.eeBDEx4.studWallOneArea = detail.studWallOneArea || null;
        this.eeBDEx4.studWallOneUValue = detail.studWallOneUValue || null;
        this.eeBDEx4.studWallTwoArea = detail.studWallTwoArea || null;
        this.eeBDEx4.studWallTwoUValue = detail.studWallTwoUValue || null;
        this.eeBDEx4.gableWallOneArea = detail.gableWallOneArea || null;
        this.eeBDEx4.gableWallOneUValue = detail.gableWallOneUValue || null;
        this.eeBDEx4.gableWallTwoArea = detail.gableWallTwoArea || null;
        this.eeBDEx4.gableWallTwoUValue = detail.gableWallTwoUValue || null;
      });
    });
  }

  openEERRSolarWaterHeatingDetailsModal(details: any): void {
    details.assetId = this.addressId;
    const modalRef = this.modalService.open(EerrSolarWaterHeatingDetailsModalComponent);
    modalRef.componentInstance.details = details;
    modalRef.result.then(() => {});
  }

  openEERRFGHRSDetailsModal(details: any): void {
    const modalRef = this.modalService.open(EerrSolarWaterHeatingDetailsModalComponent);
    modalRef.componentInstance.details = details;
    modalRef.result.then(() => {});
  }

  onSelectTab(index: number): void {
    const mobileBreakpoint = 768;
    if (window.innerWidth <= mobileBreakpoint) {
      this.closeSidebar();
    }
    const currentIndex = this.tabDetails.findIndex((tab) => tab === this.route.snapshot.queryParams['tab']);
    this.clickedTabs[index] = true;
    sessionStorage.setItem('clickedTabs', JSON.stringify(this.clickedTabs));
    this.validateFields();
    const queryParams: Params = { tab: this.tabDetails[index] ?? '' };
    this.location.replaceState(
      this.router.createUrlTree([], {
          relativeTo: this.route,
          queryParams: queryParams,
          queryParamsHandling: 'merge',
        }).toString()
    );
    if (this.route.snapshot.queryParams['tab'] !== queryParams['tab']) {
      const status = this.details.reportStatus;
      if (status !== ReportStatus.Lodged) {
        if (this.route.snapshot.queryParams['edit'] != 'false') {
          this.save(true);
        }
      }
    }
    console.log(queryParams['tab']);
  }

  isTabClicked(index: number): boolean {
    return this.clickedTabs[index];
  }

  setInitialTabAsClicked(): void {
    const currentUrl = this.router.url;
    const tabParam = new URLSearchParams(currentUrl.split('?')[1]).get('tab');
    const initialTabIndex = this.tabDetails.findIndex((tab) => tab === tabParam);
    if (initialTabIndex !== -1) {
      this.clickedTabs[initialTabIndex] = true;
    } else {
      this.clickedTabs[1] = true;
    }
    sessionStorage.setItem('clickedTabs', JSON.stringify(this.clickedTabs));
  }

  private validateFields() {
    if (this.highlightDirectives) {
      this.highlightDirectives.forEach((directive) => {
        directive.ngOnChanges({
          appHighlightRequired: {
            currentValue: directive.appHighlightRequired,
            previousValue: null,
            firstChange: true,
            isFirstChange: () => true,
          },
        });
      });
    }
  }

  setShowRoofRoomToFalseBasedOnRoofConstruction(buildingPart) {
    if (this.disableShowRoofRoom(buildingPart)) {
      this.showRoofRoom[buildingPart] = false;
    }
  }

  disableShowRoofRoom(buildingPart) {
    return (
      this.keyedLookUpCodes && (this[buildingPart].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Flat'] ||
        this[buildingPart].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Another dwelling above'] ||
        this[buildingPart].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Same dwelling above'] ||
        this[buildingPart].roofConstruction === this.keyedLookUpCodes['RoofConstruction']['Pitched, sloping ceiling'])
    );
  }

  disableEditDryLined(buildingPart, variablePrefix) {
    if (this.keyedLookUpCodes && 
      (this[buildingPart].buildingPartAge === 'A' ||
        this[buildingPart].buildingPartAge === 'B' ||
        this[buildingPart].buildingPartAge === 'C' ||
        this[buildingPart].buildingPartAge === 'D' ||
        this[buildingPart].buildingPartAge === 'E') &&
        (this[buildingPart].wallsConstruction === this.keyedLookUpCodes['WallConstruction']['Stone (granite or whinstone)'] ||
          this[buildingPart][`${variablePrefix}Construction`] === this.keyedLookUpCodes['WallConstruction']['Stone (sandstone or limestone)'] ||
          this[buildingPart][`${variablePrefix}Construction`] === this.keyedLookUpCodes['WallConstruction']['Solid Brick'] ||
          this[buildingPart][`${variablePrefix}Construction`] === this.keyedLookUpCodes['WallConstruction']['Cavity']) &&
          this[buildingPart][`${variablePrefix}InsulationType`] == this.keyedLookUpCodes['WallInsulation']['As built']) {
          return false;
    }
    return true;
  }

  setMainWallsDryLinedToFalseForCertainAgeBands(buildingPart) {
    if (this.disableEditDryLined(buildingPart, 'walls'))
      this[buildingPart].wallsDryLined = false;
  }

  setAdditionalWallsDryLinedToFalseForCertainAgeBands(buildingPart) {
    if (this.disableEditDryLined(buildingPart, 'alternativeWall1'))
      this[buildingPart].additionalWallsDryLined = false;
  }

  calculateBuildingPartAdditionalWallArea(buildingPart) {
    if (!this[buildingPart].dimensionsArray ||
      !this[buildingPart].dimensionsArray.length ||
      !this[buildingPart].dimensionsArray[0].height ||
      this[buildingPart].dimensionsArray[0].height < 1 ||
      !this.eeGeneralDetails.unheatedCorridorLength ||
      this.eeGeneralDetails.unheatedCorridorLength <= 0) {
      return null;
    }
    const alternativeWallArea = (this.eeGeneralDetails.unheatedCorridorLength * this[buildingPart].dimensionsArray[0].height);
    return alternativeWallArea < 0 ? null : alternativeWallArea.toFixed(3);
  }

  setRenewablesSWHDefaults() {
    if (this.eeRR.swhConfiguration === 'DetailsKnown') {
      this.eeRR.solarWaterHeaterPitch = this.keyedLookUpCodes['VerticalPitch']['30 degrees'];
      this.eeRR.solarWaterHeatingPresent = true;
      this.eeRR.solarPanelCollectorDatasource = '2';
      this.setRenewablesSWHOrientations();
      this.eeRR.solarWaterHeaterOrientation = this.keyedLookUpCodes['Orientation']['South'];
      this.eeRR.solarWaterHeaterOvershading = this.keyedLookUpCodes['Overshading']['Modest'];
      this.eeRR.solarWaterHeaterShowerTypes = this.keyedLookUpCodes['ShowerType']['Non-electric only'];
      this.eeRR.solarWaterHeaterCirculatingPump = this.keyedLookUpCodes['SolarPump']['PV powered'];
      this.eeRR.solarWaterHeaterCollectorType = this.keyedLookUpCodes['CollectorType']['Flat plate'];
      this.eeRR.solarWaterHeaterAreaOfPanel = Number('3.0');
      this.eeRR.solarWaterHeaterZeroLossEfficiency = parseFloat('0.8');
      this.eeRR.solarWaterHeaterLinearHeatLossCoefficient = parseFloat('4.0');
      this.eeRR.solarWaterHeatersecoundaryHeatLossCoefficient = parseFloat('0.01');
    } else if (this.eeRR.swhConfiguration === 'DetailsUnknown') {
      this.eeRR.solarWaterHeatingPresent = true;
    } else {
      this.eeRR.solarWaterHeatingPresent = false;
      this.resetRenewablesSWHDefaults();
    }
  }

  resetRenewablesSWHDefaults() {
    this.eeRR.solarWaterHeaterPitch = null;
    this.eeRR.solarWaterHeaterOrientation = null;
    this.eeRR.solarWaterHeaterOvershading = null;
    this.eeRR.solarWaterHeaterShowerTypes = null;
    this.eeRR.solarWaterHeaterCirculatingPump = null;
    this.eeRR.solarWaterHeaterCollectorType = null;
    this.eeRR.solarWaterHeaterAreaOfPanel = null;
    this.eeRR.solarWaterHeaterZeroLossEfficiency = null;
    this.eeRR.solarWaterHeaterLinearHeatLossCoefficient = null;
    this.eeRR.solarWaterHeatersecoundaryHeatLossCoefficient = null;
  }

  isGeneralTabValid(): boolean {
    let isValid = !!((
        this.eeGeneralDetails.previousEpcCheckedCode &&
        this.eeGeneralDetails.previousEpcExistsCode &&
        this.eeGeneralDetails.transactionType &&
        this.eeGeneralDetails.tenure &&
        this.eeGeneralDetails.builtForm &&
        this.eeGeneralDetails.terrain &&
        this.eeGeneralDetails.measurements &&
        this.eeGeneralDetails.buildingConfiguration &&
        this.eeGeneralDetails.conservationType &&
        this.eeGeneralDetails.habitableRoomCount &&
        this.eeGeneralDetails.habitableRoomCount > 0 &&
        this.eeGeneralDetails.habitableRoomCount <= 99 &&
        this.eeGeneralDetails.heatedRoomCount >= 0 &&
        this.eeGeneralDetails.totalFixedLightOutlets &&
        this.eeGeneralDetails.totalFixedLightOutlets > 0 &&
        this.eeGeneralDetails.totalFixedLightOutlets <= 999 &&
        this.eeGeneralDetails.totalFixedLELOutlets >= 0
      )
    );
    if (this.eeGeneralDetails.previousEpcExistsCode === 'Y') {
      isValid = isValid && !!this.eeGeneralDetails.previousEpcReasonCode;
    }
    if (this.eeGeneralDetails.conservationType === '4') {
      isValid = isValid && !!(
          this.eeGeneralDetails.conservatoryHeight &&
          this.eeGeneralDetails.glazedPerimiter &&
          this.eeGeneralDetails.glazedPerimiter > 0 &&
          this.eeGeneralDetails.glazedPerimiter <= 999 &&
          this.eeGeneralDetails.floorArea > 0 &&
          this.eeGeneralDetails.floorArea <= 999 &&
          this.eeGeneralDetails.floorArea
        );
    }
    if (this.eeGeneralDetails.propertyType === '2' || this.eeGeneralDetails.propertyType === '3') {
      isValid = isValid && !!(
          this.eeGeneralDetails.flatType &&
          this.eeGeneralDetails.locationInBlock &&
          this.eeGeneralDetails.corridorType);
      if (this.eeGeneralDetails.corridorType === '2') {
        isValid = isValid && !!this.eeGeneralDetails.unheatedCorridorLength;
      }
    }
    return isValid;
  }
  
  isValidBathAndShowerRoomsCount(): boolean {
    const totalRooms = this.eeHeating.bathAndShowerRoomsWithBathAndOrNonMixerShower || 0;
    const mixerShowerRooms = (this.eeHeating.bathAndShowerRoomsWithMixerShowerNoBath || 0) + (this.eeHeating.bathAndShowerRoomsWithMixerShowerAndBath || 0);
    return totalRooms >= mixerShowerRooms;
  }

  isOpeningsTabValid(): boolean {
    const glazingTypeRequiresExtra = this.eeOpeningDetails.glazingType === '7' || this.eeOpeningDetails.glazingType === '8';
    let isValid = !(
      this.eeOpeningDetails.draughtProofing! > 100 ||
      this.eeOpeningDetails.draughtProofing! < 0 ||
      this.eeOpeningDetails.externalDoors == null ||
      this.eeOpeningDetails.externalDoors > 20 ||
      this.eeOpeningDetails.externalDoors < 0 ||
      this.eeOpeningDetails.insulatedExternalDoors == null ||
      this.eeOpeningDetails.insulatedExternalDoors > 20 ||
      this.eeOpeningDetails.insulatedExternalDoors < 0 ||
      this.eeOpeningDetails.openFireplaces == null ||
      this.eeOpeningDetails.openFireplaces > 99 ||
      this.eeOpeningDetails.openFireplaces < 0 ||
      this.eeOpeningDetails.ventilationType == null ||
      this.eeOpeningDetails.ventilationType === '' ||
      this.eeOpeningDetails.coverage == null ||
      this.eeOpeningDetails.coverage === '' ||
      this.eeOpeningDetails.multiGlazing == null ||
      this.eeOpeningDetails.multiGlazing > 100 ||
      this.eeOpeningDetails.multiGlazing < 0
    );
    if (glazingTypeRequiresExtra) {
      return (isValid && !(
          this.eeOpeningDetails.UValue == null ||
          this.eeOpeningDetails.GValue == null ||
          this.eeOpeningDetails.windowTransmissionDataSource == null));
    }
    if (this.eeOpeningDetails.coverage === '1' || this.eeOpeningDetails.coverage === '2' || this.eeOpeningDetails.coverage === '3') {
      isValid = isValid && this.eeOpeningDetails.glazingType != null && this.eeOpeningDetails.glazingType !== '';
    }
    if (this.eeOpeningDetails.upvcFramed){
      isValid = isValid && this.eeOpeningDetails.glazingGap !== ''
    }
    return isValid;
  }

  roofRoomExtendedDataValid(buildingPart: string): boolean {
    const buildingData = this[buildingPart];
    if (!buildingData) return true;
    if (!this.showRoofRoom[buildingPart]) return true;
    const fieldsToCheck = [
      'flatCeilingOneArea',
      'flatCeilingOneUValue',
      'flatCeilingTwoArea',
      'flatCeilingTwoUValue',
      'slopeOneArea',
      'slopeOneUValue',
      'slopeTwoArea',
      'slopeTwoUValue',
      'studWallOneArea',
      'studWallOneUValue',
      'studWallTwoArea',
      'studWallTwoUValue',
      'gableWallOneArea',
      'gableWallOneUValue',
      'gableWallTwoArea',
      'gableWallTwoUValue',
    ];
    const anyFieldHasValue = fieldsToCheck.some((field) => buildingData[field] != null);
    if (!anyFieldHasValue) return true;
    const requiredFields = [
      'flatCeilingOneArea',
      'flatCeilingOneUValue',
      'slopeOneArea',
      'slopeOneUValue',
      'studWallOneArea',
      'studWallOneUValue',
      'gableWallOneArea',
      'gableWallOneUValue',
    ];
    return requiredFields.every((field) => buildingData[field] != null);
  }
  
  isMainBuildingTabValid(): boolean {
    let isValid =
      this.buildingPartDimensionsAreValid('eeBDMainBuilding') &&
      this.roofRoomExtendedDataValid('eeBDMainBuilding') &&
      this.eeBDMainBuilding.buildingPartAge != null &&
      this.eeBDMainBuilding.wallsConstruction != null &&
      this.eeBDMainBuilding.wallsInsulationType != null &&
      this.eeBDMainBuilding.floorHeatLossType != null &&
      this.eeBDMainBuilding.roofConstruction != null &&
      (this.eeBDMainBuilding.floorInsulationType !== '2' || this.eeBDMainBuilding.floorInsulationThickness != null);
    if (this.allPartyWallConstructionsNotApplicableIfNotDetached()) {
      return false;
    }
    if (this.eeBDMainBuilding.roofConstruction !== '3' && this.eeBDMainBuilding.roofConstruction !== '7') {
      isValid = isValid && this.eeBDMainBuilding.roofInsulationType != null;
    }
    if (this.eeBDMainBuilding.roofConstruction !== '3' &&
      this.eeBDMainBuilding.roofConstruction !== '7' &&
      this.eeBDMainBuilding.roofInsulationType !== '4' &&
      this.eeBDMainBuilding.roofInsulationType !== '5') {
      switch (this.eeBDMainBuilding.roofInsulationType) {
        case '1':
          isValid = isValid && this.eeBDMainBuilding.rafterInsulationThickness != null && this.eeBDMainBuilding.rafterInsulationThickness !== '';
          break;
        case '6':
          isValid = isValid && this.eeBDMainBuilding.flatRoofInsulationThickness != null && this.eeBDMainBuilding.flatRoofInsulationThickness !== '';
          break;
        case '7':
          isValid = isValid && this.eeBDMainBuilding.slopingCeilingInsulationThickness != null && this.eeBDMainBuilding.slopingCeilingInsulationThickness !== '';
          break;
        default:
          isValid = isValid && this.eeBDMainBuilding.roofInsulationThickness != null && this.eeBDMainBuilding.roofInsulationThickness !== '';
          break;
      }
    }
    if (!['3', '6', '8'].includes(this.eeBDMainBuilding.floorHeatLossType)) {
      isValid = isValid && this.eeBDMainBuilding.floorConstruction != null && this.eeBDMainBuilding.floorInsulationType != null;
    }
    if (this.eeBDMainBuilding.wallThicknessMeasured === true) {
      isValid = isValid && this.eeBDMainBuilding.wallsWallThickness >= 50 && this.eeBDMainBuilding.wallsWallThickness <= 1500;
    }
    if (this.eeBDMainBuilding.uValueknown === true) {
      isValid = isValid && this.eeBDMainBuilding.wallsUValue > 0 && this.eeBDMainBuilding.wallsUValue < 2.5;
    }
    if (this.eeBDMainBuilding.floorUValueKnown === true) {
      isValid = isValid && this.eeBDMainBuilding.floorUValue != null && this.eeBDMainBuilding.floorUValue > 0.009 && this.eeBDMainBuilding.floorUValue < 2.4;
    }
    if (this.eeBDMainBuilding.roofUValueKnown === true) {
      isValid = isValid && this.eeBDMainBuilding.roofUValue != null && this.eeBDMainBuilding.roofUValue > 0.04 && this.eeBDMainBuilding.roofUValue < 2.4;
    }
    if (this.showAdditionalWall.eeBDMainBuilding === true) {
      let additionalWallValid =
        this.eeBDMainBuilding.additionalWallsConstruction != null &&
        this.eeBDMainBuilding.additionalWallsInsulationType != null &&
        this.eeBDMainBuilding.additionalWallWallArea != null &&
        this.eeBDMainBuilding.additionalWallWallArea < 1000 &&
        this.eeBDMainBuilding.additionalWallWallArea > 0.009;
      if (this.eeBDMainBuilding.additionalWallUValueKnown === true) {
        additionalWallValid = additionalWallValid &&
          this.eeBDMainBuilding.additionalWallsUValue != null &&
          this.eeBDMainBuilding.additionalWallsUValue > 0 &&
          this.eeBDMainBuilding.additionalWallsUValue <= 2.5;
      }
      if (this.eeBDMainBuilding.additionalWallThicknessMeasured === true) {
        additionalWallValid =  additionalWallValid && this.eeBDMainBuilding.additionalWallsWallThickness >= 50;
      }
      if (this.eeBDMainBuilding.additionalWallsInsulationType !== '4' && this.eeBDMainBuilding.additionalWallsInsulationType !== '5') {
        additionalWallValid = additionalWallValid && this.eeBDMainBuilding.additionalWallsInsulationThickness != null;
      }
      isValid = isValid && additionalWallValid;
    }
    if (this.showRoofRoom.eeBDMainBuilding === true) {
      let roofRoomValid =
        this.eeBDMainBuilding.roofRoomsAge != null &&
        this.eeBDMainBuilding.roofRoomsArea != null &&
        this.eeBDMainBuilding.roofRoomsArea <= 999 &&
        this.eeBDMainBuilding.roofRoomsArea >= 1 &&
        this.eeBDMainBuilding.roofRoomsInsulation != null;
      if (this.eeBDMainBuilding.roofRoomsInsulation !== 'AB' && this.eeBDMainBuilding.roofRoomsInsulation !== '0') {
        roofRoomValid = roofRoomValid && this.eeBDMainBuilding.roofRoomsThickness != null;
      }
      isValid = isValid && roofRoomValid;
    }
    isValid = isValid && this.hasAreaForBuildingPart(0);
    const wallInsulationTypeRequiresThickness = [1, 3, 6, 7].includes(Number(this.eeBDMainBuilding.wallsInsulationType));
    const wallThicknessRequired = this.eeBDMainBuilding.wallThicknessMeasured === true;
    if (wallInsulationTypeRequiresThickness || wallThicknessRequired) {
      isValid = isValid && (wallInsulationTypeRequiresThickness ? this.eeBDMainBuilding.wallsInsulationThickness != null : true) && (wallThicknessRequired ? this.eeBDMainBuilding.wallsWallThickness != null : true);
    }
    if (this.eeGeneralDetails.builtForm !== '1') {
      isValid = isValid && this.eeBDMainBuilding.partyWallConstruction != null;
    } 
    if (this.eeOpeningDetails.coverage == '4' || this.eeOpeningDetails.coverage == '5') {
      isValid = isValid && this.eeOpeningDetails.sapWindows?.length > 0;
    }
    return isValid;
  }
  private isExtensionTabValid(extension: 'eeBDEx1' | 'eeBDEx2' | 'eeBDEx3' | 'eeBDEx4'): boolean {
    const extensionNumber = extension.slice(-1) as '1' | '2' | '3' | '4';
    if (!this.showBuildingExtensions[`extension${extensionNumber}`]) {
      return true;
    }
    const ext = this[extension] as any;
    let isValid = this.buildingPartDimensionsAreValid(extension) &&
      ext.buildingPartAge != null &&
      ext.wallsConstruction != null &&
      ext.wallsInsulationType != null &&
      ext.floorHeatLossType != null &&
      ext.roofConstruction != null &&
      (ext.floorInsulationType !== '2' || ext.floorInsulationThickness != null);
    if (this.allPartyWallConstructionsNotApplicableIfNotDetached()) {
      return false;
    }
    if (ext.roofConstruction !== '3' && ext.roofConstruction !== '7') {
      isValid = isValid && ext.roofInsulationType != null;
    }
    if (ext.roofConstruction !== '3' &&
      ext.roofConstruction !== '7' &&
      ext.roofInsulationType !== '4' &&
      ext.roofInsulationType !== '5') {
      switch (ext.roofInsulationType) {
        case '1':
          isValid = isValid && ext.rafterInsulationThickness != null && ext.rafterInsulationThickness !== '';
          break;
        case '6':
          isValid = isValid && ext.flatRoofInsulationThickness != null && ext.flatRoofInsulationThickness !== '';
          break;
        case '7':
          isValid = isValid && ext.slopingCeilingInsulationThickness != null && ext.slopingCeilingInsulationThickness !== '';
          break;
        default:
          isValid = isValid &&  ext.roofInsulationThickness != null && this.eeBDMainBuilding.roofInsulationThickness !== '';
          break;
      }
    }
    if (!['3', '6', '8'].includes(ext.floorHeatLossType)) {
      isValid = isValid && ext.floorConstruction != null && ext.floorInsulationType != null;
    }
    if (ext.wallThicknessMeasured === true) {
      isValid = isValid && ext.wallsWallThickness >= 50;
    }
    if (ext.uValueknown === true) {
      isValid = isValid && ext.wallsUValue > 0 && ext.wallsUValue < 2.5;
    }
    if (ext.floorUValueKnown === true) {
      isValid = isValid && ext.floorUValue != null && ext.floorUValue > 0.009 && ext.floorUValue < 2.4;
    }
    if (ext.roofUValueKnown === true) {
      isValid = isValid && ext.roofUValue != null && ext.roofUValue > 0.04 && ext.roofUValue < 2.4;
    }
    if (this.showAdditionalWall[extension] === true) {
      let additionalWallValid = ext.additionalWallsConstruction != null &&
        ext.additionalWallsInsulationType != null &&
        ext.additionalWallWallArea != null &&
        ext.additionalWallWallArea < 1000 &&
        ext.additionalWallWallArea > 0.009;
      if (ext.additionalWallUValueKnown === true) {
        additionalWallValid = additionalWallValid &&
          ext.additionalWallsUValue != null &&
          ext.additionalWallsUValue > 0 &&
          ext.additionalWallsUValue <= 2.5;
      }
      if (ext.additionalWallThicknessMeasured === true) {
        additionalWallValid = additionalWallValid && ext.additionalWallsWallThickness >= 50;
      }
      if (ext.additionalWallsInsulationType !== '4' && ext.additionalWallsInsulationType !== '5') {
        additionalWallValid = additionalWallValid && ext.additionalWallsInsulationThickness != null;
      }
      isValid = isValid && additionalWallValid;
    }
    if (this.showRoofRoom[extension] === true) {
      let roofRoomValid = ext.roofRoomsAge != null &&
        ext.roofRoomsArea != null &&
        ext.roofRoomsArea <= 999 &&
        ext.roofRoomsArea >= 1 &&
        ext.roofRoomsInsulation != null;
      if (ext.roofRoomsInsulation !== 'AB' && ext.roofRoomsInsulation !== '2') {
        roofRoomValid = roofRoomValid && ext.roofRoomsThickness != null;
      }
      isValid = isValid && roofRoomValid;
    }
    const wallInsulationTypeRequiresThickness = [1, 3, 6, 7].includes(Number(ext.wallsInsulationType));
    const wallThicknessRequired = ext.wallThicknessMeasured === true;
    if (wallInsulationTypeRequiresThickness || wallThicknessRequired) {
      isValid = isValid && (wallInsulationTypeRequiresThickness ? ext.wallsInsulationThickness != null : true) && (wallThicknessRequired ? ext.wallsWallThickness != null : true);
    }
    if (this.eeOpeningDetails.coverage == '4' || this.eeOpeningDetails.coverage == '5') {
      isValid = isValid && this.eeOpeningDetails.sapWindows?.length > 0;
    }
    isValid = isValid && this.hasAreaForBuildingPart(Number(extensionNumber));
    return isValid;
  }
  
  isExtension1TabValid(): boolean {
    return this.isExtensionTabValid('eeBDEx1');
  }
  
  isExtension2TabValid(): boolean {
    return this.isExtensionTabValid('eeBDEx2');
  }
  
  isExtension3TabValid(): boolean {
    return this.isExtensionTabValid('eeBDEx3');
  }
  
  isExtension4TabValid(): boolean {
    return this.isExtensionTabValid('eeBDEx4');
  }
  
  isHeatingTabValid(): boolean {
    let isValid = true;
    isValid = isValid && this.eeHeating.electricMeter != null && this.eeHeating.electricMeter !== '';
    if (this.secondaryHeating) {
      isValid = isValid && !!(this.eeHeating.secoundaryHeatingFuel != null && this.eeHeating.secoundaryHeatingSystem != null);
    }
    if (this.mainSystems === 'None installed') {
      return isValid;
    }
    if (this.mainSystems === '1 Main system') {
      isValid = isValid && !!(this.eeHeating.mainSystem1Fuel != null && this.eeHeating.mainSystem1SystemType != null && this.eeHeating.mainSystem1Controls != null);
      if (this.eeHeating.mainSystem1SystemType !== '1') {
        isValid = isValid && this.eeHeating.mainSystem1System != null && this.eeHeating.mainSystem1SystemSubType != null;
      }
      if (this.eeHeating.mainSystem1FlueType !== undefined) {
        isValid = isValid && this.eeHeating.mainSystem1FlueType != '';
      }
      if (['149', '253', '148'].includes(this.eeHeating.mainSystem1SystemSubType)) {
        isValid = isValid && this.eeHeating.mainSystem1Emitter != null;
      }
      if (['145', '146', '147'].includes(this.eeHeating.mainSystem1SystemSubType)) {
        isValid = isValid && this.eeHeating.mainSystem1Emitter != null && this.eeHeating.mainSystem1PumpAge != null && this.eeHeating.mainSystem1FlowTemp != null;
      }
      if (this.eeHeating.mainSystem1Fuel != '29') {
        isValid = isValid && this.eeHeating.mainSystem1FlueType != '';
      }
      if (this.eeHeating.mainSystem1SystemType === '1' && this.eeHeating.mainSystem1Fuel != '29') {
        isValid = isValid && this.eeHeating.mainSystem1FlueType !== '' && this.eeHeating.mainSystem1FlueType !== null;
      }
    }
    if (this.mainSystems === '2 Main systems' || this.mainSystems === this.MAIN_SYSTEM_AND_DHW_ONLY) {
      isValid = isValid && !!(this.eeHeating.mainSystem1Fuel != null && this.eeHeating.mainSystem1SystemType != null && this.eeHeating.mainSystem1Controls != null);
      if (this.eeHeating.mainSystem1SystemType !== '1') {
        isValid = isValid && this.eeHeating.mainSystem1System != null;
      }
      if (this.eeHeating.mainSystem1FlueType !== undefined) {
        isValid = isValid && this.eeHeating.mainSystem1FlueType != '';
      }
      if (['145', '146', '147'].includes(this.eeHeating.mainSystem2SystemSubType)) {
        isValid = isValid && this.eeHeating.mainSystem2Emitter != null && this.eeHeating.mainSystem2PumpAge != null && this.eeHeating.mainSystem2FlowTemp != null;
      }
      if (['149', '253', '148'].includes(this.eeHeating.mainSystem2SystemSubType)) {
        isValid = isValid && this.eeHeating.mainSystem2Emitter != null;
      }
      isValid = isValid && !!(this.eeHeating.mainSystem2Fuel != null && this.eeHeating.mainSystem2SystemType != null && this.eeHeating.mainSystem2Controls != null);
      if (this.eeHeating.mainSystem2SystemType !== '1') {
        isValid = isValid && this.eeHeating.mainSystem2System != null && this.eeHeating.mainSystem2SystemSubType != null;
      }
      if (this.eeHeating.mainSystem2FlueType !== undefined) {
        isValid = isValid && this.eeHeating.mainSystem2FlueType != null;
      }
      if (this.eeHeating.mainSystem2SystemType === '1' && this.eeHeating.mainSystem2Fuel != '29') {
        isValid = isValid && this.eeHeating.mainSystem2FlueType != '';
      }
    }
    return isValid;
  }

  isWaterHeatingTabValid(): boolean {
    let isValid = !!(
      this.eeHeating.waterHeatingSystem != null &&
      this.eeHeating.bathAndShowerRoomsWithBathAndOrNonMixerShower != null &&
      this.eeHeating.bathAndShowerRoomsWithBathAndOrNonMixerShower >= 0 &&
      this.eeHeating.bathAndShowerRoomsWithBathAndOrNonMixerShower <= 99 &&
      this.eeHeating.bathAndShowerRoomsWithMixerShowerAndBath != null &&
      this.eeHeating.bathAndShowerRoomsWithMixerShowerAndBath >= 0 &&
      this.eeHeating.bathAndShowerRoomsWithMixerShowerAndBath <= 99 &&
      this.eeHeating.bathAndShowerRoomsWithMixerShowerNoBath != null &&
      this.eeHeating.bathAndShowerRoomsWithMixerShowerNoBath >= 0 &&
      this.eeHeating.bathAndShowerRoomsWithMixerShowerNoBath <= 99
    );
    const allBathAndShowerRooms = (this.eeHeating.bathAndShowerRoomsWithMixerShowerNoBath || 0) + (this.eeHeating.bathAndShowerRoomsWithMixerShowerAndBath || 0);
    isValid = isValid && (this.eeHeating.bathAndShowerRoomsWithBathAndOrNonMixerShower || 0) >= allBathAndShowerRooms;
    if (this.eeHeating.cylinderDetailsSize !== '1' && this.eeHeating.cylinderDetailsSize !== '0') {
      isValid = isValid && !!(this.eeHeating.cylinderDetailsSize != null && this.eeHeating.cylinderDetailsInsulation != null);
    }
    if (this.eeHeating.waterHeatingSystem === '903') {
      isValid = isValid && this.eeHeating.cylinderDetailsImmersion != null;
    }
    return isValid;
  }

  isRenewablesTabValid(): boolean {
    let isValid = !!(this.eeRR.pvConfiguration && (this.eeRR.pvConfiguration !== 'roofCoverageOnly' || (this.eeRR.pvConfiguration === 'roofCoverageOnly' && this.eeRR.percentageOfRoofCovered != null)));
    if (this.eeRR.pvConfiguration === 'OnePVArray' || this.eeRR.pvConfiguration === 'TwoPVArrays' || this.eeRR.pvConfiguration === 'ThreePVArrays') {
      isValid = isValid && !!(this.eeRR.array1Pitch &&
          this.eeRR.array1Orientation &&
          this.eeRR.array1Overshading &&
          this.eeRR.array1KWP != null &&
          this.eeRR.array1KWP > 0.1 &&
          this.eeRR.array1KWP < 16);
    }
    if (this.eeRR.pvConfiguration === 'TwoPVArrays' || this.eeRR.pvConfiguration === 'ThreePVArrays') {
      isValid = isValid && !!(this.eeRR.array2Pitch &&
          this.eeRR.array2Orientation &&
          this.eeRR.array2Overshading &&
          this.eeRR.array2KWP != null &&
          this.eeRR.array2KWP > 0.1 &&
          this.eeRR.array2KWP < 16);
    }
    if (this.eeRR.pvConfiguration === 'ThreePVArrays') {
      isValid = isValid && !!(this.eeRR.array3Pitch &&
          this.eeRR.array3Orientation &&
          this.eeRR.array3Overshading &&
          this.eeRR.array3KWP != null &&
          this.eeRR.array3KWP > 0.1 &&
          this.eeRR.array3KWP < 16);
    }
    if (this.eeRR.swhConfiguration === 'DetailsKnown') {
      if (this.eeRR.solarWaterHeaterStoreVolumeDetailsKnown) {
        isValid = isValid && this.eeRR.solarWaterHeaterTotalCylenderVolume != null &&
          this.eeRR.solarWaterHeaterTotalCylenderVolume >= 0.01 &&
          this.eeRR.solarWaterHeaterTotalCylenderVolume <= 500;
      }
    }
    if (this.eeRR.swhConfiguration === 'DetailsKnown') {
      isValid = isValid && !!(this.eeRR.solarWaterHeaterAreaOfPanel != null &&
          this.eeRR.solarWaterHeaterAreaOfPanel > 0.4 &&
          this.eeRR.solarWaterHeaterAreaOfPanel < 11.0);
    }
    if (this.eeRR.swhConfiguration === 'DetailsKnown') {
      isValid = isValid && !!(this.eeRR.solarWaterHeaterZeroLossEfficiency != null &&
          this.eeRR.solarWaterHeaterZeroLossEfficiency >= 30 &&
          this.eeRR.solarWaterHeaterZeroLossEfficiency <= 90);
    }
    if (this.eeRR.swhConfiguration === 'DetailsKnown') {
      isValid = isValid && !!(this.eeRR.solarWaterHeaterLinearHeatLossCoefficient != null &&
          this.eeRR.solarWaterHeaterLinearHeatLossCoefficient > 0.4 &&
          this.eeRR.solarWaterHeaterLinearHeatLossCoefficient < 21.0 );
    }
    if (this.eeRR.swhConfiguration === 'DetailsKnown') {
      isValid = isValid && !!(this.eeRR.solarWaterHeatersecoundaryHeatLossCoefficient != null &&
          this.eeRR.solarWaterHeatersecoundaryHeatLossCoefficient >= 0 &&
          this.eeRR.solarWaterHeatersecoundaryHeatLossCoefficient <= 0.1);
    }
    if (this.eeRR.swhConfiguration === 'DetailsKnown') {
      if (this.eeRR.solarWaterHeaterStoreVolumeDetailsKnown) {
        isValid = isValid && this.eeRR.solarWaterHeaterDedicatedSolarVolume != null &&
          this.eeRR.solarWaterHeaterDedicatedSolarVolume >= 0 &&
          this.eeRR.solarWaterHeaterDedicatedSolarVolume <= 500;
      }
    }
    if (this.windTurbinesDetailsKnown) {
      isValid = isValid && !!(this.eeRR.rotorDiameter != null &&
          this.eeRR.rotorDiameter >= 1.0 &&
          this.eeRR.rotorDiameter <= 5.0 &&
          this.eeRR.hubHeight != null &&
          this.eeRR.hubHeight >= 1.0 &&
          this.eeRR.hubHeight <= 12.0 );
    }
    return isValid;
  }

  isRecoveryTabValid() {
    return !!((this.wasteWaterHeatRecovery && this.eeRR.fghrHeatingSystem1ID));
  }

  canCalculate() {
    return (
      this.isGeneralTabValid() &&
      this.isOpeningsTabValid() &&
      this.isMainBuildingTabValid() &&
      this.isExtension1TabValid() &&
      this.isExtension2TabValid() &&
      this.isExtension3TabValid() &&
      this.isExtension4TabValid() &&
      this.isHeatingTabValid() &&
      this.isWaterHeatingTabValid() &&
      this.isRenewablesTabValid() &&
      this.isRecoveryTabValid()
    );
  }

  validForAllBuildingParts() {
    return (!this.allPartyWallConstructionsNotApplicableIfNotDetached() && this.shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor());
  }

  allPartyWallConstructionsNotApplicableIfNotDetached() {
    if (this.eeGeneralDetails &&  this.keyedLookUpCodes && this.eeGeneralDetails.builtForm !== this.keyedLookUpCodes['BuiltForm']['Detached'] &&
      this.eeBDMainBuilding?.partyWallConstruction === this.keyedLookUpCodes['PartyWallConstruction']['Not applicable']) {
      if (this.showBuildingExtensions.extension1 && this.eeBDEx1.partyWallConstruction !== this.keyedLookUpCodes['PartyWallConstruction']['Not applicable']) {
        return false;
      }
      if (this.showBuildingExtensions.extension2 && this.eeBDEx2.partyWallConstruction !== this.keyedLookUpCodes['PartyWallConstruction']['Not applicable']) {
        return false;
      }
      if (this.showBuildingExtensions.extension3 && this.eeBDEx3.partyWallConstruction !== this.keyedLookUpCodes['PartyWallConstruction']['Not applicable']) {
        return false;
      }
      if (this.showBuildingExtensions.extension4 && this.eeBDEx4.partyWallConstruction !== this.keyedLookUpCodes['PartyWallConstruction']['Not applicable']) {
        return false;
      }
      return true;
    }
    return false;
  }

  shelteredWallTrueExactlyOnceIfFlatOrMaisonetteAndUnheatedCorridor() {
    if (this.eeGeneralDetails &&
      this.keyedLookUpCodes &&
      (this.eeGeneralDetails.propertyType === this.keyedLookUpCodes['PropertyType']['Flat'] ||
        this.eeGeneralDetails.propertyType === this.keyedLookUpCodes['PropertyType']['Maisonette']) &&
        this.eeGeneralDetails.corridorType === this.keyedLookUpCodes['HeatlossCorridor']['Unheated']) {
          let countShelteredWalls = 0;
          let countShelteredWalls2 = 0;
          if (this.eeBDMainBuilding?.shelteredWall) countShelteredWalls++;
          if (this.eeBDEx1.shelteredWall) countShelteredWalls++;
          if (this.eeBDEx2.shelteredWall) countShelteredWalls++;
          if (this.eeBDEx3.shelteredWall) countShelteredWalls++;
          if (this.eeBDEx4.shelteredWall) countShelteredWalls++;
          if (this.eeBDMainBuilding?.shelteredWall2) countShelteredWalls2++;
          if (this.eeBDEx1.shelteredWall2) countShelteredWalls2++;
          if (this.eeBDEx2.shelteredWall2) countShelteredWalls2++;
          if (this.eeBDEx3.shelteredWall2) countShelteredWalls2++;
          if (this.eeBDEx4.shelteredWall2) countShelteredWalls2++;
          if (countShelteredWalls === 1) return true;
          if (countShelteredWalls2 === 1) return true;
          else return false;
      }
    return true;
  }

  atLeast1BuildingPartHasAnAdditionalWall() {
    return (
      this.showAdditionalWall.eeBDMainBuilding ||
      this.showAdditionalWall.eeBDEx1 ||
      this.showAdditionalWall.eeBDEx2 ||
      this.showAdditionalWall.eeBDEx3 ||
      this.showAdditionalWall.eeBDEx4
    );
  }

  buildingPartDimensionsAreValid(buildingPart) {
    if (!this[buildingPart]?.dimensionsArray || !this[buildingPart]?.dimensionsArray?.length) {
      return false;
    }
    const partyWallNA = this[buildingPart].partyWallConstruction === this.keyedLookUpCodes['PartyWallConstruction']['Not applicable'];
    
    return this[buildingPart].dimensionsArray.every(function (dimension) {
      if (
        dimension.area === null ||
        dimension.area === undefined ||
        dimension.area < 1 ||
        dimension.area > 999 ||
        dimension.height === null ||
        dimension.height === undefined ||
        dimension.height < 1 ||
        dimension.height > 9 ||
        dimension.perimeter === null ||
        dimension.perimeter === undefined ||
        dimension.perimeter < 1 ||
        dimension.perimeter > 999
      ) {
        return false;
      }
      
      if (!partyWallNA) {
        if (
          dimension.partyWall === null ||
          dimension.partyWall === undefined ||
          dimension.partyWall < 0 ||
          dimension.partyWall > 999
        ) {
          return false;
        }
      } else if (dimension.partyWall !== 0) {
        return false;
      }
      
      return true;
    });
  }
  
  isMeasuredWindowsValid(): boolean {
    return this.eeOpeningDetails.sapWindows?.length > 0;
  }
  
  hasWindowsForBuildingPart(extensionNumber: number): boolean {
    return this.eeOpeningDetails.sapWindows?.some((window) => Number(window.windowLocation) === extensionNumber);
  }

  hasAreaForBuildingPart(extensionNumber: number): boolean {
    if (!this.eeOpeningDetails || !this.eeOpeningDetails.sapWindows) {
      return true;
    }
    const windowsForLocation = this.eeOpeningDetails.sapWindows.filter((window) => Number(window.windowLocation) === extensionNumber);
    if (!windowsForLocation || windowsForLocation.length === 0) {
      return true;
    }
    return windowsForLocation.every((window) => window.windowArea && window.windowArea.value && Number(window.windowArea.value) > 0);
  }

  previousEPCCheckChange() {
    if (this.eeGeneralDetails.previousEpcExistsCode !== 'Y') {
      this.eeGeneralDetails.previousEpcReasonCode = null;
      this.forInformationOnly = '';
    }
  }

  previousEPCReasonChange(value) {
    const lookupcodes = this.filterLookupCodes('ForInformationOnly');
    forEach(lookupcodes, (element) => {
      if (element.lookupValue === value) {
        this.forInformationOnly = element.lookUpItem;
      }
    });
  }

  setAddendum(event) {
    this.eeGeneralDetails.addendum = event;
  }

  getAddendum(addendum) {
    return addendum;
  }

  setDeselectedItems(event) {
    this.eeGeneralDetails.deselectedImprovementMeasures = event;
  }

  changePartyWallConstructionIfAllZero(buildingPart: string): boolean {
    const buildingData = this[buildingPart];
    if (!buildingData?.dimensionsArray || !buildingData.dimensionsArray.length) {
      return false;
    }
    if (this.isDetached()) {
      buildingData.dimensionsArray.forEach((dimension) => {
        dimension.partyWall = 0;
      });
      buildingData.partyWallConstruction = this.keyedLookUpCodes['PartyWallConstruction']['Not applicable'];
      return true;
    }
    const allPartyWallsZero = buildingData.dimensionsArray.every((dimension) => dimension.partyWall === 0);
    if (allPartyWallsZero) {
      buildingData.partyWallConstruction = this.keyedLookUpCodes['PartyWallConstruction']['Not applicable'];
    }
    return buildingData.dimensionsArray.every((dimension) => dimension.partyWall === 0);
  }

  isDetached(): boolean {
    return (this.eeGeneralDetails?.builtForm === this.keyedLookUpCodes['BuiltForm']['Detached']);
  }
}